/*
 * Welcome to the stats views library. This is a collection of functions that
 * are used across the stats views. Could use a bit of clean-up (understatement).
 *
 * Refactoring Spreadsheet, helpful to see various functions:
 *	 https://docs.google.com/spreadsheets/d/1r3O4Xuv3zhv_iDJKxXMdZCwzwt8zf68TQT6N1EgrFCU/edit#gid=1686320176
 * Some helpful areas to refactor:
 *   URL Generation: "DOCKET_SEARCH_URL, ...get_load_more_url
 *   Rendering functions
 *   Rendering utility functions
 * 	 typical_analytics_filters and other filters
 *   Sidebar
 */
/* stats.js is currently still globally imported:
import {
	agg_to_dict,
	args_obj_to_args_ar,
	deparam_url,
	filter_and_combine_subbuckets,

	get_filter_obj,
	get_json_results,
	get_query_str,

	viewarg_to_obj,
	get_viewargs_obj,
	param_query,
	update_dict,
	val_to_key,

	_hash_to_obj
} from "./stats.js";
*/

// Globals are not good, but put them into a single namespace.
var stats_views_globals = {
	template_filters : template_filters,
	render_analytics : template_render_analytics,
	render_analytics_sequence : render_analytics_sequence,
	parser_start_year : "2015",
	// Previously was fa-eye.
	view_only_icon : "fa-duotone fa-circle-up-right",
	user_logged_in : user_logged_in,
	party_roles : party_roles,
	state_names : state_names,
};
// Very simple test, this should eventually be it's own function.
var re_stats_outcome = /^granted|denied|sustained|dismissed|affirmed|reversed/;


/**
 * Correct small edit distance issues with keys in the buckets. This should
 * ideally be done in the backend, but this can help save embarrasing results.
 * @param buckets The items we need to review and merge.
 * @param edits Number of edits to consider two items the same. Default is 3.
 */
function correct_edit_distance_subbuckets(buckets, edits) {
	if(!edits) {
		edits = 3;
	}
	function edit_distance(a, b){
		if(a.length == 0) return b.length;
		if(b.length == 0) return a.length;
		// increment along the first column of each row
		var matrix = [];
		for(var i = 0; i <= b.length; i++){
			matrix[i] = [i];
		}
		// increment each column in the first row
		for(var j = 0; j <= a.length; j++){
			matrix[0][j] = j;
		}
		// Fill in the rest of the matrix
		for(i = 1; i <= b.length; i++){
			for(j = 1; j <= a.length; j++){
			  if(b.charAt(i-1) == a.charAt(j-1)){
				matrix[i][j] = matrix[i-1][j-1];
			  } else {
				matrix[i][j] = Math.min(matrix[i-1][j-1] + 1, // substitution
										Math.min(matrix[i][j-1] + 1, // insertion
												 matrix[i-1][j] + 1)); // deletion
			  }
			}
		}
		return matrix[b.length][a.length];
	}

	var to_rem = [];
	buckets.forEach(function (b1, b1_i) {
		buckets.forEach(function (b2, b2_i) {
			if(b1_i >= b2_i) {
				return;
			}
			var d = edit_distance(b1.key, b2.key);
			if(d > edits || b1.doc_count == b2.doc_count) {
				return;
			}
			to_rem.push(b2_i);
			b1.doc_count += b2.doc_count;
			for (var k in b2) {
				if(k != 'key' && k != 'doc_count') {
					console.warn("Not copying aggregation: " + k);
				}
			}
		});
	});
	to_rem.sort().reverse().forEach(function (i) {
		delete buckets[i];
	});
	return buckets;
}


///////////////////////////
// Views Specific Data Manipulation Utilities

function sortByKey(array, get_key, reverse) {
	if(!get_key) {
		console.log("Cannot sort array, no key.")
		return array;
	}
	return !reverse ?
		array.sort(function(a, b) {
			var x = get_key(a);
			var y = get_key(b);
			return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		}):
		array.sort(function(a, b) {
			var x = get_key(a);
			var y = get_key(b);
			return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		})
}

/**
 * Get the current date, subtracting the given number of months.
 * @param months How many months to subtract.
 * @param first_of_month If true, return the first of the month. If false, 3 months prior.
 * @param start_date If null, use current date.
 * @returns {Date}
 */
function get_months_prev(months, first_of_month, start_date) {
    if(!months) {
        months = 3;
    }
    var monthsbefore = start_date || new Date();
	monthsbefore.setUTCMilliseconds(0);
	monthsbefore.setUTCSeconds(0);
	monthsbefore.setUTCMinutes(0);
	monthsbefore.setUTCHours(0);
	monthsbefore.setUTCMonth(monthsbefore.getUTCMonth() - months);
	if(first_of_month) {
		monthsbefore.setUTCDate(1);
	}
	return monthsbefore;
}
function get_totals_and_before(agg) {
	// Three months before
	var monthsbefore = get_months_prev(3, true);
	// Get Seconds
	var monthsbeforeS = monthsbefore.getTime();

	// Go through the data, and get the average
	var total = 0, totalbefore = 0;
	for (var i in agg.buckets) {
		var doc_count = agg.buckets[i].doc_count;
		total += doc_count;
		// Get the rolling average
		if(agg.buckets[i].key >= monthsbeforeS)
			totalbefore += 	doc_count
	}
	return {
		monthsbefore 	: monthsbefore,
		total			: total,
		totalbefore		: totalbefore,
	}
}

function get_granted_total(buckets, partial_counts) {
	var total = 0;
	for(var i = 0; i < buckets.length; i++) {
		if(granted_keys.indexOf(buckets[i].key) >= 0 ||
			(partial_counts && granted_test(buckets[i].key))) {
			total += buckets[i].doc_count;
		}
	}
	return total;
}

function get_denied_total(buckets, partial_counts) {
	var total = 0;
	for(var i = 0; i < buckets.length; i++) {
		if(denied_keys.indexOf([i].key) >= 0 ||
			(partial_counts && denied_test(buckets[i].key))) {
			total += buckets[i].doc_count;
		}
	}
	return total;
}

/**
 * One function that returns all of the necessary information above
 */
function get_grant_rates(ag, partial_counts) {
	if(!ag || !ag.doc_count) {
		return {total:0, granted:0, granted_rate:0}
	}
	var granted = get_granted_total(ag.buckets, partial_counts);
	return {
		total: ag.doc_count,
		granted: granted,
		granted_rate: granted / ag.doc_count
	}
}

/**
 * Determine if an aggregation uses an existence statistic or a granted/denied
 * stat. If it uses an existence stat, return the rate that it exists, and the
 * total in a structure, otherwise return false.
 *
 * Existence stats are used to show the percent of times an event occurs,
 * whereas a granted/denied stat shows how often a stat is granted.
 **/
function uses_existance_rates(ag, total_docs) {
    if (!ag) {
        return 0;
    }
    if (ag.count) {
        // If we have a specific count aggregation, use it.
        var count = typeof ag.count == 'number' ? ag.count:
			ag.count.value || ag.count.doc_count || 0;
        return {
        	count : count,
            rate: count / total_docs,
            exists: !!count,
        };
    }
    if (!total_docs || !ag.doc_count) {
        // If there is no real data, then return 1, defaulting to grant/deny.
        return 0;
    }
    // If the aggregation has buckets, we can create a rate.
    if (ag.buckets && ag.buckets.length == 1 && ag.buckets[0].key === "") {
        // This is a exist/not exist analysis.
        return {
            rate: ag.buckets[0].doc_count / total_docs,
            exists: ag.buckets[0].doc_count,
        };
    }
    return false;
}

// Given a set of search parameters, return a link to searh results as well.
function DOCKET_SEARCH_URL(params) {
	// When we have a link filter provided, use it. Add the filter.
	if(!params.f) {
		params.f = []
	} else if(!Array.isArray(params.f)) {
		params.f = [params.f];
	}
	if(params.v) { delete params.v; }
	if(params.viewargs) {
		// Convert viewargs into filters.
		var varg = {};
		var pvarg = typeof params.viewargs == "string" ?
			[params.viewargs] : params.viewargs;
		pvarg.forEach(function (va) {
			var k = va.split("-", 1)[0];
			varg[k] = va.slice(k.length + 1);
		});
		// Limit by party type and entity information.
		if(varg.party_exact && varg.party_type_exact) {
			params.f.push('q_analytics_party_type-party:(name_exact:"' +
				varg.party_exact + '" type_exact:"' +
				varg.party_type_exact + '")');
			params.fname_q_analytics_party_type = 'Party ' +
				varg.party_exact + " as " +  varg.party_type_exact;
		}
		if(varg.firm_exact && varg.party_type_exact) {
			params.f.push('q_analytics_firm_type-party:(firm:(name_exact:"' +
				varg.firm_exact + '") type_exact:"' +
				varg.party_type_exact + '")');
			params.fname_q_analytics_firm_type = 'Firm ' +
				varg.firm_exact + " representing " + varg.party_type_exact;
		}
		if(varg.attorney_exact && varg.party_type_exact) {
			params.f.push('q_analytics_attorney_type-party:(firm:(attorney_exact:"' +
				varg.attorney_exact + '") type_exact:"' +
				varg.party_type_exact + '")');
			params.fname_q_analytics_attorney_type = 'Attorney ' +
				varg.attorney_exact + " representing " + varg.party_type_exact;
		}
		delete params.viewargs;
	}
	if(!params.q) {
	    params.q = "";
	}
	return template_link_filter(params);
}
function DOCUMENT_SEARCH_URL(params) {
	return DOCKET_SEARCH_URL(params).replace("/dockets/", "/documents/");
}

/**
 * Help format a query into its parts, to ultimately make it human readable.
 * @param params   (Optional) An object with key-value pairs of the encoded URL
 *              query. If blank, uses the query on the current page.
 * @returns {Array}
 */
function query_to_list(params) {
	if(!params) {
		params = deparam_url();
	}
	var page_title_f = null;
	if(params.v && params.v.endsWith("_profile")) {
		// On some views (e.g., profiles), certain filters aren't really filters
		// but  are part of the real title.
		page_title_f = params.v.slice(0, -8)
	}

	function default_format_value(k, key_title, v, is_title) {
		// Format the value.
		v = v.startsWith(key_title) ? v.slice(key_title.length) : v;
		return (is_title ? "" : key_title.strip() + " ") + v.strip();
	}
	function patent_format_value(k, key_title, v, is_title) {
		// Start with the default value.
		v = default_format_value(k, key_title, v, is_title);
		// Special case for patent numbers.
		if(key_title == "Patent" || key_title == "patent" || k == 'q_patent') {
			// Format design and reissue patent numbers nicely.
			v = v.replace(/^(D|RE)(\d+)(\d\d\d)$/ig, "$1$2,$3");
			// Handle standard number-only patent numbers.
			if(v.search(/^\d+$/ig) == 0) {
				v = number_with_commas(v);
			}
			v = "U.S. Patent No. " + v;
		}
		return v;
	}
	// Date keys are formatted differently.
	var re_date_key = /^date_(.*)$/ig
	function query_key_to_title(k) {
		// Hacky. Come up with a reasonable name for this filter.
		k = k.endsWith("_exact") ? k.slice(0, -6) : k;
		if (k.startsWith("q_")) {
			k = k.slice(2);
		}
		// Remove _obj, and .name, they don't help the name.
		k = k.replaceAll("_obj", "").replaceAll(".name", "");
		// Shorten party.firm down to firm
		k = k.replaceAll("party.firm", "firm");
		// Move remove to the front.
		if (k.endsWith("_remove")) {
			k = "Remove " + k.slice(0, -("_remove".length));
		}
		// Special case for date filters.
		var m_date_key = re_date_key.exec(k);
		if(m_date_key) {
			// Move the "date" to the end of the key.
			k = m_date_key[1] + " Date";
		}
		k = k.replaceAll("_", " ");
		k = capitalize(k);
		return k;
	}
	var _identifier_dict = null;
	function identifier_dict() {
		if(!_identifier_dict) {
			var list = _get_viewargs_identifiers(_hash_to_obj(params.viewargs)).identifier_list;
			_identifier_dict = list ? parser_stats_utils.get_identifier_dict(list) : null;
		}
		return _identifier_dict || {};
	}
	/**
	 * Convert a single filter into a nicely formatted name.
	 * @param f A string filter in the form "filter_key-filter_value"
	 * @returns {null|{name: *, remove_link: *, title: boolean}}
	 */
	function get_filter_name(f) {
	    var f_orig = f;
		// Get the first hyphen spit up.
		f = f.split("-");
		if (f.length < 2) {
			console.log("Bad filter: " + f);
			return {name : "filter" };
		}
		// We don't care about hyphens after the first.
		f = [f[0], f.slice(1).join("-")];
		var f_key = f[0];
		if(f_key == 'event_identifier') {
			if(params.views == 'Event_Info_Counts' ||
				params.views == 'Event_Histogram' ||
				params.views == 'Event_Length_Histogram') {
				// Don't need to display the identifier on these views, it's shown elsewhere.
				return null;
			}
			var pinfo = identifier_dict()[f[1]];
			return {
				name : pinfo ? pinfo.name_display : f[1],
				title :  false,
				is_identifier : true,
			}
		}

		// Determine the removal link, the link to this page w/o the filter.
		var new_params = $.extend({}, params);
		if(typeof new_params.f == "string") {
		    new_params.f = [new_params.f]
        }
		var found = false;
		// Get down the list of filters.
		new_params.f = (new_params.f || []).filter(function (f_exist) {
            if(f_orig == f_exist) {
                found = true;
                return false;
            }
		    return true;
        });
		var remove_link = found ? $.param(new_params, true) : null;

		// Check if there is a
		var key_no_exact = f_key.endsWith("_exact") ? f_key.slice(0, -6) : f_key;
		// The fname parameter can contain the name of the filter.
		var filter_name = params['fname_' + f_key] || params['fname_' + key_no_exact];
		if(filter_name) {
            // Hack: Deam this to be a title if we're searching a entity type.
            var fname_is_title = /^q_(entity|party|attorney|firm|judge)/.test(key_no_exact);
			return {name : filter_name, title : fname_is_title, remove_link:remove_link };
		}

		var key_title = query_key_to_title(f_key);
		// Determine if this is a title.
		var is_title = page_title_f && (key_title.toLowerCase() == page_title_f.toLowerCase());
		// We may want to treat entity filters a bit differently.
		var is_entity = /^(party|attorney|firm|judge)(_exact)?$/.test(f_key);
		// Allow the view info to specify the facet that generates the title.
		if(params.v && gbl_view_infos[params.v] && gbl_view_infos[params.v].title_facets &&
			gbl_view_infos[params.v].title_facets.indexOf(key_title) >= 0) {
			is_title = true;
		}
		var value = f[1];
		var formatter = key_title.search(/^patent$/ig) >= 0 ? patent_format_value:
			default_format_value;
		var name = formatter(f_key, key_title, value, is_title);
		return {
			name : name,
			title :  is_title,
            remove_link:remove_link,
			is_entity : is_entity
		}
	}
	// Some (most?) view arguments should not be displayed b/c there are other UI indicator.
	var skip_viewarg = /^date_histogram_type-|unknown_outcomes-|max_[a-z]+-|gender-|interval_days-|include_percentiles-|length_histogram_type-/;
	var removable_args = /^date_identifier_start-|party_type(_exact)?-/
	function get_viewargs_name(viewarg) {
		if(skip_viewarg.test(viewarg)) {
			return null;
		}

		// A view argument is not the same as a filter, but the function above
		// basically does what we need it to.
		var out = get_filter_name(viewarg);
		// Special case certain viewargs.
		if(out && (out.remove_link || removable_args.test(viewarg))) {
			var v_split = viewarg.split("-", 2)
			var cur_hash = get_url_hash();
			var frag_obj = url_params_to_object(cur_hash);
			var viewargs = get_viewargs_obj(cur_hash);
			if(v_split.length > 1 && viewargs[v_split[0]] == v_split[1]) {
				delete viewargs[v_split[0]];
				frag_obj.viewargs = args_obj_to_args_ar(viewargs);
				var new_hash = $.param(frag_obj, true);
				if (window.location.hash != new_hash) {
					out.remove_link = new_hash;
				}
			}
		}
		return out;
	}
	var filters = [];
	// Start building the list of filters.
	if (Array.isArray(params.f)) {
		filters = params.f.map(get_filter_name);
	} else if (params.f && params.f.length) {
		filters.push(get_filter_name(params.f));
	}
	// Remove empties.
	filters = filters.filter(function (x) { return x != null; });

	// Add the query as a filter, if a name for it wasn't specified.
	if(params.q && params.q.length) {
		if(params.qname) {
			// A title was explicitly specified, honor it.
			filters.push({
				name : params.qname,
				title : true
			});
		} else {
			// No name for it specified, be a bit generic.
			filters.push({
				name : "query: " + jQuery.bbq.getState("q"),
				title : false
			});
		}
	}
	// Add a message about the time range.
	function to_time(date_filed) {
		// All of our time is in UTC, so adjust accordingly.
	    var tdate = new Date(date_filed*1000);
	    return new Date(date_filed*1000 + tdate.getTimezoneOffset()*60*1000);
    }
	// Each attribute is optional, so handle all cases.
	if(params.date_filed_start && params.date_filed_end) {
		var tlo = to_time(params.date_filed_start);
		var thi = to_time(params.date_filed_end);
		filters.push({title: false, name : "Cases from " +
			$.datepicker.formatDate(tlo.getFullYear() == thi.getFullYear() ?
				'M d' : 'M d, yy', tlo) + " to " +
			$.datepicker.formatDate('M d, yy', thi)});
	} else if (params.date_filed_start) {
	    var tlo_alone = to_time(params.date_filed_start);
	    filters.push({title: false, name : "Cases from " +
			$.datepicker.formatDate('M d, yy', tlo_alone)});
    } else if (params.date_filed_end) {
	    var thi_alone = to_time(params.date_filed_end);
	    filters.push({title: false, name : "Cases to " +
			$.datepicker.formatDate('M d, yy', thi_alone)});
    }

	// Add the view arguments, but they only apply to specific views.
	var viewargs = Array.isArray(params.viewargs) ? params.viewargs:
		params.viewargs && params.viewargs.length ? [params.viewargs]: [];
	viewargs.forEach(function (va) {
		var arr = viewarg_to_obj(va);
		if(!arr || !arr.v || !arr.v.length) {
			return;
		}
		// Add the view arg.
		var fname = get_viewargs_name(va);
		if(!fname) {
            return;
        }
		// Don't add the view arg if it already exists in another filter.
        var has_similar = filters.some(function (o) {
            return o.title == fname.title && o.name.indexOf(arr.v) >= 0;
        });
		if(has_similar) {
			return;
		}
        filters.push(fname);
	});

	// Separate filters and titles.
	var titles = filters.filter(function (f) { return f.title; });
	filters = filters.filter(function (f) { return !f.title; });
	// There should only be one title
	if(titles.length > 1) {
		console.log("Too many titles: " + titles);
		// Turn the title into a filter.
		filters = filters.concat(titles.slice(1));
	}
	return {
		title : titles.length ? titles[0] : null,
		filters : filters
	};
}

/**
 * Get the URL to filtered analytics.
 * @param filter_key What to filter on.
 * @param filter_val The filter value
 * @param view The v to use.
 * @param viewargs Any additional viewarguments.
 * @returns {string}
 */
function get_filtered_view_url(filter_key, filter_val, view, viewargs) {
	var cur = deparam_url();
	if(!cur.f) {
		cur.f = [];
	} else if (!Array.isArray(cur.f)) {
		cur.f = [cur.f];
	}

	// Add filters.
	var f = filter_key + "-" + filter_val;
	if (cur.f.indexOf(f) == -1) {
		cur.f.push(f);
	}

	// Add the view arguments, which should be an array.
	if(viewargs) {
		if(!Array.isArray(viewargs)) {
			throw "viewargs should be an array";
		}
		cur.viewargs = Array.isArray(cur.viewargs) ? cur.viewargs:
			cur.viewargs && cur.viewargs.length ? [cur.viewargs]: [];
		cur.viewargs = cur.viewargs.concat(viewargs)
	}
	cur.v = view;
	return param_query(cur);
}

/**
 * Returns a link that loads more data. Only relevant for the list of parties.
 */
function get_load_more_url(cur_buckets) {
	var url_hash = get_url_hash();
	var viewargs = get_viewargs_obj(url_hash);
	// Get the current viewargs
	var max_entities = parseInt(viewargs.max_entities);
	cur_buckets = parseInt(cur_buckets);
	// Get the new max_entities
	if(isNaN(max_entities)) {
		// The max entities field is not set. The default is set on the server,
		// which we don't know. Assume it's a multiple of ten, so if we have a
		// non-multiple of ten, then we hit the max.
		if(!isNaN(cur_buckets) && cur_buckets % 10 != 0) {
			return null;
		}
		// Default to 50
		viewargs.max_entities = 50;
	} else if (!isNaN(cur_buckets) && cur_buckets < max_entities) {
		// max_entities is set higher than the number of bcukets that we have.
		// Don't show the load more.
		return null;
	} else if(max_entities < 100) {
		// First load more should be 100.
		viewargs.max_entities = 100;
	} else if(max_entities < 250) {
		// Then 1000.
		viewargs.max_entities = 250;
	} else {
		// Double max_entities after that.
		viewargs.max_entities = max_entities * 2;
	}

	// Setup the current viewargs
	var cur = deparam_url(url_hash);
	cur.viewargs = args_obj_to_args_ar(viewargs);

	return "#" + param_query(cur);
}

/**
 * Display a percentage in better terms. If it's > 0 but really small, we
 * display "< 1%".
 * @param percent   0 to 1 percent
 * @param first_choice Text after percent.
 * @param br		Add a break between the key and the percentage.
 **/
function get_perc_text(percent, first_choice, zero_choice, br) {
	br = br ? "<br>" : " ";
	if (percent === null || isNaN(percent)) {
		return "N/A" + br + "No Cases";
	}
	if(percent < 1e-5) {
		// Instead of shoing 0%, show 100% of the other type.
		return "100%" + br + zero_choice;
	}
	// Show a fixed percentage, but indicate if non-zero or less than 100%.
	var percent_str =
		percent < .01 ? "< 1":
		percent > .99 && percent < .9999 ? " > 99":
		(percent*100).toFixed(0);
	return percent_str + "%" + br + first_choice;
}

///////////////////////////
// Aggregation Specific Views

/**
 * Renders the chart showing the summary overview of the court.
 * Also graphs the number of new filings. Agg info options include:
 *   filing_str	what to call the new filings
 **/
function render_new_filings(obj_id, agg_info, agg_name, agg,
	filtered_name, filtered_agg, cumulative) {
	var filing_str = agg_info.filing_str;

	var $obj = $("#" + obj_id);
	var stats_agg = filtered_agg || agg;
	// Get cumulative data, or try to create it from
    var cum = cumulative || get_totals_and_before(stats_agg);
	var startdate = stats_agg.buckets && stats_agg.buckets.length ?
						new Date(stats_agg.buckets[0].key) : new Date();

	function get_average_text(avg) {
		return avg > 150*24 ? (avg/24/60).toFixed(2).toString() + "/minute":
			avg > 200 ? (avg/24).toFixed(1).toString() + "/hour":
			avg > .8 ? avg.toFixed(1).toString() + "/day":
			avg*7 > .8 ? (7*avg).toFixed(1).toString() + "/week":
			(30*avg).toFixed(1).toString() + "/month";
	}
	function onClick(d, nextd) {
		// Break down the current url.
		var cur = deparam_url();
		// Set the low date limit.
		if(d) {
			cur.date_filed_start = d.x/1000;
		}
		// Set a high date limit if we have one.
		if(nextd) {
			cur.date_filed_end = nextd.x/1000;
		}
		// Return the docket search url.
		return DOCKET_SEARCH_URL(cur);
	}
	// Figure out the averages per day overall and for trailing 3 months.
	var now = new Date();
	var num_days = now - startdate;
	var avg_p_day = num_days ? cum.total / (num_days / (1000*3600*24)) : 0;
	var avg_p_day_bef = cum.totalbefore / ((now - cum.monthsbefore) / (1000*3600*24));
	var perc_busy = (avg_p_day_bef / avg_p_day - 1.0);
	var perc_busy_txt = perc_busy > 0 ?
		"busier than average in the past three months":
		"less busy than average in the past three months";

	var url_all = onClick();
	var url_bef = onClick({x: cum.monthsbefore.getTime()});

	// Convert the percentage to degrees
	var degs = 90 * (1 - Math.exp(-1 * Math.abs(perc_busy) * 4));
	if(perc_busy < 0) {
		degs = -degs;
		perc_busy = -perc_busy;
	}
	degs = (degs + 90).toFixed(0); // At 90 degrees, the needle is in the middle.

	// Create the summary view.
	$obj.append($(".summary.original").clone().removeClass("original").show());
	$obj
		.find(".perc").text((perc_busy * 100).toFixed(0).toString() + "%").end()
		.find(".perc_sub").text(perc_busy_txt).end()

		.find(".avg").text(get_average_text(avg_p_day)).end()
		.find(".avg_super").text("Average Rate").end()
		.find(".avg_sub").text("average new " + plural(2, filing_str) +
			" overall").end()

		.find(".avg_recent").text(get_average_text(avg_p_day_bef)).end()
		.find(".avg_recent_super").text("Average Rate for Past 3 Months").end()
		.find(".avg_recent_sub").text("average new " + plural(2, filing_str) +
			" in the past three months").end()

		.find(".total a").text(cum.total.toLocaleString())
			.attr("href", url_all).attr("target", "_blank").end()
		.find(".total_super").text("overall").end()
		.find(".total_sub").text("new " + plural(2, filing_str)).end()

		.find(".total_recent a").text(cum.totalbefore.toLocaleString())
			.attr("href", url_bef).attr("target", "_blank").end()
		.find(".total_recent_super").text("Past 3 Months").end()
		.find(".total_recent_sub").text("total new " + plural(2, filing_str) +
			" in the past three months").end()

		.find(".avg_recent, .total_recent").powerTip({
            popupClass : 'stats_tip',
			closeDelay: 1000,
			fadeOutTime: 100,
			mouseOnToPopup: true
		}).data('powertip', function () {
				var d = new Date(cum.monthsbefore);
				d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
				var dstr = $.datepicker.formatDate("MM d, yy", d);
				// Get the UTC Date without the time.
				var href = $(this).find("a").attr('href');
				return $(hover_original)
						.find(".xval").text('Past 3 Months').end()
						.find(".series").text("Since:").addClass('visible').end()
						.find(".yval").addClass("inline").text(dstr).end()
						.find("a.viewmore").attr("href", href)
							.css("display", href ? "auto" : "none").end()
						.html();
			}).end()
		.find(".needle").css("transform", "rotateZ(" + degs + "deg)").end();

	// Add a motion chooser.
	if(parser_stats_utils.uses_motion_chooser()) {
		var viewargs = get_viewargs_obj();
    	var p_identifier = viewargs.event_identifier;
		var $gtitle = $obj.find(".graph_title .options, .graph_title").first();
		if(!$gtitle.length) {
			$gtitle = $obj.parents(".chart").find(".graph_title .options, .graph_title").first();
		}
		if(p_identifier) {
			$gtitle.append(parser_stats_utils.profile_only_link());
		}
		$gtitle.append(parser_stats_utils.drop_down(
			null, null, true, (p_identifier ? "Change" : "Add") + " Motion Analytics"));
	}

	if(cum.totalbefore == 0) {
		// Provide the number rather than "recent filings"
		$obj.addClass("pump_and_onegroup")
			.find(".perc").text("no").end()
			.find(".perc_sub").text("recent " + plural(2, filing_str) +
				" in the past three months").end()
	}
	if(agg.buckets && agg.buckets.length) {
		// Create the date histogram
		var new_id = obj_id + "_Histogram";
		$obj.append("<h2 class='graph_title'>New " +
			capitalize(plural(2, filing_str)) + " Each Month</h2>");

		$obj.append("<div id='" + new_id + "'></div>");
		var series = [{
			color: 'steelblue',
			renderer: 'lineplot',
			className : 'series_0',
			name: "Number of " + capitalize(plural(2, filing_str)) + " Filed",
			data : agg.buckets.map(function(b) {
				return { x : b.key/1000, y : b.doc_count };
			})
		}];
		// Add the filtered aggregation, if it exists.
		var filtered_agg_buckets = filtered_agg && filtered_agg.buckets;
		if(filtered_agg_buckets && filtered_agg_buckets.length) {
			series.push({
				color: 'steelblue',
				className : 'series_1',
				name: filtered_name,
				data : filtered_agg_buckets.map(function(b) {
					return { x : b.key/1000, y : b.doc_count };
				})
			});
		} else if(filtered_agg_buckets) {
		    // The aggregation exists, but there is no data.
            console.warn("TODO: tell user there is no data.");
        }
		$("#" + new_id).addClass("datehistogram")
			.append("<div class='graph'></div>");
		var xAxis = _render_time_series(0, new_id, series, onClick, null, null,
            'lineplot');
		xAxis.graph.configure({
			className 	: 'lineplotline',
			interpolation : 'linear',
		});

		xAxis.graph.renderer.areaFill = true;
		if(filtered_agg) {
			var legend = add_legend_to_graph(xAxis, series);
			// When displaying a filtered view, default to showing just that.
			if(legend.lines.length == 2) {
			    var line = legend.lines[0];
			    line.series.disable();
			    addClass(line.element, 'disabled');
            }
		}

		xAxis.graph.render();
	}
}

function render_case_length(obj_id, agg_info, agg_name, agg,
	filtered_name, filtered_agg) {
	var stats_agg = filtered_agg || agg;
	var compare_agg = filtered_agg ? agg : null;
	var blen = (stats_agg.buckets.length && stats_agg.buckets.length) || 0;
	var SERVER_INTERVAL = 1;
	var is_parser = false;
	var MAX_TICKS = 300 / SERVER_INTERVAL;
	_process_and_render_histogram(agg_name, obj_id, is_parser, stats_agg,
		// new_id
		obj_id + "_Claims_Histogram",
		// val_title
		"Case Length Histogram",
		// val_legend_name
		"Number of Days",
		// xaxis_name
		"Case Length",
		// val_units
		"day",
		// event_type, q_range_filter
		null, "num_days",
		// INTERVAL
		blen > 30*MAX_TICKS ? 365 : blen > 7*MAX_TICKS ? 30 : 7,
		// compare_data & compare_legend_name
		compare_agg, compare_agg ? "Number of Days" : null
	);
}

/**
 * Before we can render a histogram, we need to massage the data a bit.
 * @param agg_name The name of the greater aggregation.
 * @param obj_id   The id where the larger agg sits.
 * @param is_parser True if this is a parser request.
 * @param histo_data An array of buckets of data.
 * @param new_id An id for the new histogram (can be null).
 * @param val_title Chart title
 * @param val_legend_name A function that takes a series number and returns a legend name.
 * @param xaxis_name
 * @param val_units
 * @param event_type
 * @param q_range_filter The internal filter to use inside of the event to limit by day.
 * @param INTERVAL a constant set on the server.
 * @param compare_data To show two sets of data at once, send more data here.
 * @param compare_legend_name
 **/
function _process_and_render_histogram(agg_name, obj_id, is_parser, histo_data, new_id,
	val_title, val_legend_name, xaxis_name, val_units,
	event_type, q_range_filter,
	INTERVAL, compare_data, compare_legend_name, main_value_func) {
	// Get the domain.
	var all_data = typeof histo_data == "function" ? histo_data() :
        histo_data ? [histo_data] : [];
	if(compare_data && compare_data.buckets && compare_data.buckets.length) {
		all_data.push(compare_data);
	}
	// Safety checks.
	if(!all_data || !all_data.length || !all_data[0].buckets || !all_data[0].buckets.length) {
		return;
	}
	if(!new_id) {
		new_id = obj_id + "_histogram";
	}

	// Add the title.
	$("#" + obj_id).append("<h3>" + val_title +"</h3>" +
		"<div id='" + new_id +"' class='chart claims_granted depth_0'></div>");

	var max_k = Math.max.apply(null, all_data.map(function (a) {
		return a.buckets[a.buckets.length - 1].key;
	}));
	var min_k = Math.min.apply(null, all_data.map(function (a) {
		return a.buckets[0].key;
	}));
	function get_legend_name(idx) {
		return typeof val_legend_name == 'function'?
                val_legend_name(idx):
                (idx == 0 ? val_legend_name : compare_legend_name);
	}
	// Fill in zero entries for the histogram. Generate statistics.
	function normalize_data_and_get_stats(in_data) {
		var out = {
			vals_dict : [],
			vals_bucket : [],
			stats : []
		};
		for(var a_i in in_data) {
			var data = in_data[a_i];
			// Generate stats about the agg
			var stat = { n : 0, total : 0, totalsq : 0 };
			// Turn the agg into a dictionary
			var vals = {};
			for(var i in data.buckets) {
				var datum = data.buckets[i];
				vals[datum.key] = datum.doc_count;
				var amt = datum.doc_count*datum.key;
				stat.n += datum.doc_count;
				stat.total += amt;
				stat.totalsq += amt*amt;
			}
			// Additional stats.
			stat.avg = stat.total / stat.n;
			stat.stddev = Math.sqrt(stat.totalsq/stat.n - stat.avg*stat.avg);

			var shift = 0;
			// The comparison chart is drawn as a line, so it's shifted.
			if(compare_data && a_i > 0) {
			    shift = INTERVAL / 2
            }
			var legend_name = get_legend_name(a_i);
			var new_agg = {
				buckets: [],
                className : data.className,
				key : legend_name +
					" <span class='stats'>" + roundNumber(stat.avg, 1) +
						" " + plural(stat.avg, val_units) + " average</span>"
			};
			for(var k=min_k; k <= max_k; k += INTERVAL) {
				new_agg.buckets.push({
					// This is the number of claims granted, we never have 0 granted
					key : (k + (k < max_k ? shift : 0)) || 1,
					doc_count : vals[k] || 0
				});
			}
			out.vals_bucket.push(new_agg);
			out.vals_dict.push(vals);
			out.stats.push(stat);
		}
		return out;
	}

	// Prepare the data
	var D = normalize_data_and_get_stats(all_data);

	function _histo_hover_formatter(obj, i, series, x, y, className) {
		// Make xhi inclusive.
		var xhi = i >= 0 && i < series.data.length - 1 ? series.data[i+1].x - 1 : "";
		// English description of the range.
		var range_txt = xhi == "" ? plural_n(x, val_units) + " and above":
						xhi == x ? x: x + " to " + plural_n(xhi, val_units);

		var cur = deparam_url();
		if(!cur.f) {
			cur.f = [];
		} else if (!Array.isArray(cur.f)) {
			cur.f = [cur.f];
		}
		// Check for outcomes.
		var el_class = $(obj).attr('class');
		var outcome_q = re_stats_outcome.test(el_class || '') ?
			// If it's an outcome, the parser query expects words.
			el_class.replaceAll("_", " ") : '';
		var outcome_msg = '';
		if(outcome_q && outcome_q.length) {
			outcome_msg = " with outcome " + capitalize(outcome_q);
			outcome_q = " outcome_exact:(" + outcome_q + ")";
		}

		var q = q_range_filter + ":[" + x + "," + xhi + "]";
		var f_key = 'fname_q_event_date';
		if (event_type) {
			// We manually create it here. Should add something to PleadingTag.
			var f_start = (is_parser ? "parser_obj:(identifier:": "event:(type:");

			// Put the query together.
			q =  f_start + "(" + event_type + ") AND " + q + outcome_q + ")";
			// Put the message together.
			cur[f_key] = "Showing " + event_type +
				" that took between " + x + " and " + plural_n(xhi, val_units) + outcome_msg;
		} else {
			cur[f_key] = "Between " + x + " and " + plural_n(xhi, val_units) + outcome_msg;
		}
		cur.f.push("q_event_date-" + q);
		var url = DOCKET_SEARCH_URL(cur);

		var series_idx = null;
		this.graph.series.forEach(function (s, s_i) {
			if(s == series) {
				series_idx = s_i;
				return false;
			}
		});
		// Get the legend name based on the series number.
		var legend_name = get_legend_name(series_idx);
		// Finish building the "x value" line in the tip.
		var x_val = range_txt + (legend_name ? ": " + legend_name : "");

		var compare_values =
			D.vals_dict.length == 2 && series_idx == 0 && D.vals_dict[1][x] !== undefined ?
				html_tag("div", "compare",
					"Compare " + (get_legend_name(1) || "overall") + ": " +
					number_with_commas(D.vals_dict[1][x] || 0)
				): "";
		var main_value = main_value_func ?  main_value_func(y):
			"Occurred in " + number_with_commas(roundNumber(y, 1)) +
				plural(y, " " + case_str);

		// Build the hover tooltip.
		return $(hover_original).clone()
			.find(".xval").text(x_val).end()
			.find(".yval").html(main_value + compare_values).end()
			.find("a.viewmore").attr("href", url).end()
			.html();
	}

	// Call the standard drawing routines.
	render_histogram(0, agg_name, D.vals_bucket, new_id, _histo_hover_formatter,
		10, 100, xaxis_name, null, compare_data ? [1] : []);
}

/**
 * Add a control to the graph that changes the interval.
 * @param obj_id
 * @param xAxis
 */
function add_date_gap_changer(obj_id, xAxis) {
    var $obj = $("#" + obj_id);
    if (!$obj.length || $obj.find('.interval').length || !xAxis) {
        // Already created / bad input.
        return;
    }
    if (!$obj.find('.interval').length) {
        var lis = ['default', 'year', 'month', 'day'].map(function (i) {
            var txt = i == 'default' ? "Default Interval" :
                i == 'day' ? 'Daily' :
                    capitalize(i) + "ly";
            return wrap_html(txt, "option", 'val', {}, {value: i});
        });
        var $ul = $(wrap_html(lis.join(""), 'select', 'interval'));
        $obj.append($ul);
    }
    ///////
    // Setup the loader.
    if (!$obj.find(".loader").length) {
        $obj.append('<img class="loader" alt="throbber" ' +
            'src="/site_media/loader.gif" style="display:none">');
    }
    var cur_hash = get_url_hash();
    var frag_obj = url_params_to_object(cur_hash);
    var viewargs = get_viewargs_obj(cur_hash);
    $obj.find('.interval').change(function _on_click() {
        viewargs.interval = $(this).val();
        if (viewargs.interval == 'default') {
            delete viewargs['interval'];
        }
        var new_hash = $.extend({}, frag_obj);
        new_hash.viewargs = args_obj_to_args_ar(viewargs);
        var new_hash_url = param_query(new_hash);
        if (window.location.hash != new_hash_url) {
            window.location.hash = new_hash_url;
        }
        return false;
    });
    $obj.find(".interval").val(viewargs.interval || "default");

    $obj.css('visibility', 'visible').hide().fadeIn("fast");
}

var parser_stats_utils = {
	/**
	 * True if this page supports motion tags.
	 * @returns {boolean}
	 */
	uses_motion_chooser : function _uses_motion_chooser() {
		// For now, hard code FederalCourts. May need to make this more extensible.
		return window.location.pathname.search(/\/FederalCourts\//) >= 0;
	},
	on_event_profile : function on_event_profile() {
		return $.bbq.getState("v") == 'event_profile';
	},
	/**
	 * Return a jquery link that, when clicked, will remove any applied motion identifier.
	 * @returns {*|jQuery}
	 */
	profile_only_link : function () {
		var v = $.bbq.getState("v");
		if(!v.search(/_profile$/) == -1 || !this.uses_motion_chooser()) {
			return;
		}

		var icon = wrap_html("", "i", stats_views_globals.view_only_icon);
		var html = wrap_html(icon + "Remove Motion", "a", "view_all_stats");
		return $(html).click(function () {
			var cur_hash = get_url_hash();
			var viewargs = get_viewargs_obj(cur_hash);
			var frag_obj = url_params_to_object(cur_hash);
			delete viewargs['event_identifier'];
			frag_obj.viewargs = args_obj_to_args_ar(viewargs);
			var new_hash = $.param(frag_obj, true);
			if (window.location.hash != new_hash) {
				window.location.hash = new_hash;
			}
		});
	},
	other_links : function other_links(selected_identifier) {
        var html = '';
        if($.bbq.getState("v") != 'event_profile') {
            var view_all = '#q=&v=event_profile&viewargs=event_identifier-' + selected_identifier;
			var icon = wrap_html("", "i", stats_views_globals.view_only_icon);
			html += wrap_html(icon + "All event stats", "a", "view_all_stats",
                {}, { href : view_all });
        }
        return $(html);
    },
	identifier_tip : function identifier_tip(identifier_info, not_event_profile) {
		if(not_event_profile == true && this.on_event_profile()) {
			return '';
		}
		if(!identifier_info.tip) {
			return '';
		}
		return html_tag("p", "identifier_tip", identifier_info.tip);

	},
	drop_down : function drop_down(selected_identifier, identifier_dict, not_event_profile, btn_txt) {
		if(not_event_profile == true && this.on_event_profile()) {
			return '';
		}
		// Default button text.
		if(!btn_txt) {
			btn_txt = "More Motion Analytics";
		}
        var $motion_chooser = $(wrap_html("", "div", "motion_chooser_wrapper"));
        var $show_button = $(wrap_html(
            wrap_html("", "i", "fad fa-analytics") + btn_txt,
			"div", "motion_chooser_btn"));
        var search_url = window.location.origin + DOCKET_SEARCH_URL(deparam_url());
        analytics_track("MotionChooser", "dropdown");
        setup_motion_chooser({
            $object : $motion_chooser,
            search_url: search_url,
            sort: "priority",
            auto_expand: true,
            // This expander is on the right, put tooltips on the left.
            tip_placement : 'nw',
            max_types : 0,
			analytics_link_toggle: true,
            create_href : parser_stats_utils.create_analytics_link,
            done : function () {

            }
        });
        function toggle_show() {
            $motion_chooser.toggle();
            $show_button.toggleClass("selected");
        }
        $show_button
            .append($motion_chooser.hide())
            .click(function (ev) {
                // only continue if the target itself has been clicked
               if(ev.target != this && ev.target !== $(this).find("i")[0])
                   return;
               toggle_show();
            });
        // The global dropdown allows the user to click anywhere to hide.
        add_global_dropdown(".motion_chooser_wrapper", $show_button, toggle_show)
        return $show_button;
    },
	update_agg_info : function update_agg_info(agg_info, p_identifier, name) {
		update_dict(agg_info, {
			is_parser : true,
			name: 'Analytics on ' + name,
			map_name : function(it) {
				return capitalize(it.key);
			},
			map_short_name : function _get_short_name(it) {
				return capitalize(it.key);
			},
			className : function _get_short_name(it) {
				return it.key;
			},
			sort_series 	: sort_grant,
			click_searches_dockets : true,
			click_type		: null,
			click_identifier : p_identifier,
			// Specific to render_event_success
			days_from_name : case_str + " Start",
			days_to_name : name,
			// Specific to patent claim analysis (so far only PTAB uses it)
			claims_grant_name : null,
			// Special function specific to render_event_success
			get_stat : null && function (agg) {
				return {
					stat : (100*this.get_stat_filtered(agg).stat
						).toFixed(0).toString() + "%",
					p : e.percent_success
				}
			},
			// Generates a percentage statistic for filtered data.
			get_stat_filtered : function(agg) {
				var total = 0;
				var counts = {};
				for(var i in agg.buckets) {
					var bucket = agg.buckets[i];
					var types = bucket.type && bucket.type.buckets || [];
					total += bucket.doc_count;
					types.forEach(function (type_bucket) {
						counts[type_bucket.key] = (counts[type_bucket.key] || 0) + type_bucket.doc_count;
					});
				}
				var total_stat = counts['order'] || 0;
				return {
					stat 	: total ? total_stat / total : null,
					p 		: "Total Orders",
				};
			}
		});
	},

	/**
	 * Turn a list of identifiers into a dictionary.
	 * @param identifier_list
	 * @returns {{}}
	 */
	get_identifier_dict : function get_identifier_dict(identifier_list) {
		var identifier_dict = {};
		identifier_list.forEach(function (info) {
			identifier_dict[info.identifier] = info;
		});
		return identifier_dict;
	},

	// The "recent time" view argument controls the recent stats that are shown on the right.
	recent_time_options  : {
		"7days" : "Last Week",
		"3months" : "Last 3 Months",
		"12months" : "Last Year",
		"2years" : "Last 2 Years",
	},
	// Must match server's default.
	recent_time_default : "3months",
	recent_time_dropdown : function recent_time_dropdown(recent_val) {
		return this.create_viewargs_dropdown(recent_val, this.recent_time_options, this.recent_time_default, 'recent_time', 'recent');
	},

	// Histogram type controls the type of parser hitogram we show.
	date_histogram_type_options : {
		'order_outcomes' : 'Orders and outcomes',
		'order_known_outcomes' : 'Orders and known outcomes',
		'all_types' : 'Orders, motions, responses, replies',
		'motions' : 'Motions',
	},
	date_histogram_type_default : "order_outcomes",
	date_histogram_type_dropdown : function date_histogram_type_dropdown(histo_val) {
		return this.create_viewargs_dropdown(histo_val, this.date_histogram_type_options, this.date_histogram_type_default, 'date_histogram_type', 'date_histogram_type');
	},
	interval_days_options : {
		'1' : 'Daily Interval (up to 50 days)',
		'2' : '2 Day Intervals (up to 100 days)',
		'5' : '5 Day Intervals (up to 250 days)',
		'10' : '10 Day Intervals (up to 500 days)',
		'30': '30 Day Intervals (Up to 1500 days)',
		'100': '100 Day Intervals (Up to 5000 days)',
		'250': '250 Day Intervals (Up to 12,500 days)',
	},
	interval_days_default : 10,
	interval_days_dropdown : function interval_days_dropdown(interval_days) {
		return this.create_viewargs_dropdown(interval_days, this.interval_days_options, this.interval_days_default, 'interval_days', 'interval_days');
	},

	length_histogram_info : [
		{key:'Days_To_Motion', name:'Case Start → Motion', q_filter : "type:motion days"},
		{key:'Days_Sequence', name:'Motion → Decision', q_filter : "days_sequence"},
		{key:'Days_Decision', name:'Fully Briefed → Decision', q_filter : "days_decision"},
		{key:'Days_Briefing', name:'Motion → Fully Briefed', q_filter : "days_briefing"},
		// The q_filter below is a bit of a hack to limit to only orders/motions.
		{key:'Days_To_Decision', name:'Case Start → Decision', q_filter : "type:order days"},
	],
	// The default values depending on whether viewing histogram or a row, and whether timing dat ais available.
	timing_defaults : stats_views_globals.render_analytics_sequence ? {
		histo: "days_sequence+outcome",
		row: "days_sequence"
	} : {
		histo : "days_to_decision+outcome",
		row : "days_to_decision"
	},
	length_histogram_type_options : function length_histogram_type_options() {
		var key_to_name = {};
		this.length_histogram_info.forEach(function (info) {
			var kew_lower = info.key.toLowerCase();
			key_to_name[kew_lower] = info.name;
		});
		return stats_views_globals.render_analytics_sequence ? {
			// The most important ones.
			'days_sequence+outcome' : 'Motion → Decision with Outcomes',
			'days_decision+outcome' : 'Fully Briefed → Decision with Outcomes',

			// Second Tier - maybe remove?
			'days_to_decision+outcome' : 'Case Start → Decision with Outcomes',
			'days_to_decision' : 'Case Start → Decision',
			'days_to_decision,days_to_motion' : 'Case Start → Motion + Decision',
			'days_to_motion' : key_to_name['days_to_motion'],

			// Third Tier
			'days_sequence,days_briefing' : 'Motion → Decision + Fully Briefed',
			'days_briefing' : key_to_name['days_briefing'],
			'days_sequence' : key_to_name['days_sequence'],
			'days_decision' : key_to_name['days_decision'],
		} : {
			// Case Start timing w/o linking.
			'days_to_decision+outcome' : 'Case Start → Decision with Outcomes',
			'days_to_decision' : 'Case Start → Decision',
			'days_to_decision,days_to_motion' : 'Case Start → Motion + Decision',
			'days_to_motion' : 'Case Start → Motion',
		};
	},

	length_histogram_type_dropdown : function length_histogram_type_dropdown(event_histo_val) {
		var options = this.length_histogram_type_options();
		var opt_default = this.timing_defaults.histo;
		return this.create_viewargs_dropdown(event_histo_val, options, opt_default,
			'length_histogram_type', 'length_histogram_type');
	},
	// The stats row timing shares many similarities with the length histogram timing, but not the same.
	stats_row_timing_type_options : function stats_row_timing_type_options() {
		var info_options = {};
		this.length_histogram_info.forEach(function (info) { info_options[info.key.toLowerCase()] = info.name; });
		return stats_views_globals.render_analytics_sequence ?  {
			'days_sequence' : info_options['days_sequence'],
			'days_to_decision' : info_options['days_to_decision'],
			'days_to_motion' : info_options['days_to_motion'],
			'days_decision' : info_options['days_decision'],
			// Needs testing b/c we're filtered on
			// 'days_briefing' : info_options['days_briefing'],
		} : {
			'days_to_decision' : info_options['days_to_decision'],
			'days_to_motion' : info_options['days_to_motion'],
		}
	},
	stats_row_timing_type_dropdown : function stats_row_timing_type_dropdown(stats_row_timing_type_val) {
		var options = this.stats_row_timing_type_options();
		var opt_default = this.timing_defaults.row;
		return this.create_viewargs_dropdown(stats_row_timing_type_val,
			options, opt_default, 'stats_row_timing_type', 'stats_row_timing_type');
	},

	/**
	 * Create a dropdown menu that will change the view arguments when changed.
	 * @param curviewargs_val The current viewargs val (null if not set).
	 * @param options A viewargs value --> human display dictionary.
	 * @param default_val Default value.
	 * @param klass Any additional klass.
	 * @param viewargs_key The view arguments key you want to change.
	 * @returns {*|jQuery}
	 */
	create_viewargs_dropdown : function create_viewargs_dropdown(curviewargs_val, options, default_val, klass, viewargs_key) {
		var html_options = [];
		for(var val in options) {
			var name = options[val];
			var attrs = {value:val};
			if(val == curviewargs_val || (!curviewargs_val && val == default_val)) {
				attrs.selected = true;
			}
			html_options.push(html_tag("option", "", name, {}, attrs));
		}
		var html = html_tag("select", klass, html_options.join(""));
		return $(html).change(function _recent_dropdown_changed() {
			var cur_hash = get_url_hash();
			var frag_obj = url_params_to_object(cur_hash);
			var viewargs = get_viewargs_obj(cur_hash);
			viewargs[viewargs_key] = $(this).val();
			frag_obj.viewargs = args_obj_to_args_ar(viewargs);
			var new_hash = $.param(frag_obj, true);
			if (window.location.hash != new_hash) {
				window.location.hash = new_hash;
			}
		})
	},

	render_basic_stats : function render_basic_stats(p_info, viewargs, agg) {

		// Create a single statistic.
		function do_stat(name, agg_val, icon_klass, klass, q_type, recent_time) {
			var icon = html_tag("i", icon_klass, "");
			var subtitle = agg_val.cases ? html_tag("div", "subtitle",
				"in " + plural_n(agg_val.cases.doc_count, case_str)) : "";
			var main = plural_n(agg_val.count || agg_val.doc_count || 0, name);
			var link = q_type ? get_parser_query(p_info, q_type, null, recent_time) : "";

			return html_tag(link ? "a" : "div", "one_stat " + (klass || ''),
				icon + main + subtitle, {}, link?{target:"_blank", href:link}:null);
		}
		// Create a single outcome statistics
		function do_outcome_stat(name, agg_count, agg_dict, icon_klass, klass, recent_time) {
			var icon = html_tag("i", icon_klass, "");
			var full_klass = "one_stat outcome " + (klass || '');
			if(!agg_count) {
				return html_tag("div", full_klass + " empty", icon + "-");
			}
			var link = get_parser_query(p_info, 'order', [klass], recent_time);

			var count = agg_dict ? agg_dict.count : 0;
			var percentage = (100 * count / agg_count).toFixed(0);
			var title = percentage + "% " + name;
			return html_tag("a", full_klass, icon + title, {}, {href:link, target: "_blank"});
		}
		// create a single time statistic.
		var timing_icon = "fad fa-calendar";
		// Return a dict with the stat, cases, and percentiles for the timing key.
		function get_timing_aggs(agg_val) {
			var keys = ['days_sequence', 'days_to_decision', 'days_to_motion', 'days_decision'];
			// Return the first key we find with the correct statistic.
			var timing_key = keys.find(function (key) { return agg_val[key + "_stats"]; });
			return {
				stat : agg_val[timing_key + "_stats"],
				cases : agg_val[timing_key + "_cases"],
				perc : agg_val[timing_key + "_percentiles"],
			}
		}
		function do_time_stat(agg_val) {
			var icon = html_tag("i", timing_icon, "");
			var a_timing = get_timing_aggs(agg_val);
			if(!a_timing.stat.count) {
				return html_tag("div", "one_stat time empty", icon + '-');
			}
			var subtitle =
				html_tag("div", "subtitle", "Motions → Decisions") +
				html_tag("div", "subtitle",
				"in " + plural_n(a_timing.stat.count, "Motion"));
			// Add the case count if we were given it.
			if(a_timing.cases && a_timing.cases.doc_count) {
				subtitle += html_tag("div", "subtitle",
					"across " + plural_n(a_timing.cases.doc_count, case_str));
			}

			var count = plural_n(a_timing.stat.avg.toFixed(0), "day") + " avg.";

			var percentile = '';
			if(a_timing.perc && a_timing.stat.count > 1) {
				var values = a_timing.perc.values;
				percentile += html_tag("div", "percentile subtitle", "Common Range: " +
					parseInt(values['25.0']).toFixed(0) + "-" +
					parseInt(values['75.0']).toFixed(0) + " days", {
						powertip: "Common Range: The day range between the 25th and 75th percentiles (i.e., the middle 50%) — estimating a common statistical range."
				}	);
			}
			return html_tag("div", "one_stat time", icon + count + subtitle + percentile);
		}

		// Get a list of statistics. Code is shared between all time and recent.
		function get_stats_list(agg, outcome_agg, recent_time) {
			var outcomes = agg_to_dict(outcome_agg);
			var known_outcomes = outcome_agg.doc_count - ((outcomes.unknown || {}).count || 0);
			return [
				do_stat("Order",agg.Orders, parser_fontawesome_icons.order,"orders", "order", recent_time),
				do_outcome_stat("Granted", known_outcomes, outcomes.granted, 'fad fa-check',"granted", recent_time),
				do_outcome_stat("Denied", known_outcomes, outcomes.denied, 'fad fa-thumbs-down',"denied", recent_time),
				html_tag("div", "one_stat outcome_subtitle", " of " + plural_n(known_outcomes, "known outcome")),
				do_time_stat(agg.Orders),
				do_stat("Motion", agg.Motions, parser_fontawesome_icons.motion, "motions", "motion", recent_time),
			];
		}
		function pie_chart_div(outcomes_agg) {
			var buckets = ((outcomes_agg || {}).buckets || []);
			// Setup the buckets so they can be displayed.
			buckets.forEach(function _setup_bucket_for_display(b) {
				b.outcome = b.key;
				b.short_name = capitalize(b.key);
				b.className = b.key.replaceAll(" ", "_");
				b.k = b.short_name;
			});
			return html_tag("div", "outcome_pie_chart", "");
		}
		function outcome_pie_chart_click(recent_time) {
			return function _inner_pie_click(data, iteration, element) {
				var outcome = data.data && data.data.k;
				var link = get_parser_query(p_info, 'order', [outcome], recent_time);
				return link;
			}
		}

		var recent_time = viewargs_get_recent_date(viewargs);
		var recent_time_name = parser_stats_utils.recent_time_options[viewargs.recent || parser_stats_utils.recent_time_default] || "Since " + $.datepicker.formatDate('m/d/yy', recent_time);

		var html =
		html_tag("div", "stat_section all_time",
			html_tag("div", "stat_title", "Since " + stats_views_globals.parser_start_year) +
			html_tag("div", "stat_list", get_stats_list(agg, agg.Outcome).join("")) +
			pie_chart_div(agg.Outcome),
		) +
		html_tag("div", "stat_section recent",
			html_tag("div", "stat_title", recent_time_name) +
			html_tag("div", "stat_list", get_stats_list(agg.Recent, agg.Recent_Outcome, recent_time).join("")) +
			pie_chart_div(agg.Recent_Outcome),
		);
		var $html = $(html)
			.find("[data-powertip]").powerTip({
				smartPlacement:true,
				popupClass : 'small_powertip'
			}).end();

		// The pie charts are all in javascript.
		setup_pie_chart(2, "All Time", agg.Outcome,
			$html.find(".outcome_pie_chart").first(),
			null, outcome_pie_chart_click());
		setup_pie_chart(2, "Recent", agg.Recent_Outcome,
			$html.find(".outcome_pie_chart").last(),
			null, outcome_pie_chart_click(recent_time));

		return $html;
	}
}

/**
 * Parse the view argument to get the "recent" date.
 * @param viewargs
 * @returns {null|Date}
 */
function viewargs_get_recent_date(viewargs) {
	var key = viewargs.recent;
	if(key == undefined) {
		key = parser_stats_utils.recent_time_default;
	}
	var d = new Date();

	var years = /-?(\d)\s*years?/.exec(key);
	if(years) {
		d.setFullYear(d.getFullYear() - parseInt(years[1]));
		return d;
	}
	var months = /-?(\d)\s*mo\.?(nths?)?/.exec(key);
	if(months) {
		d.setMonth(d.getMonth() - parseInt(months[1]));
		return d;
	}
	var days = /-?(\d)\s*days?/.exec(key);
	if (days) {
		 d.setDate(d.getDate() - parseInt(days[1]));
		 return d;
	}
	return null;
}

/**
 * Wrap a rendering function that takes the standard arguments, and add two
 * additional arguments at the start.
 * @param render_func Takes standard rendering arguments, plust an identifier_dict, and was_synchronous input params.
 * @returns {*}
 */
function render_with_identifier_dict(render_func) {
	var render_no = 0;
	return function _render_with_identifier(obj_id, agg_info, agg_name, agg) {
		var was_synchronous = true;
		render_no++;
		var cur_render_no = render_no;
		var did_done = false;
		was_synchronous = get_identifier_list({
			search_url: false, // Just get the static list
			sort: 'priority',
			// Filter down to the given type.
			filter_types: null,
			max_identifiers: 1,
			max_types: 100,
			// Try to call done synchronously if possible.
			synchronous: true,
			done: function _done(identifier_list) {
				did_done = true;
				if(cur_render_no != render_no) {
					return;
				}
				// Turn the list into a dict.
				var identifier_dict = parser_stats_utils.get_identifier_dict(identifier_list);
				render_func(identifier_dict, was_synchronous, obj_id, agg_info, agg_name, agg);
			},
			error: function _error(error) {
				did_done = true;
				console.log("Error Getting Identifier List: " + error);
			}
		});
		was_synchronous = false;

		// If we're still waiting after a second, display a message.
		setTimeout(function () {
			if(!did_done && cur_render_no == render_no) {
				$("#" + obj_id).text("Loading pleading tag info...");
			}
		}, 1000);
	}
}

function render_event_counts_viewargs(identifier_dict, was_synchronous, obj_id, agg_info, agg_name, agg) {
	var viewargs = get_viewargs_obj();
    var p_identifier = viewargs.event_identifier;
	var $obj = $("#" + obj_id).addClass("eventcounts");
    function type_to_title(p_type) {
        return capitalize(p_type);
    }
    parser_stats_utils.update_agg_info(agg_info, p_identifier, p_identifier);
    var has = {};
    has.unknown_outcomes = viewargs.unknown_outcomes == undefined;

    var check_options= [];
    check_options.push(["Show Unknown Outcomes", has.unknown_outcomes,
            "unknown_outcomes", null, unknown_outcome_tip()]);

	// Get the info on the given event key.
	var p_info = identifier_dict[p_identifier];
	if(!p_info) {
		handle_error(p_identifier ?
			"Unknown identifier: " + p_identifier : "Identifier is required.");
		return;
	}
	var $dropdown = parser_stats_utils.drop_down(p_identifier, identifier_dict);
	var $identifier_tip = parser_stats_utils.identifier_tip(identifier_dict[p_identifier]);
	var $other_links = parser_stats_utils.other_links(p_identifier);
	var $recent_dropdown = parser_stats_utils.recent_time_dropdown(viewargs.recent);
	var $outcome_options = get_checkbox_viewargs_row(check_options, obj_id);
	var $options = $outcome_options.append($recent_dropdown)
		.append($other_links).append($dropdown);
	function get_title() {
		return p_info.name_display + ": Overview";
	}
	$obj.find(".graph_title")
		.addClass("no_suggest")
		.addClass("no_export")
		// Update the title.
		.find(".name").text(get_title()).end()
		.append($options)
		.append($identifier_tip)
	;

	update_dict(agg_info, {
		name : p_info.name,
	});
	var html = parser_stats_utils.render_basic_stats(p_info, viewargs, agg);

	$obj.append(html);
}

/**
 * Render a parser event histogram.
 * @param obj_id
 * @param agg_info
 * @param agg_name
 * @param agg
 */
function render_date_event_histogram(identifier_dict, was_synchronous, obj_id, agg_info, agg_name, agg) {
	var viewargs = get_viewargs_obj();
	var p_identifier = viewargs.event_identifier;
	var $obj = $("#" + obj_id).addClass("eventdatehistogram");

	parser_stats_utils.update_agg_info(agg_info, p_identifier, name);
	var has = {};
	has.unknown_outcomes = viewargs.unknown_outcomes == undefined;

	var check_options = [];
	check_options.push(["Show Unknown Outcomes", has.unknown_outcomes,
		"unknown_outcomes", null, unknown_outcome_tip()]);

	// Get the info on the given event key.
	var p_info = identifier_dict[p_identifier];
	if (!p_info) {
		handle_error(p_identifier ?
			"Unknown identifier: " + p_identifier : "Identifier is required.");
		return;
	}
	var $dropdown = parser_stats_utils.drop_down(p_identifier, identifier_dict, true);
	var $identifier_tip = parser_stats_utils.identifier_tip(identifier_dict[p_identifier], true);
	var $other_links = parser_stats_utils.other_links(p_identifier);
	var $date_histogram_type_dropdown = parser_stats_utils.date_histogram_type_dropdown(viewargs.date_histogram_type);
	var $outcome_options = get_checkbox_viewargs_row(
		check_options, obj_id).addClass("outcome_option");
	var $options = $(wrap_html("", "div", "options"))
		.append($date_histogram_type_dropdown)
		.append($other_links).append($dropdown);

	function get_title() {
		var histo_title = parser_stats_utils.date_histogram_type_options[viewargs.date_histogram_type || parser_stats_utils.date_histogram_type_default]
		return p_info.name_display + ": " + histo_title;
	}

	$obj.find(".graph_title")
		.addClass("no_suggest")
		.addClass("no_export")
		// Update the title.
		.find(".name").text(get_title()).end()
		.append($options)
		.append($identifier_tip)
		.append("<div id='Event_Histogram'></div>");

	update_dict(agg_info, {
		name: p_info.name,
	});
	var no_outcomes = false;
	transform_agg(agg, agg_info.filter, agg_info.map, agg_info.map_name,
		agg_info.map_className, agg_info.sort_series);

	function get_url(el, start_d, end_d) {
		// The element's class name has the data series it's from.
		var el_class = $(el).attr('class');
		// is_parser_type is a global defined in pleading_tags.js
		var type_val = is_parser_type && is_parser_type(el_class) ? el_class : "order";
		var outcome = re_stats_outcome.test(el_class) ?
			// If it's an outcome, the parser query expects an array.
			[el_class.replaceAll("_", " ")] : null;
		return get_parser_query(p_info, type_val, outcome, start_d, end_d);
	}
	render_event_success_histogram($obj, agg, agg_name, agg_info, no_outcomes, get_url, "parser");
}

function render_length_event_histogram(identifier_dict, was_synchronous, obj_id, agg_info, agg_name, agg) {
	var viewargs = get_viewargs_obj() || {};
	var p_identifier = viewargs.event_identifier;
	var $obj = $("#" + obj_id).addClass("eventlengthhistogram");
	var cur_histogram_type = viewargs.length_histogram_type ||
		parser_stats_utils.timing_defaults.histo;

	parser_stats_utils.update_agg_info(agg_info, p_identifier, name);
	var has = {};
	has.unknown_outcomes = viewargs.unknown_outcomes == undefined;
	has.length_histogram_do_range = viewargs.length_histogram_do_range;
	has.outcomes = cur_histogram_type.search(/\+outcomes?$/ig) >= 0;

	var check_options = [];
	check_options.push(["Show as pie chart", has.length_histogram_do_range,
		"length_histogram_do_range", true, "Show in a pie chart as days, " +
		"weeks, months, years, etc, rather than as a histogram."]);

	// Get the info on the given event key.
	var p_info = identifier_dict[p_identifier];
	if (!p_info) {
		handle_error(p_identifier ?
			"Unknown identifier: " + p_identifier : "Identifier is required.");
		return;
	}
	var $dropdown = parser_stats_utils.drop_down(p_identifier, identifier_dict, true);
	var $identifier_tip = parser_stats_utils.identifier_tip(identifier_dict[p_identifier], true);
	var $other_links = parser_stats_utils.other_links(p_identifier);
	var $interval_days_dropdown = parser_stats_utils.interval_days_dropdown(viewargs.interval_days);
	var has_sequence_timing = p_info.can.sequence && stats_views_globals.render_analytics_sequence;
	var $length_histogram_type_dropdown = parser_stats_utils.length_histogram_type_dropdown(
		viewargs.length_histogram_type, has_sequence_timing);
	var $outcome_options = get_checkbox_viewargs_row(
		check_options, obj_id).addClass("outcome_option");
	var $options = $(wrap_html("", "div", "options"))
		.append($interval_days_dropdown)
		.append($length_histogram_type_dropdown)
		.append($outcome_options)
		.append($other_links).append($dropdown);

	function get_title(main_agg) {
		var options = parser_stats_utils.length_histogram_type_options();
		var name = options[cur_histogram_type];
		if(!name) {
			name = main_agg && main_agg.name || '';
		}
		return p_info.name_display + ": Timing " + name;
	}
	var main_agg_info = null, compare_agg_info = null;
	var main_data = null, compare_data = null;
	parser_stats_utils.length_histogram_info.forEach(function (agg_info) {
		var agg_data = agg[agg_info.key];
		if(agg_data) {
			if(!main_agg_info) {
				main_agg_info = agg_info;
				main_data = agg_data;
			} else if(!compare_agg_info) {
				compare_agg_info = agg_info;
				compare_data = agg_data;
			} else {
				console.warning("Ignoring data: " + agg_info.name);
			}
		}
	});
	$obj.find(".graph_title")
		.addClass("no_suggest")
		.addClass("no_export")
		// Update the title.
		.find(".name").text(get_title(main_agg_info)).end()
		.append($options)
		.append($identifier_tip)
		.append("<div id='Event_Length_Histogram'></div>");

	if(!main_agg_info) {
		$obj.find("#Event_Length_Histogram").text("No Data");
		return;
	}
	update_dict(agg_info, {
		name: p_info.name,
	});
	transform_agg(agg, agg_info.filter, agg_info.map, agg_info.map_name,
		agg_info.map_className, agg_info.sort_series);

	if(has.length_histogram_do_range) {
		// If we get data as a named range, there may be buckets.
		function _buckets_to_arrays(data) {
			if(!data || !data.buckets || typeof data.buckets != "object") {
				return
			}
			var buckets_ar = [];
			for(var k in data.buckets) {
				var b = data.buckets[k];
				if(b.from === undefined) {
					console.warning("Bad Range Bucket: " + b.name);
					continue;
				}
				if(b.key == undefined) {
					// May have already changed it.
					b.key = k;
				}
				buckets_ar.push(b);
			}
			buckets_ar.sort(function (a, b) {
				return a.from - b.from;
			});
			data.buckets_dict = data.buckets;
			data.buckets = buckets_ar;
		}
		function do_one_pie(main, sub, histogram) {
			var histo_copy = $.extend({}, histogram)
			_buckets_to_arrays(histo_copy);
			if(!histo_copy.doc_count || !histo_copy.buckets || !histo_copy.buckets.length) {
				return;
			}
			var subtitle_html = (sub ? html_tag("div", "subtitle", capitalize(sub)) : "");
			var title_html = html_tag("div", "pietitle", main + subtitle_html);
			var $pie = $("<div></div>").append(title_html);
			$obj.append($pie)
			setup_pie_chart(sub ? 1 : 0, title_html,
				histo_copy, $pie, null, null);
		}
		if(has.outcomes) {
			main_data.buckets.forEach(function (b) {
				do_one_pie(main_agg_info.name, b.key, b.histogram);
			});
			((compare_data || {}).buckets || []).forEach(function (b) {
				do_one_pie(compare_agg_info.name, b.key, b.histogram);
			});
		} else {
			do_one_pie(main_agg_info.name, null, main_data);
			if(compare_agg_info) {
				do_one_pie(compare_agg_info.name, null, compare_data);
			}
		}
		$obj.append(html_tag("p", "warning", "These pie charts are an " +
			"experimental preview showing timing divided into common " +
			"cumulative buckets, i.e., the week slice is really 2-7 days, the " +
			"month slice is 8 to 30 days, etc. Additional visualizations are coming soon."));
		return;
	}
	var histogram_bucket_interval_days = parseInt(viewargs.interval_days || 10);
	var main_histo_buckets = [main_data];
	if(has.outcomes) {
		main_histo_buckets = (main_data.buckets || []).map(function _to_histo_bucket(b) {
			if(!b || !b.histogram || !b.histogram.buckets){
				return null;
			}
			b.className = b.key.replaceAll(/[\s/]+/ig, "_")
			b.buckets = b.histogram.buckets
			b.doc_count = b.histogram.doc_count;
			return b;
		}).filter(function (b) { return b; });
	}
	_process_and_render_histogram(agg_name, obj_id, agg_info.is_parser,
			function _get_histo_data() {
				return main_histo_buckets;
			},
			obj_id + "_" + main_agg_info.key,
			main_agg_info.name,
			function _legend_name(idx) {
				if(has.outcomes) {
					return main_agg_info.name + ": " + capitalize(main_histo_buckets[idx].key);
				}
				return idx == 0 ? main_agg_info.name:
					idx > 0 && compare_agg_info ? compare_agg_info.name:
						"Extra Data";
			},
			main_agg_info.name,
			"day",
			p_identifier,
			main_agg_info.q_filter,
			histogram_bucket_interval_days,
			compare_data,
			compare_agg_info && compare_agg_info.name,
			function _main_value_func(y) {
				// Sometimes we get floats.
				return "Occurred " + plural_n(parseInt(y), "time") + ".";
			}
		);
}

/**
 * Deprecated, will be removed in favor of render_event_counts_viewargs
 */
function render_event_success_viewargs(identifier_dict, was_synchronous, obj_id, agg_info, agg_name, agg) {
    var viewargs = get_viewargs_obj();
    const p_identifier = viewargs.event_identifier;
    const p_type = viewargs.event_type;
    function type_to_title(p_type) {
        return capitalize(p_type);
    }

    parser_stats_utils.update_agg_info(agg_info, p_identifier, p_identifier);
    var has = {};
    has.unknown_outcomes = viewargs.unknown_outcomes == undefined;

    var check_options= [];
    check_options.push(["Show Unknown Outcomes", has.unknown_outcomes,
            "unknown_outcomes", null, unknown_outcome_tip()]);

	// Get the info on the given event key.
	var p_info = identifier_dict[p_identifier];
	if(!p_info) {
		handle_error(p_identifier ?
			"Unknown identifier: " + p_identifier : "Identifier is required.");
		return;
	}
	var $obj = $("#" + obj_id);
	var $dropdown = parser_stats_utils.drop_down(p_identifier, identifier_dict);
	var $identifier_tip = parser_stats_utils.identifier_tip(identifier_dict[p_identifier]);
	var $other_links = parser_stats_utils.other_links(p_identifier);
	var $outcome_options = get_checkbox_viewargs_row(
		check_options, obj_id).addClass("outcome_option");
	var $options = $(wrap_html("", "div", "options")).append($other_links).append($dropdown);

	$obj.find(".graph_title")
		.addClass("no_suggest")
		.addClass("no_export")
		// Update the title.
		.find(".name").text(p_info.name).end()
		.append($options)
		.append($identifier_tip);

	update_dict(agg_info, {
		name : p_info.name,
	});

	render_event_success(obj_id, agg_info, agg_name, agg, 0, true);

	var u_id = uniqueid();
	$obj.append(wrap_html("", "div", "outcome_analysis", {}, {id:u_id}))
	$obj.find(".outcome_analysis").append($outcome_options);
	render_event_success(u_id, agg_info, agg_name, agg, 0, true, "Outcome")

	var compare_agg = null;
	var days_to_name = p_info.name;
	var HISTOGRAM_DATE_BUCKET_DAYS = 10;
	_process_and_render_histogram(agg_name, obj_id, agg_info.is_parser,
		function _get_data() {
			var buckets = agg.Days_from_Filing.buckets || [];
			return buckets.map(function (b) {
				return {
					key : b.key,
					className : b.key,
					doc_count : b.doc_count,
					buckets : b.days.buckets,
				}
			});
		},
		obj_id + "_Days_Histogram",
		"Time to " + days_to_name,
		function _legend_name(idx) {
			var p_type = agg.Days_from_Filing.buckets[idx].key;
			return "Days to " + type_to_title(p_type);
		},
		"Days from " + agg_info.days_from_name + " to " + days_to_name +
		(compare_agg ? added_name : ""),
		"day",
		agg_info.click_type,
		"days",
		HISTOGRAM_DATE_BUCKET_DAYS,
		compare_agg ? compare_agg.Days_from_Filing : null,
		compare_agg ? ("Days to " + days_to_name +
			added_compare_name) : null
	);
	var other_histos = ['Days_to_Decision', 'Days_for_Sequence', 'Days_for_Briefing'];
	var other_histo_info = {
		Days_to_Decision : {
			q_filter : "days_decision"
		},
		Days_for_Sequence : {
			q_filter : "days_sequence"
		},
		Days_for_Briefing : {
			q_filter : "days_briefing"
		}
	}
	other_histos.forEach(function(name) {
		var days_agg = agg[name];
		if(!days_agg || !days_agg.buckets) {
			return;
		}
		var name_human = name.replaceAll("_", " ");
		var info = other_histo_info[name];
		_process_and_render_histogram(agg_name, obj_id, agg_info.is_parser,
			days_agg,
			obj_id + "_" + name,
			name_human,
			function _legend_name(idx) {
				return name_human;
			},
			name_human,
			"day",
			p_identifier,
			info.q_filter,
			HISTOGRAM_DATE_BUCKET_DAYS,
			compare_agg ? compare_agg[name] : null,
			compare_agg ? (name_human + added_compare_name) : null
		);
	});
}

/**
 * Given information on  pleading tag, generate a search URL.
 * @param identifier_info
 * @param type
 * @param outcome
 * @param date_gte
 * @param date_lte
 * @returns {string}
 */
function get_parser_query(identifier_info, type, outcome, date_gte, date_lte) {
	var identifier = identifier_info && identifier_info.identifier;
	var tag_info = new PleadingTagInfo(type, identifier, identifier_info, null, outcome)
	var info = tag_info.to_query_info({date_gte: date_gte, date_lte: date_lte});

	var cur = deparam_url();
	if(cur.v) {
		delete cur.v;
	}
	if(cur.views) {
		delete cur.views;
	}
	function prep_field_array(d, k) {
		if(!d[k]) {
			d[k] = [];
		} else if (typeof d[k] == 'string') {
			d[k] = [d[k]];
		}
	}
	prep_field_array(cur, 'f');
	cur.f.push("q_pleading_tag-" + info.query);
	cur.fname_q_pleading_tag = info.name;
	var url = DOCKET_SEARCH_URL(cur);
	// Don't do docket only.
	url = url.replace("/dockets/", "/");
	return url;
}

/**
 * DEPRECATED Function, use get_parser_query, which returns nicer titles.
 */
function get_event_query(is_parser, type, identifier, outcome, date_min, date_max) {
    var base_filter = is_parser ? "parser_obj": "event";
    var type_q = type ? "type:'" + type + "' " : "";
    var ident_q = identifier ? "identifier:'" + identifier + "' " : "";
    var outcome_unknown = outcome == 'unknown';
    var outcome_q = outcome_unknown ? "not outcome:'' ":
        outcome ? "outcome_exact:'" + outcome + "' " : "";

    function fix_d(d) {
        return d && typeof d == 'number'?
            $.datepicker.formatDate('m/d/yy', new Date(d)): d;
    }
    var startd = date_min ? ' date:(from:' + fix_d(date_min) + ")":"";
    var endd = date_max ? ' date:(to:' + fix_d(date_max) + ")":"";

    return base_filter + ":(" + type_q + outcome_q + ident_q + startd + endd + ")"
}

/**
 * Create a histogram that can accept different outcomes.
 * @param $obj
 * @param date_agg
 * @param agg_name
 * @param agg_info
 * @param no_outcomes
 * @param get_url Function that takes in the element, the x pos, and the next x pos.
 */
function render_event_success_histogram($obj, date_agg, agg_name, agg_info, no_outcomes, get_url, q_base_filter) {
	// Show the main chart over time.
	var new_id = uniqueid() + "_Histogram";
	var viewargs = get_viewargs_obj();
	// Don't automatically assume the interval monthly. It's a default.
	var interval = (viewargs && viewargs.interval) || null;
	var date_color_key = agg_info.date_color_key || null;
	var interval_cap = interval ? capitalize(interval) + " to " +
		capitalize(interval): "Date";
	$obj.append(
		"<h3>" + interval_cap + " Histogram</h3>" +
		"<div id='" + new_id +"' class='chart depth_0 histogram'></div>");
	var $histogram = $obj.find(".histogram");

	// click_type must be defined for the onClick method
	var onClick = null, q_key = '';
	if(get_url && (agg_info.click_type || agg_info.click_identifier)) {
		onClick =  function _onClick(d, nextd, i, el) {
			return get_url(el, d.x, nextd ? nextd.x : null);
		}
		q_key = "q_date_" +
			(agg_info.click_type ? "_" + agg_info.click_type.replaceAll(" ", "_") : "") +
			(agg_info.click_identifier ? "_" + agg_info.click_identifier.replaceAll(" ", "_") : "");
	}
	// Add the ability to remove date filters, if there are any.
	function remove_old_filter(frag_obj) {
		if (!frag_obj.f) {
			frag_obj.f = [];
		} else if (!Array.isArray(frag_obj.f)) {
			frag_obj.f = [frag_obj.f];
		}
		var orig_len = frag_obj.f.length;
		// Remove the old facet filters.
		frag_obj.f = frag_obj.f.filter(function (f) {
			return f.split("-")[0] != q_key;
		});
		// Remove the old facet filter name.
		if (frag_obj["fname_" + q_key]) {
			delete frag_obj["fname_" + q_key]
		}
		return frag_obj.f.length < orig_len;
	}
	var xAxis;
	if(no_outcomes) {
		// There are no substantive outcomes for this aggregation.
		var data_series = [{
			// color: 'steelblue',
			className : 'series_1',
			name: agg_info.name,
			data : (date_agg.buckets || []).map(function(b) {
				return { x : b.key/1000, y : b.doc_count };
			})
		}];
		// Instead of displaying stacked time series, display a normal one.
		$histogram.addClass("datehistogram").append("<div class='graph'></div>");
		xAxis = _render_time_series(0, new_id, data_series, onClick, interval);
	} else {
		// Display a stacked histogram that shows all of the different outocmes.
		var has_legend = date_agg.buckets && date_agg.buckets.length > 0 && agg_info.is_parser;
		xAxis = render_stacked_date_histogram(0, agg_name, date_agg, new_id, onClick, interval, date_color_key, has_legend);
		function on_slider_changed(val_min, val_max) {
			var frag_obj = url_params_to_object(get_url_hash());
			var click_type = agg_info.click_type;
			var click_identifier = agg_info.click_identifier
			// Make sure the facet filters are properly setup.
			var had_filter = remove_old_filter(frag_obj);
			var q_sl_key = 'q_slider' + (click_type ? "_" + click_type:"");
			var qfilter = q_sl_key + "-" + q_base_filter + ":(" +
				(click_type ? "type:'" + click_type  + "'" : "") +
				(click_identifier ? "identifier:'" + click_identifier + "'":"") +
				" date:(";
			var qfilter_name = agg_info.name + ":";
			var domain = xAxis.graph.dataDomain();
			if (val_min && (had_filter || val_min != domain[0])) {
				var d = new Date(val_min);
				qfilter += " from:" + $.datepicker.formatDate('m/d/yy', d);
				qfilter_name += " From " + $.datepicker.formatDate('M d, yy', d);
			}
			if (val_max && (had_filter || val_max != domain[1])) {
				var d = new Date(val_max);
				qfilter += " to:" + $.datepicker.formatDate('m/d/yy', d);
				qfilter_name += " To " + $.datepicker.formatDate('M d, yy', d);
			}
			qfilter += "))";
			if (val_min || val_max) {
				frag_obj.f.push(qfilter);
				frag_obj['fname_' + q_sl_key] = qfilter_name;
			}
			var new_hash = "#" + param_query(frag_obj);
			if (window.location.hash != new_hash) {
				window.location.hash = new_hash;
			}
			return false;
		}
		// Add the slider below.
		add_jqueryui_slider_to_graph(new_id, xAxis, null, null, on_slider_changed);
	}
	// Add the interval changer.
	add_date_gap_changer(new_id, xAxis);
	if(remove_old_filter(url_params_to_object(get_url_hash()))) {
		$histogram.find(".clear_date").show();
	}
}

/**
 * Intended for showing whether an event was successful or not.
 * The agg_info structure must specify the following:
 *	claims_grant_name
 *	days_from_name
 *	days_to_name
 *	get_stat
 *	get_stat_filtered
 *  click_searches_dockets Whether clicking on the histograms does a search
 *					for the corresponding documents or the dockets.
 */
function render_event_success(obj_id, agg_info, agg_name, agg, pie_lev,
		omit_histograms, date_agg_key) {
	var $obj = $("#" + obj_id).addClass("eventsuccess");
	// The Main Date Histogram Aggregation
	var date_agg = agg[date_agg_key || 'Date_Histogram'];
	// Protect against no data
	if(!date_agg || !date_agg.buckets) {
		date_agg = {buckets:[]};
	}
	var q_base_filter = agg_info.is_parser ? "parser_obj": "event";
	var HISTOGRAM_INTERVAL_TIMING = 10;
	var HISTOGRAM_INTERVAL_CLAIMS = 2;

	transform_agg(date_agg, agg_info.filter, agg_info.map, agg_info.map_name,
		agg_info.map_className, agg_info.sort_series);

	var cumlative = {};
	var cum_len = 0;
	for(var i in date_agg.buckets) {
		var subagg = _get_sub_agg_from_bucket(date_agg.buckets[i]);
		if(subagg) {
		    cumlative[date_agg.buckets[i].key] = get_totals_and_before(subagg);
		    cum_len += 1;
        }
	}
	// Figure out if there are no substantive outcomes. If so, hide the summary.
	var no_outcomes = !cum_len || (
	    // I am not sure what this old logic is from.
	    date_agg.buckets.length == 1 && date_agg.buckets[0].key === "");
	// Create new cumulative aggregations.
	var agg_before = {
		name 		: 'Trailing Three Months',
		buckets 	: [] ,
		doc_count 	: 0
	};
	var agg_total = {
		name 		: 'Total',
		buckets 	: [],
		doc_count 	: 0
	};
	for(var k in cumlative) {
		// Get the name
		var n = agg_info.map_name({key : k });
		var sn = agg_info.map_short_name({key : k });
		var className = agg_info.map_className ?
					agg_info.map_className({key : k }) : null;
		// Add the key
		agg_total.buckets.push({ key : n, doc_count : cumlative[k].total,
								short_name : sn, className : className  });
		agg_before.buckets.push({key : n, doc_count : cumlative[k].totalbefore,
								short_name : sn, className : className  });
		// Add to the total
		agg_total.doc_count += cumlative[k].total;
		agg_before.doc_count += cumlative[k].totalbefore;
	}

	// Two pie charts, one for total success, and one for trailing.
	var agg_total_name 	=  agg_name + "_Total";
	var agg_before_name =  agg_name + "_Before";

	// I hate rendering html in JS, but it'll do for now.
	$obj.append(
		"<div class='eventsummary'>" +
		"<div class='group'>" +
			"<h3 class=''>For All Time</h3>" +
			"<div class='total subgroup'><h4 class='stat'></h4><p></p></div>" +
			"<div class='subgroup' id='" + agg_total_name +"'></div>" +
		"</div><div class='group'>" +
			"<h3 class=''>Last Three Months</h3>" +
			"<div class='before subgroup'><h4 class='stat'></h4><p></p></div>" +
			"<div class='subgroup' id='" + agg_before_name +"'></div>" +
		"</div></div>");
	// Hide the summary if there's nothing substantive to show.
	if(no_outcomes) {
	    $obj.find(".eventsummary").hide();
    }
	// Show a single statistic in each of the two areas.
	if(agg_info.get_stat) {
		if(agg_total.doc_count > 0) {
			// Show the statistic for the total
			var stat_total 	= agg_info.get_stat(agg_total);
			$obj.find(".total.subgroup")
					.find(".stat").text(agg_total.doc_count > 0 ? stat_total.stat : "No Filings").end()
					.find("p").text(stat_total.p).end()
				.end();
		} else {
			// Handle no data cases gracefully.
			$obj.find(".total.subgroup").addClass("no_filings")
					.find(".stat").html(_render_no_cases()).end()
					.find("p").text("").end();
		}
		if(agg_before.doc_count > 0) {
			// Show the "before" statistic
			var stat_before = agg_info.get_stat(agg_before);
			$obj.find(".before.subgroup")
					.find(".stat").text(stat_before.stat).end()
					.find("p").text(stat_before.p).end();
		} else {
			// Handle no data cases gracefully.
			$obj.find(".before.subgroup").addClass("no_filings")
					.find(".stat").html(_render_no_cases()).end()
					.find("p").text("").end();
		}
	}
	function getURL(el, startd, endd) {
		// Figure out which outcome this element is.
		var click_type = agg_info.click_type;
		var click_identifier = agg_info.click_identifier;

		var outcome = null;
		var outcome_name = null;
		var classList = getClassList(el);
		for (var cls_i = 0; cls_i < classList.length; cls_i++) {
			var c = classList[cls_i];
			if(granted_test(c) || denied_test(c)) {
                // Convert from class to search outcome.
                outcome = c.replaceAll("_", " ");
                outcome_name = capitalize(outcome).replaceAll(" And ", " and ");
                break;
            } else if (agg_info.is_parser && c == "unknown") {
			    outcome = c;
			    outcome_name = capitalize(c);
			    // If they are looking for unknown outcomes, then they're looking for orders.
			    if(!click_type) {
			        click_type = 'order';
                }
			} else if (is_parser_type(c) && agg_info.is_parser && !click_type) {
			    click_type = c;
			} else if (c == "") {
			    // This happens for events without an outcome.
			    outcome_name = agg_info.name;
			    break;
            }
		}

		var base = deparam_url();

		var date_search = '', date_search_nice = '';
		// If we're searching documents, we can set the date filter.
		if(!agg_info.click_searches_dockets) {
			// Set the low date limit.
			base.date_filed_start = startd ? startd/1000 : null;
			if(!base.date_filed_start) delete base.date_filed_start;
			// Set a high date limit if we have one.
			base.date_filed_end = endd ? endd/1000 : null;
			if(!base.date_filed_end) delete base.date_filed_end;
		} else if (startd || endd) {
			// We must do the date search within the query.
			date_search = "date:[" +
				(startd ? startd : "") + "," +
				(endd ? endd-1 : "") + "]";
			date_search_nice =
				(startd ? ", from " + niceDate(startd) : "") +
				(endd ? " to " + niceDate(endd - 1) : "")
		}

		// Add the real query filter.
		if(!base.f) {
			base.f = [];
		} else if (!Array.isArray(base.f)) {
			base.f = [base.f];
		}
		function get_filter_info(outcome) {
		    // Create the search filter.
            var query = get_event_query(agg_info.is_parser, click_type, click_identifier, outcome, startd, endd);
		    var q_name = "q_pie";
		    return {
		        f : q_name + "-" + query,
                name : q_name,
                title : (click_type ? capitalize(click_type) + ": " : "") +
                    (outcome_name ? outcome_name + " " : "") +
                    (click_identifier ? capitalize(click_identifier) + " " : "") +
                    (date_search_nice.length ? ": " + date_search_nice : "")
            }
        }
		var f_info = get_filter_info(outcome);
        base.f.push(f_info.f);
        base['fname_' + f_info.name] = f_info.title;

		// Turn it back into a query url.
		return (agg_info.click_searches_dockets ?
			DOCKET_SEARCH_URL : DOCUMENT_SEARCH_URL)(base);
	}

	// Draw pie charts showing cumulative data.
	pie_lev = pie_lev || 2;
	function getOnClickPieFunc(before) {
		return function (d, i, el) {
			var start_time = null;
			if(before) {
				// Not a real loop, just used to get the first item.
				for(var k in cumlative) {
					start_time = cumlative[k].monthsbefore.getTime();
					break;
				}
			}
			return getURL(el, start_time, null);
		}
	}
	var total_selector = "#" + obj_id + " #" + agg_total_name;
	var before_selector = "#" + obj_id + " #" + agg_before_name;
	setup_pie_chart(pie_lev, agg_total_name, agg_total, total_selector,
											null, getOnClickPieFunc(false));
	setup_pie_chart(pie_lev, agg_before_name, agg_before, before_selector,
											null, getOnClickPieFunc(true));

	if(date_agg.buckets.length) {
		render_event_success_histogram($obj, date_agg, agg_name, agg_info, no_outcomes, getURL, agg_info.is_parser ? "parser_obj": "event");
	}

	// The function that renders the two histograms.
	this.render_histograms = function(compare_agg,
			added_name, added_compare_name) {
		// The two other aggregation.
		_process_and_render_histogram(agg_name, obj_id, agg_info.is_parser,
			agg.Number_of_Claims_Granted,
			obj_id + "_Claims_Histogram",
			"Histogram of " + agg_info.claims_grant_name,
			"Number of " + agg_info.claims_grant_name +
				(compare_agg ? added_name : ""),
			agg_info.claims_grant_name + (compare_agg ? added_name : ""),
			" claims", agg_info.click_type, "claims_num_grant",
			HISTOGRAM_INTERVAL_CLAIMS,
			compare_agg ? compare_agg.Number_of_Claims_Granted : null,
			compare_agg ? ("Number of " + agg_info.claims_grant_name +
				added_compare_name) : null
		);
		_process_and_render_histogram(agg_name, obj_id, agg_info.is_parser,
			agg.Days_from_Filing,
			obj_id + "_Days_Histogram",
			"Time to " + agg_info.days_to_name,
			"Days to " + agg_info.days_to_name + (compare_agg ? added_name : ""),
			"Days from " + agg_info.days_from_name + " to " + agg_info.days_to_name +
				(compare_agg ? added_name : ""),
			"day", agg_info.click_type, "days", HISTOGRAM_INTERVAL_TIMING,
			compare_agg ? compare_agg.Days_from_Filing : null,
			compare_agg ? ("Days to " + agg_info.days_to_name +
				added_compare_name) : null
		);
	};

	// Render the histograms immediately unless we're told otherwise.
	if(!omit_histograms) {
		this.render_histograms();
	}
}

/**
 * Much like the above rendered, but this one handles filtered data and compares
 * it to cumulative data.
 */
function render_filtered_event_success(obj_id, agg_info, agg_name, agg,
		filtered_name, filtered_agg) {
	// The goal is compare the filtered data against the unfiltered data to
	// determine if the event is more or less likely. First we calculate data.
	if(!agg_info.get_stat_filtered) {
		throw "Expecting this aggregation to have a statistic.";
	}

	// The Main Date Histogram Aggregation
	var date_agg = agg['Date_Histogram'];
	var filtered_date_agg = filtered_agg['Date_Histogram'];
	// Caution against these being null
	if(!date_agg || !date_agg.buckets) {
		date_agg = {buckets:[]};
	}
	if(!filtered_date_agg || !filtered_date_agg.buckets) {
		filtered_date_agg = {buckets : []};
	}

	// Get totals for the aggregations
	var cum_agg  = {};
	var cum_filt = {};
	for(var i in date_agg.buckets) {
		var subagg = _get_sub_agg_from_bucket(date_agg.buckets[i]);
		if(subagg) {
		    cum_agg[date_agg.buckets[i].key] = get_totals_and_before(subagg);
        }
	}
	for(i in filtered_date_agg.buckets) {
		var subagg = _get_sub_agg_from_bucket(filtered_date_agg.buckets[i]);
		if(subagg) {
		    cum_filt[filtered_date_agg.buckets[i].key] = get_totals_and_before(subagg);
        }
	}

	// Convert the cumulative and filtered cumulative data into aggregations.
	var cum_agg_total = {
		name 		: 'Cumulative',
		buckets 	: [] ,
		doc_count 	: 0
	};
	var cum_agg_filtered = {
		name 		: 'Filtered',
		buckets 	: [],
		doc_count 	: 0
	};
	for(var k in cum_agg) {
		// Get the name
		var n 	= agg_info.map_name({key : k });
		var sn 	= agg_info.map_short_name({key : k });
		var className = agg_info.map_className ?
					agg_info.map_className({key : k }) : null;
		var cum_filt_total = cum_filt[k] ? cum_filt[k].total : 0;

		// Add the key
		cum_agg_total.buckets.push({ key : n, doc_count : cum_agg[k].total,
								short_name : sn, className : className  });
		cum_agg_filtered.buckets.push({key : n, doc_count : cum_filt_total,
								short_name : sn, className : className  });
		// Add to the total
		cum_agg_total.doc_count 	+= cum_agg[k].total;
		cum_agg_filtered.doc_count 	+= cum_filt_total;
	}
	function format_perc(stat) {
		return (100*stat).toFixed(1) + "%";
	}

	// Show a single statistic in each of the two areas.
	var stat_total 	= agg_info.get_stat_filtered(cum_agg_total);
	var stat_filtered = agg_info.get_stat_filtered(cum_agg_filtered);
	if(stat_total.stat < 0 || stat_total.stat > 1)
		throw "Expecting total statistic to be between 0 and 1";
	if(stat_filtered.stat < 0 || stat_filtered.stat > 1)
		throw "Expecting total statistic to be between 0 and 1";

	// How much more likely is one percentage than the other.
	var likely = stat_total.stat ? stat_filtered.stat / stat_total.stat : 1;
	// This is the odds ratio, but it can be confusing:
	// likely = stat_filtered.stat / (1-stat_filtered.stat) /
	//			( stat_total.stat / (1-stat_total.stat) );

	var more = 1;
	var threshold = .01;
	if(likely < 1) {
		// It is less likely, convert.
		likely = 1/likely;
		more = -1;
	}
	// Subtract 1, because that means they are no more or less likely.
	likely -= 1.0;
	// Convert the percentage to degrees
	var degs = more*90 * (1 - Math.exp(-1 * likely * 4));
	degs += 90; // 90 is the middle.
	degs = degs.toFixed(0);
	// Build a user-friendly text string regarding how likely they are.
	var likely_txt = stat_filtered.stat == null ? "":
			likely < threshold ? "not":
			// If very large, then use English
			likely > 20 ? "much":
			// Use multipliers if greater than 1. We have to add the 1 back in.
			likely > 1 ? (1.0 + likely).toFixed(1).toString() + "x":
			// User percentages if less than 1
			(likely * 100).toFixed(0).toString() + "%";

	// Only say it's more/less likely if we show a figure.
	var more_txt = stat_filtered.stat == null ? "more or less likely" :
		more < 0 && likely > threshold ? "less likely" : "more likely";
	var add_period = "";
	if(filtered_name && filtered_name.length) {
		more_txt = stat_filtered.stat == null ?
			"Cannot form a statistic on whether " + filtered_name + " is " +
			likely_txt + " " + more_txt:
			"Compared to the average, " + filtered_name + " is " +
			likely_txt + " " + more_txt;
		// This is now a complete sentence, so add a period.
		add_period = ".";
	}

	// Create a confidence score using Normal_approximation_interval.
	// See http://en.wikipedia.org/wiki/Binomial_proportion_confidence_interval
	function get_conf(n, p) {
		var z = 1 - .5 * .95;  // 95% confidence level
		// Normal approximation interval
		// var interval = z * Math.sqrt(1/n * p  * (1-p ));
		// Wilson score interval
		return z * Math.sqrt(1/n * p  * (1-p ) + z*z/(4*n*n));
	}
	var plural_cases = plural(2, case_str).toLowerCase();
	var interval = 1 - (1-get_conf(cum_agg_filtered.doc_count, stat_filtered.stat))*
						(1-get_conf(cum_agg_total.doc_count, stat_total.stat));
	// Form the statistic, if possible
	var confidence_txt_maj = stat_filtered.stat == null ?
		"N/A" : "&plusmn;" + format_perc(interval);
	var confidence_txt_min =
		stat_filtered.stat == null ?
			"Too few " + plural_cases + " to form a statistic at all":
		// Wilson score breaks down with too few samples.
		interval*2 >= likely || cum_agg_filtered.doc_count < 10 ?
			"Too few " + plural_cases + " to form a confident statistic":
		interval*1.5 >= likely ?
			"Too few " + plural_cases + " to form a confident statistic":
			"Sufficient " + plural_cases + " to form a confident statistic";

	var user_agg = agg_info.name || agg_name.replaceAll("_", " ");

	// Now start creating the object
	var $obj = $("#" + obj_id).addClass("eventsuccess_filtered");
	$obj.append($(".filtered_event.original").clone().removeClass("original").show());
	$obj
		// .find(".title").text("Summary of " + user_agg + " for " + filter_name).end()
		.find(".title").text("").end()
		// Add a Tool Tip
		.find(".perc").text(likely_txt).powerTip({
            popupClass : 'stats_tip',
        }).data('powertip',
			'<div class="explain"><div class="top">' +
			// Explain the overall statistic.
			(stat_total.stat == null ? "" :
			'Overall: <b>' + format_perc(stat_total.stat) + '</b> &plusmn;' +
				format_perc(get_conf(cum_agg_total.doc_count, stat_total.stat)) +
				'<br>') +
			// Explain the filtered statistic.
			filtered_name + ": " + (stat_filtered.stat == null ?
				'Cannot form a static':
				'<b>' + format_perc(stat_filtered.stat) + '</b> &plusmn;' +
					format_perc(get_conf(cum_agg_filtered.doc_count,
						stat_filtered.stat))) +
			'</div></div>'
			)
			.end()
		.find(".perc_sub").text(more_txt + " " + stat_total.p + add_period).end()

		.find(".total").text(cum_agg_filtered.doc_count.toLocaleString()).end()
		.find(".total_sub").text(user_agg.toLowerCase() + " analyzed" +
            (filtered_name ? " for " + filtered_name : "")).end()

		.find(".conf").html(confidence_txt_maj).end()
		.find(".conf_sub").text(confidence_txt_min).end()

		.find(".busy").text("more likely").end()
		.find(".notbusy").text("less likely").end()

		.find(".needle").css("transform", "rotateZ(" + degs + "deg)");

	if(stat_filtered.stat == null) {
		// If there is no statistic, hide these elemen
		$obj.find(".needle, .busy, .notbusy, .perc_sub, p.error").hide().end()
			.find("img.gauge").addClass("disabled");
	}
	// Render the normal histogram underneath.
	var obj_id_sub = obj_id + "_filtered";
	$obj.find(".filtered_event").append("<div class='eventsuccess_histo' id='" +
											obj_id_sub + "'></div>");
	var evsuccess = new render_event_success(obj_id_sub, agg_info, agg_name,
		filtered_agg, 3, true);
	evsuccess.render_histograms(agg, " for " + filtered_name, " Overall");
	// Do DOM jujitsu: move the summary into eventsuccess_filtered
	$obj.find(".eventsummary").appendTo($obj.find(".group.right .eventsuccess"));
}

/**
 * If we're currently viewing a profile page (party, firm, etc.), return that entity type.
 **/
function get_current_profile_type(base) {
    if(!base) {
        base = deparam_url();
    }
    // Figure out the entity that we're analyzing here.
    var re_base_entity_type = /^([a-z]+)_profile(-|$)/g;
    var entity_type = null;
    if(base.v) {
        entity_type = re_base_entity_type.exec(base.v);
        entity_type = entity_type && entity_type[1]
    }
    if(!entity_type) {
        // Look in the viewarg filters for the any "_exact" queries.
        var entities = base.viewargs.map(function( varg){
            var found = /^([a-z]+)_exact-/.exec(varg);
            return found && found[1];
        }).filter(function (varg) { return varg && varg.length; });
        if(entities.length == 1) {
            entity_type = entities[0];
        }
    }
    // If we can't figure it out from the view, then use the query url.
    if(!entity_type) {
        var p_type = $.deparam(window.location.search.slice(1)).profile_type;
        entity_type = p_type && re_base_entity_type.exec(p_type);
        entity_type = entity_type && entity_type[1];
    }
    return entity_type;
}

function render_top_entity_histogram(obj_id, agg_info, agg_name, agg,
		filtered_name, filtered_agg) {
    if(!agg || !agg.buckets) {
        return;
    }
    // If true, we are looking for entities that don't represent this entity.
    var non_represent = obj_id.search("Nonrepresent") > -1;
    // Show the main chart over time.
    var new_id = obj_id + "Entity_Histogram";
    var $obj = $("#" + obj_id);
    $obj.append("<div id='" + new_id +"' class='chart depth_0'></div>");
    function getURL(entity, startd, endd) {
        var click_type = agg_info.click_type;
		var base = deparam_url();
		var viewargs = get_viewargs_obj();
		var date_search = '';
		// If we're searching documents, we can set the date filter.
        if(startd) {
            date_search += "from:" + niceDate(startd);
        }
        if(endd) {
            if(date_search.length) {
                date_search += " ";
            }
            date_search += "to:" + niceDate(endd);
        }

        var entity_type = get_current_profile_type(base);
        if(entity_type == "party") {
            var base_entity_name = viewargs[entity_type] ||
                viewargs[entity_type + "_exact"];
            base.f = [];
            if(non_represent) {
                base.f.push("q_entity-party:(name:(" + base_entity_name +
                    ") and not firm:(name:(" + entity + "))) and firm:(" + entity + ")");
                base.fname_q_entity = "Party " + base_entity_name +
                    " not represented by " + entity;
            } else {
                base.f.push("q_entity-party:(name:(" + base_entity_name +
                    ") firm:(name:(" + entity + ")))");
                base.fname_q_entity = "Party " + base_entity_name +
                    " represented by " + entity;
            }
        } else if (entity_type) {
            console.warn("Cannot generate link for type: " + entity_type);
        } else {
            console.warn("Cannot determine entity type");
		}
		if(date_search.length) {
		    base.f.push("q_date_range-" + date_search);
        }
		// Turn it back into a query url.
		return DOCKET_SEARCH_URL(base);
    }
    function onClick(d, nextd, i, el) {
        var re_series = /^series-(\d+)$/g;
        var match = re_series.exec(el.classList[0]);
        var series_i = parseInt(match[1]);
        var entity = agg.buckets[series_i].key;
        return getURL(entity, d.x, d.x + 3600*24*365*1000 - 1000);
    }
    var series = agg.buckets.map(function (a, idx) {
        var subagg = _get_sub_agg_from_bucket(a);
        a.className = 'series-' + idx.toString();
        return {
            // color: 'steelblue',
            className: a.className,
            name: a.key,
            data: subagg && subagg.buckets ? subagg.buckets.map(function (b) {
                return {x: b.key / 1000, y: b.doc_count};
            }) : []
        };
    });
    function color_key() {
        return "Set3";
    }
    var xAxis = render_stacked_date_histogram(0, agg_name, agg, new_id,
        onClick, "year", color_key);
    var legend = add_legend_to_graph(xAxis, series);
    // Always put this legend at the bottom
    $(legend.element).addClass("below");
    xAxis.graph.render();
}

/**
 * Custom Aggregation Renderer for Top Players. Agg Info Options
 *   party_types: The types of parties to analyze.
 *	 sub_pane:	Additional event information on each party can be obtained.
 *		event:		The event name in standard english.
 *		event_short	A shorter version of the event name.
 *		aggview:	The aggregation view to obtain the event from the server.
 *		aggkey:		The aggregation key once it is received.
 */
function render_filtered_top_players(obj_id, agg_info, agg_name, agg,
	filtered_name, filtered_agg) {
	////
	// Grab the options
	var party_types = agg_info.party_roles;
	var sub_pane = agg_info.sub_pane || {
		event : "Motion for Joinder",
		event_short : "motion",
		aggview : null, // This is just an example.
		aggkey : "Motion_for_Joinder"
	};
	var filing_str = agg_info.filing_str;

	var key_to_class = {};
	party_types.forEach(function (e) {
		key_to_class[e] = e.toLowerCase().replace(" ", "_");
	});
	if(filtered_agg) {
		// Use the filtered data.
		agg = filtered_agg;
	}
	var $obj = $("#" + obj_id).addClass("top_players");
	// Remove assignees
	function filter_party_types(buckets) {
		return buckets ? buckets.filter(function (it) {
			return party_types.indexOf(it.key) != -1;
		}) : null;
	}

	// Render tables of top parties
	$obj.append("<div class='parties'>" + party_types.map(function (p) {
		return "<div class='party " + key_to_class[p] + "'>" +
			"<div class='table'></div><div class='info'></div></div>";
		}).join("") + "</div>" +
		"<h2 class='graph_title'>Law Firms for Top Parties</h2>" +
		"<div class='firms'>" + party_types.map(function (p) {
			return "<div class='party " + key_to_class[p] + "'><h3>Representing " +
				plural(2, p) + "</h3></div>";
		}).join("") + "</div>"
	);

	/**
	 * A few utility functions to help manipulate URLs
	 **/
	function val_to_id(val) {
		// Convert val into html-friendly id, replace all non alpha-nums.
		return val.replaceAll(" ", "_").replace(/[^a-z0-9_]+|\s+/gmi, "");
	}
	function add_party_to_q(cur, party, role) {
		if(!cur.f) {
			cur.f = [];
		} else if (!Array.isArray(cur.f)) {
			cur.f = [cur.f];
		}
		if(role) {
		    // Needs updating since #2178.
		    console.warn("party_w_type_exact not supported");
			cur.f.push("party_w_type_exact-" + party + " # " + role);
		} else {
			cur.f.push("party_exact-" + party);
		}
		return cur;
	}
	function add_outcome_to_q(cur, event, grant, deny, grantdeny) {
		if(!cur.f) {
			cur.f = [];
		} else if (!Array.isArray(cur.f)) {
			cur.f = [cur.f];
		}
		var use_or = ((grant?1:0) + (deny?1:0) + (grantdeny?1:0)) > 1;
		var f = (use_or ? "outcome_exact_or-": "outcome_exact-") + event + " - ";
		if (grant) {
			cur.f.push(f + "Granted");
		}
		if (deny) {
			cur.f.push(f + "Denied");
		}
		if (grant) {
			cur.f.push(f + "Granted and Denied");
		}
		return cur;
	}
	function get_search_party_url(party, role) {
		return DOCKET_SEARCH_URL(add_party_to_q(
			deparam_url(), party, role));
	}
	function get_search_event_url(party, role, event, grant, deny, grantdeny) {
		return DOCUMENT_SEARCH_URL(add_party_to_q(
				add_outcome_to_q(deparam_url(), event,
				grant, deny, grantdeny), party, role));
	}
	function plural_events(n) {
		return "<em>" + plural_n(n, sub_pane.event_short) + " " +
			plural_have(n) + "</em>";
	}

	/**
	 * Setup the party information on the right of the screen.
	 **/
	function setup_party_info($info, party_name, role,
			party_info, party_role_info) {
		if(!party_name) {
			$info.removeClass("loading").html("<h3>Party Information</h3>" +
				"<p class='empty'>Click on a party to the left to " +
				"see their statistics.</p>");
			return;
		}
		$info.removeClass("loading").html(
			"<h3>" + party_name + "</h3>" +
			"<a class='full_report'>View Full Report</a>" +
			"<div class='sec small preference'><h4>Party Preference</h4>" +
				"<div class='val'></div><p></p></div>" +
			"<div class='sec small inst_rate'><h4>" + sub_pane.event + " Rate</h4>" +
				"<div class='val'></div><p></p></div>" +
			"<div class='sec big'><h4>Recent Cases</h4>" +
				"<ul></ul><a class='all_cases'>View All Cases</a></div>");

		// Setup the list of most recent cases.
		var lis = "";
		var results = party_role_info.search_results;
		for(var j=0; j < results.length; j++) {
			lis += "<li><a href='" + results[j].internal_link + "'>" +
				results[j].title + "</a></li>";
		}
		// Get URL for the full list of info.
		var full_url = get_search_party_url(party_name, role);
		var $ul = $info.find(".sec.big")
			.find("h4").text("Recent Cases as " + role).end()
			.find("ul").append(lis).end()
			.find(".all_cases").attr("href", full_url);

		if(party_info) {
			// Get the top party type info.
			var role_buckets = party_info.aggs.Party_Roles ?
				filter_and_combine_subbuckets(
					party_info.aggs.Party_Roles.buckets, party_name) : null;
			if(role_buckets && role_buckets.Party_Roles &&
				role_buckets.Party_Roles.buckets) {
				role_buckets = filter_party_types(role_buckets.Party_Roles.buckets);
			}

			// Figure out their party type preference.
			if (role_buckets && role_buckets.length) {
				var preference = role_buckets[0].key;
				var num_total = sum_doc_counts(role_buckets);
				var percent = 100 * role_buckets[0].doc_count / num_total;
				percent = roundNumber(percent, 1); // Round to one decimal.

				var explain = "";
				if(filtered_name) {
					explain = "In cases with " + filtered_name + ", " + party_name +
						" acts as " + preference + " <em>" + percent + "%</em> of the time.";
				} else {
					explain = party_name + " acts as " + preference + " in <em>" +
						percent + "%</em> of cases.";
				}

				// Add a link to the other cases.
				if (role_buckets[0].doc_count != num_total && role_buckets.length > 1) {
					var other_url = get_search_party_url(party_name, role_buckets[1].key);
					explain += " View the <a href='" + other_url + "'>" +
						(num_total - role_buckets[0].doc_count) + " other cases</a>.";
				}
				$info.find(".preference")
					.removeClass("loading")
					.find(".val").text(preference).end()
					.find("p").html(explain);
			} else {
				$info.find(".preference")
					.removeClass("loading")
					.find(".val").text("N/A").end()
					.find("p").text("Not enough data to calculate preferred party role.");
			}
		} else {
			// party_info is still loading
			$info.find(".preference")
					.addClass("loading")
					.find("p").html("Additional information on this party is loading.");
		}

		// Figure out the institution rate
		var inst_buckets = party_role_info.aggs[sub_pane.aggkey] &&
											party_role_info.aggs[sub_pane.aggkey].buckets ?
			party_role_info.aggs[sub_pane.aggkey].buckets : [];
		if(inst_buckets.length) {
			var granted = get_granted_total(inst_buckets, true);
			var denied = get_denied_total(inst_buckets, false);
			var inst_percent = 100 * granted / (granted + denied);
			inst_percent = roundNumber(inst_percent, 1); // Round to one decimal

			var grant_url = get_search_event_url(party_name, role, sub_pane.event,
				true, false, true);
			var deny_url = get_search_event_url(party_name, role, sub_pane.event,
				false, true, false);
			// Add the start about the filter.
			var inst_explain = "<a href='" + grant_url + "'>" +
                    plural_events(granted) +
					"</a> been granted and <a href='" + deny_url +"'>" +
					plural_events(denied) + "</a> been denied in cases " +
					(filtered_name ? ("with " + filtered_name + " and "): "") +
					"where " + party_name + " is " + role + ".";
			$info.find(".inst_rate")
				.find(".val").text(inst_percent + "%").end()
				.find("p").html(inst_explain);
		} else {
			$info.find(".inst_rate")
				.find(".val").text("N/A").end()
				.find("p").text("Not enough data to calculate institution rate.");
		}
	}

	function setup_party_type(a, $table, $info, $firm_info) {
		var subagg = _get_sub_agg_from_bucket(a);
		var buckets = subagg.buckets;
		// Setup the table of parties
		setup_bar_table({
			$obj : $table,
			cols : [
				{text:a.key},
				{text:"No. " + capitalize(plural(2, filing_str)),
					range:[0, buckets[0].doc_count]}
			],
			hide_export : true,
			num_rows : buckets.length,
			num_rows_displayed : 10,
			// We need a closure so that the agg name is within scope.
			get_row : function(j) {
				return [
					{text:buckets[j].key, 'class':'key'},
					{val:buckets[j].doc_count, 'class':'val'}
				];
			},

			clicked : function (row, key, event) {
				var filter = add_party_to_q(deparam_url(),
											buckets[row].key, a.key);
				filter.limit = 7;
				$info.html("loading<br><img alt='throbber' class='loader' " +
					"src='/site_media/img/loader-big.svg'>").addClass("loading");

				get_json_results({
					requests : [
					// Do not filter by role to determine the party roles.
					{
						views : ["Party_Roles"],
						filter : add_party_to_q(deparam_url(),
											buckets[row].key)
					},
					// Filter the results by party role as well to determine success rate.
					{
						views : [sub_pane.aggview],
						filter : filter
					}],
					on_success : function on_render(results) {
						setup_party_info($info, buckets[row].key, a.key,
							results[0], results[1]);
					},
					on_finished_request : function (i, response) {
						if(i === 1) {
							setup_party_info($info, buckets[row].key, a.key, null, response);
						}
					},
					on_fail :  function () {

					}
				});
			}
		});
		// When we start, we have no party info, so give it null;
		setup_party_info($info);

		function quote(q) {
			return q.search(" ") >= 0 ? '"' + q + '"' : q;
		}
		function get_firm_click(party, party_type) {
			return function (d, i, el) {
				if (!d || !d.data || !d.data.k || d.data.k == "Other") {
					return null;
				}
				var cur = deparam_url();
				cur.q = (cur.q && cur.q.length ? cur.q + " AND " : "") +
					"party_obj:(name:" + quote(party) + " type:" + quote(party_type) +
					" firm.name:" + quote(d.data.k) + ")";
				return DOCKET_SEARCH_URL(cur);
			}
		}

		for(var j in buckets) {
			// Get the firms representing this party
			var firmssubagg = _get_sub_agg_from_bucket(buckets[j]);
			// We don't always know the firms, so this can be null
			if(firmssubagg && firmssubagg.buckets && firmssubagg.buckets.length) {
				// Insert a pie chart of firms representing those parties
				var pie_id = obj_id + "_" + val_to_id(a.key) + "_" +
								val_to_id(subagg.buckets[j].key);
				// Add the item
				$firm_info.append("<div class='pie_firm'>" +
					"<h4>" + truncate(subagg.buckets[j].key, 12) + "</h4>" +
					"<div id='" + pie_id + "' class='chart'></div>" +
					"</div>");
				// Provide the overall doc count so we can include "other"
				firmssubagg.doc_count = subagg.buckets[j].doc_count;
				setup_pie_chart(2, "fiz", firmssubagg, "#" + pie_id, null,
					get_firm_click(subagg.buckets[j].key, a.key));
			}
		}
	}

	var $parties 	= $obj.find(".parties");
	var $firms 		= $obj.find(".firms");
	var po_pet_parties = filter_party_types(agg.buckets);
	for(var i in po_pet_parties) {
		var a = po_pet_parties[i];
		var $party = $parties.find(".party." + key_to_class[a.key]);
		// For the pie charts of firms representing those parties
		var $firm = $firms.find(" ." + key_to_class[a.key]);
		setup_party_type(a, $party.find(".table"), $party.find(".info"), $firm);
	}

}

/**
 * Returns a function that truncates the main key appropriately in barCharts
 */
function truncate_key_reports_func(range, $table) {
	var DO_TRUNCATE = false;
	var NAME_MAX_WIDTH = Math.min($table.width()/3, 400);
	var NAME_MIN_WIDTH = 120;

	// Create the function we use to truncate.
	return function truncated_key(key, doc_count) {
		if(!DO_TRUNCATE) {
			return key;
		}
		var doc_perc = (doc_count - range[0]) / (range[1] - range[0]);
		return truncate_by_width(key,
				Math.max(NAME_MIN_WIDTH, doc_perc*NAME_MAX_WIDTH), "11pt", true);
	}
}

function event_powertip(e, rates) {
	// Put together powertip text based on the outcome of a particular event.
	var dec = e.full.toLowerCase();
	if (!(/(decision|opinion|judgment)$/i).test(dec)) {
		dec += " decision"
	}
	var being_granted = e.resulted_in || (
		" being granted" + (e.partial_counts ? " in full or part" : ""));
	var tip_sentence = e.powertip ? e.powertip(rates):
				rates && rates.total ? ("Out of " + plural_n(rates.total, dec) + ", " +
					rates.granted + " resulted in " + being_granted + "."):
				"No " + plural(0, dec) + ".";
	return wrap_html(e.full, "div", "xval") +
		wrap_html(tip_sentence, "div", "yval");
}

/**
 * Return a row of checkboxes, based on the given array.
 * @param txt_checked 	An array of 5-arrays:
 * [0] the text of the checkbox
 * [1] a bool if it's checked.
 * [2] The viewargs attribute
 * [3] Value to set set viewargs to if checked.
 *         If null: remove the viewarg attribute when checked, and set to false when unchecked.
 * [4] Tooltip.
 **/
function get_checkbox_viewargs_row(txt_checked, parent_id) {
    // Parent id is just used to de-dup IDs, not really needed.
    if(!parent_id) {
        parent_id = uniqueid();
    }
    var all_are_show = txt_checked.every(function (chk_array) {
        return chk_array[0].startsWith("Show ")
    });
    var remove_show = all_are_show && txt_checked.length > 2;

    var $html = join_jquery(txt_checked.map(function (chk_array) {
		var txt = chk_array[0], is_checked = chk_array[1];
		// We generate the key from the text.
		var key = txt.toLowerCase().replaceAll(/[\s/]+/ig, "_");
		var full_id = key + "_" + parent_id;
		var label_data = chk_array.length < 5 ? {} : {
		    powertip : chk_array[4]
		};
		if(remove_show) {
		    txt = txt.replace(/^Show /, "");
        }
		var label = wrap_html(txt, "label", null, label_data, { 'for' : full_id });
		return "<input type='checkbox' " + (is_checked ? "checked" : "") +
			" class='" + key + "' id='" + full_id + "'>" + label;
	}), "options", "div");

    // We removed the word "show", add it back to the front.
    if(remove_show) {
        $html.prepend(wrap_html("Show: ", "span", "show_msg"));
    }

	// Now add click handlers.
	var url_hash = get_url_hash();
	var viewargs = get_viewargs_obj(url_hash);
	txt_checked.forEach(function (chk_array) {
		// We generate the key from the text.
		var key = chk_array[0].toLowerCase().replaceAll(/[\s/]+/ig, "_");
		var viewargs_key = chk_array[2], viewargs_def = chk_array[3];
		$html.find("." + key).click(function () {
			if ($(this).is(":checked")) {
			    if(viewargs_def === null) {
			        delete viewargs[viewargs_key];
                } else {
				    viewargs[viewargs_key] = viewargs_def;
                }
			} else if(viewargs_def === null) {
                viewargs[viewargs_key] = 'false';
            } else if(viewargs[viewargs_key]) {
                delete viewargs[viewargs_key];
            }
			// Setup the current viewargs
			var cur = deparam_url(url_hash);
			cur.viewargs = args_obj_to_args_ar(viewargs);
			window.location.hash = "#" + param_query(cur);
			return false;
		}).end()
        .find("[data-powertip]").powerTip({
            smartPlacement : true,
            popupClass : 'small_powertip'
        });
	});

	return $html;
}

function get_sort_func(name, case_str_plural, mid_columns, events,
	needs_cases) {
	switch(name) {
		case 'No. ' + case_str_plural + ' Ascending':
		case 'No. ' + case_str_plural + ' Descending':
			return {
				get_key : needs_cases ?
					function (o) { return o.Cases.doc_count; }:
					function (o) { return o.doc_count; },
				reverse : name.endsWith('Descending')
			};
		case 'Name Ascending':
		case 'Name Descending':
			return {
				get_key : function (o) { return o.key.toLowerCase(); },
				reverse : name.endsWith('Descending')
			};
		case 'Law Firm Gender Ascending':
		case 'Law Firm Gender Descending':
			return {
				get_key : function (b) {
					var total = b.male.value + b.female.value;
					return total ? b.female.value / total : -1;
				},
				reverse : name.endsWith('Descending')
			};
		case 'Top Courts Ascending':
		case 'Top Courts Descending':
			return  {
				get_key : function (b) {
					var bcourts = (b.Cases && b.Cases.Courts) || b.Courts;
					return bcourts && bcourts.buckets ? bcourts.buckets[0].key : "";
				},
				reverse : name.endsWith('Descending')
			}
		case 'Cases Ascending':
		case 'Cases Descending':
			return  {
				get_key : function (b) {
					return b.Cases ? b.Cases.doc_count : b.doc_count || -1;
				},
				reverse : name.endsWith('Descending')
			}

	}

	// Handle middle columns.
	for(var i = 0; i < mid_columns.length; i++) {
		var h = mid_columns[i].header;
		if(name.startsWith(h)) {
			return {
				get_key : mid_columns[i].get_key,
				reverse : name.endsWith('Descending')
			};
		}
	}
	var percentile_search = /^(\d+)[a-z]+\s+Perc(\.|entile)\s+(Ascending|Descending)$/;

	// Handle sorting of all of legacy events and parser identifier events.
    var get_item = needs_cases ?
        function(o) { return o.Cases; } : function(o) { return o; };
	for(i = 0; i < events.length; i++) {
		const e = events[i];
		const e_key = e.key;
		if(name.startsWith(e.abrev + " Rate")) {
            // Handle sorting rates.
            return {
                get_key: function _get_rate_sort_key(o) {
                    var o_ag = get_item(o);
                    if (!o_ag.doc_count) {
                        return -1;
                    }
                    var exist_rate = uses_existance_rates(o_ag[e_key],
                        o_ag.doc_count);
                    if (exist_rate && exist_rate.rate !== undefined) {
                        return exist_rate.rate;
                    }
                    var rate = get_grant_rates(o_ag[e_key], e.partial_counts);
                    // Make the total a tie breaker.
                    return 1e7 * rate.granted_rate + rate.total;
                },
                reverse: name.endsWith('Descending')
            };
        } else if(name.startsWith(e.full + " Grant Rate")) {
            return {
                get_key : function (o) {
                    var outcomes = o[e.key] && o[e.key].outcomes;
                    if(!outcomes) {
                        return -1;
                    }
                    var rates = get_grant_rates(outcomes, e.partial_counts);
                    return rates.granted_rate;
                },
                reverse: name.endsWith('Descending')
            }
		} else if(name.startsWith('Days to ' + (e.abrev || '')) ||
			(name.search(/→ Decision/) >= 0) && e.type == 'order' ||
			(name.search(/→ Motion/) >= 0) && e.type == 'order') {
            // Handle sorting # of days.
		    return {
				get_key : function _get_days_sort_key(o) {
				    var o_ag = get_item(o);
				    if(!o_ag.doc_count) {
				        return -3;
                    }
				    var e_agg = o_ag[e_key] || o[e_key];
				    if(!e_agg) {
				        return -2;
                    }
				    var stats = e_agg.stats || e_agg.timing_stats;
				    return stats && stats.avg ? stats.avg: -1;
				},
				reverse : name.endsWith('Descending')
			}
		} else if(name.search(percentile_search) >= 0 && e.type == 'order') {
            var perc_key = name.match(percentile_search)[1] + ".0";
		    return {
				get_key : function _get_days_sort_key(o) {
				    var o_ag = get_item(o);
				    if(!o_ag.doc_count) {
				        return -3;
                    }
				    var e_agg = o_ag[e_key] || o[e_key];
				    if(!e_agg) {
				        return -2;
                    }
				    var all_percs = e_agg.timing_percentiles && e_agg.timing_percentiles.values;
				    if(!all_percs) {
				        return -1;
					}
				    var perc_val  = all_percs && all_percs[perc_key];
				    return perc_val || 0;
				},
				reverse : name.endsWith('Descending')
			}
		} else if(name.startsWith(e.full)) {
		    return {
		        get_key : function _get_count_key(o) {
		            var o_ag = get_item(o);
		            var e_agg = o_ag[e_key] || o[e_key];
		            return e_agg.count ? e_agg.doc_count : 0;
                },
                reverse : name.endsWith('Descending')
            }
        }
	}
	console.warn("No sort handler for: " + name);
	return { get_key : null, reverse : false };
}

/**
 * Given the party roles in the aggregation, and all party roles, return a
 * column in bar chart that is suitable for drawing. */
function get_party_percental_column(Party_Roles, set_roles, tipPrefix,
	requires_unnest) {
	function getcount(x) {
		if(requires_unnest && x.count && !x.sub.Cases) {
			console.warn("No Cases to unnest.");
			return x.count;
		}
		// Use the unnested Cases sub-aggregation if we have it, even if not required.
		return x.sub && x.sub.Cases ? x.sub.Cases.doc_count : x.count || 0;
	}
    // Convert the role names to keys.
	var role_key = set_roles.map(val_to_key);
	var case_str_lower = case_str.toLowerCase();
	// Get the party role.
	var b_role = agg_to_dict(Party_Roles, set_roles);
	var sum_roles = role_key.reduce(function (sum, role) {
		return sum + getcount(b_role[role])}, 0);
	if (sum_roles == 0){
	    // No party role information.
        return {
			perc : 0, 'class':'perc',
			text: get_perc_text(role_perc, set_roles[0], set_roles[1], false),
			powertip: "No party roles were identified."

		};
    } else if (role_key.length == 2) {
		// When there are two roles, we show the percentage.
		var role_perc = (getcount(b_role[role_key[0]])) / sum_roles;
		var lis = role_key.map(function (r, r_i) {
			var count = getcount(b_role[r]);
			if(!count) {
				return "";
			}
			var role = wrap_html(set_roles[r_i],"span","key");
			var val = wrap_html(count, "span", "value") + " " + plural(count, case_str_lower);
			return wrap_html(val + " as " + role, "li");
		});
		var ul = wrap_html(lis.join(""), "ul")
		return {
			perc : role_perc, 'class':'perc',
			text: get_perc_text(role_perc, set_roles[0], set_roles[1], false),
			powertip: wrap_html(tipPrefix || 'Party Roles', "div", "xval") +
				wrap_html(ul, "div", "yval")


		};
	} else if(role_key.length && Party_Roles &&
            (Party_Roles.buckets || []).length) {
		// There are more than two party types, a percentage is too simple.
		var maxkey = val_to_key(Party_Roles.buckets[0].key);
		var count = getcount(b_role[maxkey]);
		if(role_key.indexOf(maxkey) == -1) {
			// The party role may not be in the list of
			sum_roles += count;
		}
		// Get the percentage of the most common type.
		var role_perc = count / sum_roles;
		return {
			perc2 : role_perc,
			text: get_perc_text(role_perc, Party_Roles.buckets[0].key,
				'Not ' + Party_Roles.buckets[0].key, false),
			// Return a list of all of the non-zero types.
			powertip: top_entities_powertip(tipPrefix || 'Party Roles', Party_Roles.buckets),
		};
	} else {
		return {};
	}
}

/**
 * Return a column to go into a bar chart that formats a case type. However,
 * by changing parameters, it can be suitable for other data as well
 * @param list_several 	If true, then list several of the case types, otherwise
						just list the most popular one.
 * @param k 			The aggregation key to use, defaults to Case_Type
 * @param header		The header or title of the column, default to Case Type.
 * @param klass			Class to the surrounding td cell to change styling.
 **/
function get_case_type_column(list_several, k, header, klass) {
	if(!k) {
		k = 'Case_Type'
	}
	if(!header) {
		header = 'Case Type'
	}
	var case_str_lower = case_str.toLowerCase();
	return {
		header : header,
		get_row : function _getrow(b) {
			var key = b.key;
			// Get the top tech center.
			if(b.Cases) {
				b = b.Cases;
			}
			var buckets = b[k] && b[k].buckets;
			if(!buckets || !buckets.length) {
				return list_several ? {
					class : klass || '',
					list_perc : [],
					powertip: 'No ' + case_str_lower + 's.'
				} : {
					class : klass || '',
					perc2 : 0,
					text : '',
					powertip: 'No ' + case_str_lower + 's.'
				};
			}
			var total = b[k].doc_count;
			if(list_several) {
				buckets.forEach(function (item) {
					item.perc = item.doc_count / total;
				});
				// List the top items.
				return {
					class : klass || '',
					list_perc : buckets,
					powertip: top_entities_powertip(plural(2, header), buckets),
				};
			} else {
				var top_case = buckets[0];
				var perc = top_case.doc_count / total;
				var ptip = top_case.key + 's constitute ' + roundNumber(perc*100) +
							'% of ' + key + "&rsquo;s " + case_str_lower + "s.";
				// Get any extra case types.
				var extra_buck = buckets.slice(1).filter(function(ct) {
					return ct.doc_count > 0;
				});
				if(extra_buck.length > 0) {
					ptip += " In addition, " + extra_buck.map(function (ct) {
						return get_perc_text(ct.doc_count / total,
							' are ' + ct.key + 's', '', false);
					}).join(", ") + ".";
				}
				return {
					class : klass || '',
					perc2 : perc,
					text: get_perc_text(perc, top_case.key, '', false),
					powertip: ptip,
				};
			}
		},
		get_key : function _get_key(o) {
				if(o.Cases) {
					o = o.Cases || {};
				}
				o = o[k];
				// Return the greatest percentage of cases.
				return o.doc_count && o.buckets.length ?
					o.buckets[0].doc_count / o.doc_count : 0;
		}
	};
}

/**
 * Generate a nice tooltip for law firm gender information. It can be confusing.
 **/
function law_firm_gender_tip(b) {
    var tip= "";
    if(b) {
        var total = b.male.value + b.female.value;
        tip += total ? "<h3>Gender Identification of Attorney First Names</h3>" :
            "<p>No identified attorney genders.</p>";
        tip += "<ul>";
        if(total) {
            if(b.male.value) {
                tip += "<li>Male Identifying: " + number_with_commas(b.male.value) +  " attorney cases</li>";
            }
            if(b.female.value) {
                tip += "<li>Female Identifying: " + number_with_commas(b.female.value) +  " attorney cases</li>";
            }
        }
        if(b.unknown_gender.value) {
            tip += "<li>Unknown: " + number_with_commas(b.unknown_gender.value) +
                " attorney cases</li>";
        }
        tip += "</ul>";
    }
    tip += "<h3>How Firm Gender is Counted</h3>" +
        "<p>We analyze the first name of attorneys that make an appearance " +
            "and classify each as male identifying, female identifying, or unknown. " +
        "Determining gender identification based on first name is imperfect, but " +
        "can still provide meaningful diversity insights.</p>" +
        "<p>Gender is counted when an attorney makes a notice of appearance " +
        "for each party. If one attorney represents multiple parties in a " +
        "single case, they will be counted multiple times.</p>";
    return "<div class='gender_tip'>" + tip + "</div>";
}
function unknown_outcome_tip() {
    return wrap_html("Unknown Outcomes", "h3") +
    wrap_html("Unknown outcomes occur when we identify an order on a docket " +
        "sheet, but the docket text is ambiguous as to whether it was granted or denied.", "p");
}
var bartable_defaults = {
	default_row : function default_row(b, row_min_width, row_0_max_width, trunc_key) {
		var bsub_doc_count = (b.Cases ? b.Cases : b).doc_count;
		var bcount_str = number_with_commas(bsub_doc_count);
		var babrev_str = number_with_abbrev(bsub_doc_count);
		return [{
			val: bsub_doc_count,
			min_width: row_min_width,
			max_width : row_0_max_width,
			text : "<span class='name'>" + trunc_key(b.key, bsub_doc_count) +
					"</span>",
			'class':'val',
			// powertip: wrap_html(b.key, "div", "xval") + wrap_html(bcount_str, "div", "yval")
		}];
	},

	/**
	 * Internal bar table function. Given a list of event aggregations, return the
	 * column names and export column names that will go into the bar table.
	 * @param first_b
	 * @param events
	 * @returns {{all: *[], columns: *[], export_columns: *[]}}
	 */
	default_event_cols : function default_event_cols(first_b, events) {
		// Get the first bucket's total doc count.
		var first_doc_count = (first_b.Cases || first_b).doc_count;
		var all_events_custom_cols = [];

		// Do some basic checks on this structure that is used to get more columns
		// for each event.
		function check_custom_event_structure(s) {
			if(!s) {
				return;
			}
			if(!s.get_columns || !s.get_cells) {
				console.error("No get_columns or cells functions.");
			}
			if(!s.get_export_cells || !s.get_export_columns) {
				console.warn("No export columns or cells.");
			}
		}

		var export_columns = [];
		var columns = [];
		for(var e_i = 0; e_i < events.length; e_i++) {
			var e = events[e_i];
			// Get the event in the first bucket item. We need a sample to create columns
			var first_e_val = first_b[e.key] || (first_b.Cases && first_b.Cases[e.key]);
			var custom_event_columns = e.custom_columns && e.custom_columns(e, first_b, first_e_val);
			check_custom_event_structure(custom_event_columns);

			all_events_custom_cols.push(custom_event_columns);
			if(!first_e_val) {
				console.warn("Could not find event key: " + e.key);
				continue;
			}
			var ev_full = e.full || e.abrev;
			// show_rate defaults to true, so make sure it isn't false
			if(e.show_rate !== false) {
				var rate_abrev = (e.abrev || '') + " Rate";
				columns.push({
					text: rate_abrev,
					sort:[rate_abrev + ' Ascending', rate_abrev + ' Descending']
				});
				var exist_rates = uses_existance_rates(first_e_val, first_doc_count);
				if(exist_rates) {
					export_columns.push(ev_full);
					export_columns.push(ev_full + " Rate");
				} else {
					// And the total granted.
					export_columns.push(ev_full + (e.partial_counts ?
						" Granted": " Granted in Full"));
					// And the total overall.
					export_columns.push(ev_full + " Total");
					// We'll insert the rate.
					export_columns.push(ev_full + " Rate");
				}
			}
			if(custom_event_columns) {
				columns = columns.concat(custom_event_columns.get_columns());
				export_columns = export_columns.concat(custom_event_columns.get_export_columns());
			}
			if(e.show_outcome) {
				if(!first_e_val.outcomes && !first_e_val.outcome) {
					console.warn("No outcome data for " + e.key);
				} else {
					var rate_abrev = ev_full + " Grant Rate";
					columns.push({
						text : e.abrev +" Outcome",
						sort:[rate_abrev + ' Ascending', rate_abrev + ' Descending']
					});
				}
			}
		}
		return {
			columns : columns,
			export_columns:export_columns,
			all:all_events_custom_cols
		}
	},

	/**
	 * Given a bucket and the event aggregations
	 * @param b Data bucket
	 * @param events event aggregations.
	 * @param event_cols
	 * @param bucket_to_url A function that turns a bucket into a URL.
	 * @returns {*[]}
	 */
	default_event_rows : function default_event_rows(b, events, event_cols, bucket_to_url) {
		var row = [];
		var total_count = (b.Cases || b).doc_count
		// Get their event rate.
		for(var e_i = 0; e_i < events.length; e_i++) {
			const e = events[e_i];
			var custom_event_columns = event_cols.all[e_i];
			var e_ag = b[e.key] || (b.Cases ? b.Cases[e.key] : null);
			if(!e_ag){
				continue;
			}
			// show_rate defaults to true, so make sure it isn't false
			if(e.show_rate !== false) {
				var exist_rates = uses_existance_rates(e_ag, total_count);
				if (exist_rates && exist_rates.rate !== undefined) {
					// We're measuring how often this event occurs in the case.
					row.push({
						gauge: exist_rates.rate,
						gauge_count : exist_rates.count,
						'class': 'gauge',
						powertip: exist_rates.exists + " of " +
							plural_n(e_ag.doc_count, " have " + e.full)
					});
				} else {
					// We're measuring how often the event is granted when it
					// occurs in the case.
					var grant_rates = get_grant_rates(e_ag, e.partial_counts);
					row.push({
						gauge: grant_rates.total == 0 ? null : grant_rates.granted_rate,
						'class': 'gauge',
						powertip: event_powertip(e, grant_rates)
					});
				}
			}
			if(custom_event_columns) {
				row = row.concat(custom_event_columns.get_cells(b, e_ag, filing_str));
			}
			if(e.show_outcome) {
				var $obj = $("<div class=pie></div>");
				if(e.map_outcome && e_ag.outcomes && e_ag.outcomes.buckets) {
					e_ag.outcomes.buckets.forEach(function (b) {
						b.outcome = b.key;
						b.short_name = e.map_outcome(b.key);
						b.className = b.key.replaceAll(/[\s/]/ig, "_");
						b.k = b.short_name;
					});
				}
				var rates = get_grant_rates(e_ag.outcomes, e.partial_counts);
				var rate_html = wrap_html(rates.granted_rate ?
					get_perc_text(rates.granted_rate, "granted", null, false):"",
					"span", "granted_rate");
				// Get the URL of the outcome.
				var bucket_url = bucket_to_url ? bucket_to_url(b) : null;
				// Remove the initial hash/query.
				var bucket_params = bucket_url ? bucket_url.slice(1) : null;

				function get_event_pie_url(slice, index, el) {
					// Generate the new URL from the bucket URL, adding the outcome.
					var base = deparam_url(bucket_params);
					// Get the outcome, not sure why there are two ways of getting it.
					var data_outcome = slice.data.outcome || slice.data.k;
					// Figure out which outcome this element is.
					var q = get_event_query(e.is_parser, e.type, e.identifier, data_outcome);
					base.fname_q_outcome = "Outcome: " + slice.data.short_name;
					if(!base.f) {
						base.f = [];
					} else if (!Array.isArray(base.f)) {
						base.f = [base.f];
					}
					base.f.push("q_outcome-" + q);
					return DOCKET_SEARCH_URL(base);
				}
				if(e_ag.outcomes) {
					setup_pie_chart(8, e.abrev, e_ag.outcomes, $obj, 0, get_event_pie_url);
				}
				$obj.append(rate_html);

				row.push({
					jquery : $obj,
					'class' : 'jquery',
				});
			}
		}
		return row;
	}
}

/**
 * The bar tables are all quite similar and are defined by their mid_columns
 * and events. This function takes many of these common inputs and builds the
 * structure that will be passed to the more general bar table.
 * @param $obj Location of the bar table.
 * @param case_str What to call a row of data cases/orders.
 * @param buckets
 * @param mid_columns List of internal columns to show.
 * @param events List of events to show.
 * @param bucket_to_url A function that takes a bucket and returns a click URL.
 */
function default_bar_table_options($obj, case_str, buckets, mid_columns, events, bucket_to_url) {
	var $table = $obj.find(".table");

	// Get min/max ranges. We cannot assume the data is sorted.
	var num_range = [null, null];
	for(var i=0; i < buckets.length; i++) {
		var val = buckets[i].Cases ?
			buckets[i].Cases.doc_count : buckets[i].doc_count;
		 if(num_range[0] === null || val < num_range[0]) {
			num_range[0] = val;
		 }
		 if(num_range[1] === null || val > num_range[1]) {
			num_range[1] = val;
		 }
	}
	// If no data, then provide dummy ranges.
	if(!num_range[0]) {
		num_range = [0, 10];
	}

	var trunc_key = truncate_key_reports_func(num_range, $table);
	var case_str_plural = plural(2, case_str);

	// Use this function to determine if the mid_column was already added.
	var top_name = $obj.attr('id').replaceAll("_", " ");
	function mid_column_exists(header) {
		if(top_name == header) {
			// If the entire table is based on this column, don't insert it.
			return true;
		}
		return mid_columns.some(function(c) { return c.header == header});
	}

	////////////////
	// Setup capabilities for this bar table, the "has" field stores capabilities.
	var has = {};

	// Add the courts column if we have one.
	has.courts = buckets.some(function (b) {
		return (b.Cases && b.Cases.Courts) || b.Courts;
	});
	if(has.courts && !mid_column_exists('Top Courts')) {
		mid_columns.push({
			header:'Top Courts',
			get_row : function (b) {
				// Handle both nested and unnested cases.
				var bcourts = (b.Cases && b.Cases.Courts) || b.Courts;
				return bcourts && bcourts.buckets ? {
					list : bcourts.buckets,
					'class' : 'list',
					// Top Courts are always done on a case level.
					powertip: top_entities_powertip("Courts", bcourts.buckets, 'case')
				} : null;
			},
			get_key : function (b) {
				var bcourts = (b.Cases && b.Cases.Courts) || b.Courts;
				return bcourts && bcourts.buckets ? bcourts.buckets[0].key : "";
			}
		});
	}
	// Add a law firm gender column, if we have one.
	has.case_length = buckets.some(function (b) {
		return (b.Cases && b.Cases.Case_Length) || b.Case_Length;
	});
	if(has.case_length && !mid_column_exists('Case Length')) {
		function days_to_str(num_days, abbrev) {
			var num_year = Math.floor(num_days / 365);
			var num_day = Math.round(num_days % 365);
			return (num_year ? plural_n(num_year, abbrev ? "yr" : "year") + " " : "") +
				plural_n(num_day, abbrev ? "dy" : "day");
		}

		mid_columns.push({
			header:'Case Length',
			get_row : function (b) {
				// Handle both nested and unnested cases.
				var blen = (b.Cases && b.Cases.Case_Length) || b.Case_Length;
				if(!blen.count){
					return { class : "stat nodata", exported : '', text : "No data" };
				}
				return {
					class : 'stat',
					exported : Math.round(blen.avg),
					text : days_to_str(blen.avg) + (blen.std_deviation ?
						"<br><span class='stddev'>&plusmn; " +
							days_to_str(blen.std_deviation, true) + "</span>": ""),
					powertip: "Case Length Statistics:<ul>" +
						"<li><span class='key'>Analyzed</span>: " +
							number_with_commas(blen.count) + "" +
						"<li><span class='key'>Average</span>: " +
							days_to_str(blen.avg) + "" +
						"</li><li><span class='key'>Maximum</span>: " +
							days_to_str(blen.max) +
						"</li><li><span class='key'>Minimum</span>: " +
							days_to_str(blen.min) +
						"</li><li><span class='key'>Std. Dev.</span>: " +
							days_to_str(blen.std_deviation) +
						"</li></ul>"
				};
			},
			get_key : function (b) {
				var blen = (b.Cases && b.Cases.Case_Length) || b.Case_Length;
				return (blen && blen.avg) || -1;
			}
		});
	}

	// Add Case_Type column if we have one.
	has.casetype = buckets.some(function (b) {
		return (b.Cases && b.Cases.Case_Type) || b.Case_Type;
	});
	if(has.casetype && !mid_column_exists('Case Type')) {
		mid_columns.push(get_case_type_column(true));
	}
	// Add Tag column if we have one.
	has.casetag = buckets.some(function (b) {
		return (b.Cases && b.Cases.Case_Tag) || b.Case_Tag;
	});
	if(has.casetag && !mid_column_exists('Tags')) {
		mid_columns.push(get_case_type_column(true,
			'Case_Tag', 'Tags'));
	}
	// Add Case_Status column if we have one.
	has.casestatus = buckets.some(function (b) {
		return (b.Cases && b.Cases.Case_Status) || b.Case_Status;
	});
	if(has.casestatus && !mid_column_exists('Case Status')) {
		mid_columns.push(get_case_type_column(true,
			'Case_Status', 'Case Status', 'alt'));
	}
	// Add a law firm gender column, if we have one.
	has.gender = buckets.some(function (b) {
		return b.male || b.female || b.unknown;
	});
	if (has.gender) {
		mid_columns.push({
			header : "Law Firm Gender",
			get_row : function(b) {
				// Get the top clients.
				var total = b.male.value + b.female.value;
				var perc_gender = total ? b.female.value / total : null;
				var values = [{x:'Female', y:b.female.value},
                    {x:'Male', y:b.male.value},
                    {x:'Unknown', y:b.unknown_gender.value}]
				return {
					linear_pie : values,
					'class':'alt', // Adding "alt" makes it a different color.
					text: get_perc_text(perc_gender, "Female", 'Male', false),
				    // Generate a nice tooltip to ease possible confusion.
					powertip: law_firm_gender_tip(b)
				};
			},
			get_key : function (b) {
				var total = b.male.value + b.female.value;
				return total ? b.female.value / total : -1;
			}
		});
	}
	// If one of our events is a parser event.
	has.parser_events = events.some(function (ev) {
		return ev.is_parser;
	});


	////////////////
	// Build the columns, a list of dictionaries.
	var columns = [];
	var export_columns = [];

	// Normally we show the middle columns, then the events.
	// With parser tags, we reverse that.
	var middle_cols_then_events = !has.parser_events;

	// Show basic column info, but not when displaying parser events. This
	// needs to be changed to check only when we're filtering on a parser events.
	var show_basic_count = !has.parser_events;
	if(show_basic_count) {
		columns.push({
			text: "No. of " + case_str_plural, range: num_range,
			sort: ['No. ' + case_str_plural + ' Descending',
				'No. ' + case_str_plural + ' Ascending',
				'Name Ascending', 'Name Descending']
		});
		export_columns = ['Name', 'No. of ' + case_str_plural];
	}
    ////////////
	// Add the event columns.
	var event_cols = bartable_defaults.default_event_cols(buckets[0], events);
	if(!middle_cols_then_events) {
		columns = columns.concat(event_cols.columns);
		export_columns = export_columns.concat(event_cols.export_columns)
	}
	// Add the mid_columns
	for(var i = 0; i < mid_columns.length; i++) {
		var h = mid_columns[i].header;
		columns.push({ text: h, sort:[h + ' Ascending', h + ' Descending'] });
		export_columns.push(h);
	}
	if(middle_cols_then_events) {
		columns = columns.concat(event_cols.columns);
		export_columns = export_columns.concat(event_cols.export_columns)
	}

	var bartable_title = $obj.find(".graph_title").clone()
		.find(".filter_list, .export, .options, .link-view-text, .motion_chooser_btn, .view_all_stats")
			.remove().end().text();
	var bartable_subtitle = $obj.find(".graph_title .filter_list").text();

	var row_min_width = Math.min($table.width() / columns.length, 155);
	var row_0_max_width =
        (columns.length < 2 ? .95:
        columns.length < 3 ? .5:
        columns.length < 5 ? .4:
        columns.length < 6 ? .37 :
        .33) * $table.width();
	return {
		$obj : $table,
		cols : columns,
		title : bartable_title,
		subtitle : bartable_subtitle,

		num_rows : buckets.length,
		load_more : get_load_more_url(buckets.length),
		$export_btn : $obj.find(".export"),

		// We need a closure so that the agg name is within scope.
		get_row : function _default_get_row(j) {
			var b = buckets[j];
			var row = [];

			// Add the basic information.
			if(show_basic_count) {
				row = row.concat(bartable_defaults.default_row(b, row_min_width, row_0_max_width, trunc_key));
			}

			// Get the middle columns.
			var middle_cols = mid_columns.map(function (m) { return m.get_row(b); })
			// The event columns.
			var event_rows = bartable_defaults.default_event_rows(b, events, event_cols, bucket_to_url);
			// Add them teogether properly.
			row = middle_cols_then_events ?
				row.concat(middle_cols, event_rows):
				row.concat(event_rows, middle_cols);

			return row;
		},

		cols_export : export_columns,
		get_row_export : function (j) {
			var b = buckets[j];
			var bsub_doc_count = (b.Cases ? b.Cases : b).doc_count;
			// Add the basic information.
			var row = show_basic_count ? [b.key, bsub_doc_count] : [];
			// Get the middle columns.
			for(var i = 0; i < mid_columns.length; i++) {
				var mid = mid_columns[i].get_row(b);
				// This is a bit of guesswork as to what we end up exporting.
				row.push(mid.exported !== undefined ? mid.exported:
					mid.perc !== undefined ? {type: 'percent', value: mid.perc}:
					mid.val != undefined ? mid.val:
					mid.list != undefined ? mid.list.map(
						function (f) { return f.key; }).join(", "):
					mid.text ? mid.text.replaceAll("&amp;", "&"):
					'');
			}
			// Export event data to a table.
			for(var e_i = 0; e_i < events.length; e_i++) {
                var e = events[e_i];
                var e_ag = b[e.key] || (b.Cases ? b.Cases[e.key] : null);
                var custom_event_columns = event_cols.all[e_i];
                // show_rate defaults to true, so make sure it isn't false
		        if(e.show_rate !== false) {
                    var exist_rates = uses_existance_rates(e_ag, bsub_doc_count);
                    if (exist_rates) {
                        row.push(exist_rates.exists);
                        row.push({type: 'percent', value: exist_rates.rate});
                    } else {
                        var rates = get_grant_rates(e_ag, e.partial_counts);
                        row.push(rates.total ? rates.granted : '');
                        row.push(rates.total);
                        row.push({type: 'percent', value: (rates.total ? rates.granted_rate : '')});
                    }
                }
                if(custom_event_columns) {
					row = row.concat(custom_event_columns.get_export_cells(e_ag));
				}
			}
			return row;
		}
	};
}

/**
 * Render text and url based on the key
 **/
function render_link_to_view(agg_info_key) {
    var cur_hash = url_params_to_object(get_url_hash());
    var params = {
        // Keep the query the same
        q: cur_hash.q,
        /// Keep all the filters the same too.
        f: cur_hash.f,
        // The view arguments (the little checkboxes), should also stay the same.
        viewargs: cur_hash.viewargs,
    };
    // Certain views have a "v" profiel that has more options.
	var views_to_v = {
		Top_Law_Firms: 'firms',
		Top_Attorneys: 'attorneys',
		Top_Parties : 'parties',
		Top_Judges: 'judges',
		Top_Courts: 'courts',
		Top_Case_Types: 'case_types',
		Top_Classes: 'classes',
		Top_Tags: 'tags',
		Top_Patents: 'patents',
	}[agg_info_key];
	if(views_to_v) {
		params.v = views_to_v;
	} else {
		params.views = agg_info_key
	}

    if("embed" in cur_hash) {
        params.embed = undefined; // Doesn't need a real value, undefined okay.
    }
    // Generate a new URL.
    var $link = '#' + $.param(params, true);
    // Generate the HTML from the link.
    return "<a href=" + $link + " class='link-view' target='_blank'>" +
        // A nice little icon.
        wrap_html("", "i", stats_views_globals.view_only_icon) +
        // A message to the user.
        "<span class='link-view-text'>View only this report</span></a>";
}

/**
 * If there are no aggregations, return some html to show the user, or
 * optionally append it to an object.
 **/
function _render_no_cases(agg, $obj) {
	if(agg && agg.buckets && agg.buckets.length) {
		return false;
	}
	var html = "<div class='nocases'>No " + plural(2, case_str).toLowerCase() +
		".</div>";
	if($obj)
		$obj.append(html);
	return html;
}

function _get_viewargs_identifiers(viewargs) {
    if(!viewargs) {
        viewargs = get_viewargs_obj(null, true);
    }
    var output = {
        identifiers: viewargs.event_identifier,
        types : viewargs.event_type,
        // Identifier list is null until it's filled, or error is set.
        identifier_list : null,
    };
    if(viewargs.event_identifier && viewargs.event_identifier.length) {
        // Get the full identifier list, not just those matching the type.
        static_identifier_list('priority', null,
            function _done(identifier_list) {
                output.identifier_list = identifier_list;
            },
            function _error(error) {
                output.error = error;
                console.warn("Identifier list error: " + error);
            },
            true);
    }
    return output;
}

function get_identifier_bar_table_info(e, first_bucket, first_event_val) {
	if(!e.is_parser || !first_event_val) {
		return null;
	}
	var viewargs = get_viewargs_obj() || {};
	var options = parser_stats_utils.stats_row_timing_type_options();
	var timing_key = viewargs.stats_row_timing_type || parser_stats_utils.timing_defaults.row;
	var timing_name = options[timing_key];
	if(!timing_name) {
		console.warn("Unknown timing key: " + timing_key);
	}
	var has = {
		percentiles : first_event_val.timing_percentiles && first_event_val.timing_percentiles.values
	}
	return {
		get_columns : function get_columns() {
			// Put the columns into the correct format.
			function str_to_col(h) {
				return { text: h, sort:[h + ' Ascending', h + ' Descending'] };
			}
			var orders = str_to_col('Orders');
			orders.range = [0, first_event_val.doc_count];
			var cols = [orders, str_to_col('Cases with Order')];
			if(has.percentiles) {
				cols.push(str_to_col("25th Perc."));
				cols.push(str_to_col(timing_name));
				cols.push(str_to_col("75th Perc."));
			} else {
				cols.push(str_to_col(timing_name));
			}
			return cols;
		},
		get_cells : function get_cells(bucket, e_ag, filing_str) {
			var cells = [];

			// Create a basic count HTML.
			var order_count = e_ag.doc_count || 0;
			var case_count = e_ag.cases ? e_ag.cases.doc_count : null;
			var order_count_html = wrap_html(bucket.key, "div", "name");
			var case_count_html = wrap_html(plural_n(case_count, "case"), "div", "cases");
			var case_with_motion = wrap_html("Cases with Motion: " + wrap_html(plural_n(bucket.doc_count, "case"), "span", "value"), "div");
			var order_x_val = wrap_html(e.full + "<br>" + order_count_html, "div", "xval");
			var order_y_val = wrap_html(order_count == 0 ?
					"No Orders." + case_with_motion +
					wrap_html("Appears because motions exist.", "div", "notes"):
					"Order Count: " + wrap_html(number_with_commas(order_count), "span", "value") +
					wrap_html("Cases with Orders: " + wrap_html(plural_n(case_count, "case"), "span", "value"), "div") +
					case_with_motion, "div", "yval");
			var order_tip =  order_x_val + order_y_val;

			cells.push({
				val : order_count,
				text : order_count_html,
				min_width: 150,
				max_width : 400,
				'class' : 'val',
				powertip: order_tip,
			});
			cells.push({
				text : case_count_html,
				'class' : 'cases',
				powertip: order_tip,
			});

			var stats = e_ag.timing_stats || {};
			var timing_html = stats.count ?
				wrap_html(stats.avg.toFixed(0), "div", "value") +
					wrap_html("days avg.", "span", "msg"):
				wrap_html("", "span", "no_results");
			var percentiles = e_ag.timing_percentiles && e_ag.timing_percentiles.values;
			var tip = '';
			if(stats.count) {
				tip += order_x_val +
					wrap_html("Average: " + stats.avg.toFixed(0) + " days" +
						wrap_html("across " + wrap_html(plural_n(stats.count, filing_str), "em"), "div", "notes"), "div", "yval");
				if(stats.min || stats.max) {
					tip += wrap_html("Range: " + plural_n(stats.min, "day") + " minimum to " + stats.max + " days max", "div", "compare");
				}
				if(percentiles) {
					tip += wrap_html("Middle 50% Range: " + percentiles["25.0"].toFixed(0) + " to " + percentiles["75.0"].toFixed(0) + " days", "div", "compare");
				}
				if(stats.std_deviation) {
					tip += wrap_html("Std. Dev.: " + stats.std_deviation.toFixed(0) + " days", "div", "compare");
				}
			} else {
				tip = event_powertip(e, {total:0});
			}
			if(has.percentiles) {
				cells.push(percentiles ? {
					'class': 'average',
					powertip: tip,
					text : wrap_html(percentiles["25.0"].toFixed(0), "div", "value") +
						wrap_html("days 25th", "span", "msg"),
				} : {'class':'average', text:"-"});
			}
			cells.push({
				'class': 'average',
				text : timing_html,
				exists : stats.count,
				powertip: tip
			});
			if(has.percentiles) {
				cells.push(percentiles ? {
					'class': 'average',
					powertip: tip,
					text : wrap_html(percentiles["75.0"].toFixed(0), "div", "value") +
						wrap_html("days 75th", "span", "msg"),
				} : {'class':'average', text:"-"});
			}
			return cells;
		},
		get_export_columns : function () {
		    var cols = [
		    	"Orders", "Cases with Order",
				timing_name + " Num Motions",
		    	timing_name + " Avg Days",
				timing_name + " Min Days",
				timing_name + " Max Days"];
		    if(has.percentiles) {
		    	cols.push("25th Perc.");
				cols.push("75th Perc.");
			}
		    return cols;
		},
		get_export_cells : function get_export_cells(e_ag) {
			var order_count = e_ag.doc_count || 0;
			var case_count = e_ag.cases ? e_ag.cases.doc_count : '';

			var stats = e_ag.timing_stats;
			var cells = [order_count, case_count, stats.count, stats.avg, stats.min, stats.max];
			if(has.percentiles) {
				var percentiles = e_ag.timing_percentiles && e_ag.timing_percentiles.values;
				cells.push(percentiles["25.0"]);
				cells.push(percentiles["75.0"]);
			}
			return cells;
		}
	}
}
/**
 * Convert a parser info structure into an event structure that can be fed into
 * default_bar_table_options, and then eventually into the bar table.
 * Provides a higher level interface than going into the bar table itself.
 **/
function _identifier_info_to_event(identifier_info, types) {
    var p = identifier_info;
    if(types) {
        console.warn("Nothing really implemented with types.");
    }
    var key = (types && types.length == 1 ? types[0] : "") + "_" + p.identifier;
    return [{
        // User readable name of the parser aggretaion.
        name: p.name,
        type : "motion",
        identifier : p.identifier,
        // The key into the aggregation results so we can find the data.
        key: "motion_" + p.identifier,
        // Not sure about this one.
        full: p.name,
        // Use the full name even for the abbreviation.
        abrev: p.abrev || p.name,
        // Rate name is used in sentences like "The [__] rate is 32%."
        rate_name: p.name,
		custom_columns : get_identifier_bar_table_info,
        show_rate: false,
        // TODO: To get clicking to work, we need to refactor all of the
        //  query_type / click_type code.
        query_type: p.identifier,
        is_parser: true,
        days_from_name: "Case Filing",
    },{
        // User readable name of the parser aggregation.
        name: p.name,
        type : "order",
        identifier : p.identifier,
        // The key into the aggregation results, so we can find the data.
        key: "order_" + p.identifier,
        // Not sure about this one.
        full: "Order on " + p.name,
        // Abbrevited name of the aggregation.
        abrev: (p.abrev || p.name_display || p.name) + " Order",
        // Rate name is used in sentences like "The [__] rate is 32%."
        rate_name: p.name,
        custom_columns : get_identifier_bar_table_info,
        show_rate: false,
        show_outcome: true,
        map_outcome : function (k) {
            return capitalize(k);
        },
        // TODO: To get clicking to work, we need to refactor all of the
        //  query_type / click_type code.
        query_type: p.identifier,
        is_parser: true,
        days_from_name: "Case Filing",
    }];
}
function _identifier_list_to_event_list(identifier_infos, types) {
    return identifier_infos.map(function (info) {
        return _identifier_info_to_event(info, types);
    }).flat();
}

/**
 * Create a common powertip for a given set of entities.
 * @param entity_name The entity being counted.
 * @param entities Aggregation of entities.
 * @param case_s The types of things being counted, cases, orders, etc.
 * @returns {string}
 */
function top_entities_powertip(entity_name, entities, case_s) {
	if(!case_s) {
		case_s = case_str.toLowerCase();
	}
	var lis = entities.map(function (l, i) {
		if(!l.doc_count) {
			return "";
		}
		var val = wrap_html(number_with_commas(l.doc_count), "span", "value") +
			plural(l.doc_count, " " + case_s);
		return wrap_html(wrap_html(l.key, "span", "key") + ": " + val, "li");
	});
	// Use the xval and yval which has better CSS styling.
	return wrap_html(entity_name, "div", "xval") +
		wrap_html(lis.join(""), "ul", "yval");
}

function get_default_case_str(agg_info, has) {
	if(has.identifier && (!agg_info.case_str || agg_info.case_str == case_str)) {
		return "Order";
	} else {
		return agg_info.case_str || case_str || "Case";
	}
}


/**
 * Generate a list of top anything. The anything must be a field in the top
 * level mapping of the index. Allowed agg_info options:
 * 	case_str	What to call the cases (e.g., case, proceeding, etc.)
 * 	events		A list of case event dictionaries in the table.
 *	mid_columns	Any additional columns to put into the table.
 *
 * @param filter_term The filter that you are using.
 * @param top_class Optional class used for custom styling.
 * @param table_class Optional class used for
 * @param allow a dictionary in the form {
 *  gender:bool, // Add a gender analytics checkbox.
 *  top_parties:bool, // Add a top parties checkbox
 *  top_firms:bool // Add a top law firms checkbox.
 * }
 */
function render_top_terms(obj_id, agg_info, agg_name, agg,
                          filter_term, top_class, table_class, profile_name,
                          suggest_term, suggest_title, val_to_query,
                          allow) {
	if(!top_class) {
		top_class = "top_entities";
	}
	if(!table_class) {
		table_class = "entities_full";
	}
    // Default settings for the special checkboxes.
	if(!allow) { allow = {} }
	if(allow.gender === undefined) { allow.gender = true; }
	if(allow.top_parties === undefined) { allow.top_parties = true; }
	if(allow.top_firms === undefined) { allow.top_firms = true; }

    // Create copies of the array so we don't change it.
	var mid_columns = (agg_info.mid_columns || []).slice(0);
	var events = (agg_info.events || []).slice(0);

	var $obj = $("#" + obj_id).addClass(top_class);
	if(_render_no_cases(agg, $obj)) {
		return;
	}

    var identifier_viewargs = _get_viewargs_identifiers();
	var viewargs = get_viewargs_obj();
    // Look at the first bucket to see what aggregations we have selected.
    var b1 = agg.buckets && agg.buckets.length ? agg.buckets[0] : {};
    var has = {
        gender: (b1.male || b1.female || b1.unknown) ? true:false,
        top_parties: b1.Parties ? true:false,
        top_firms: b1.Firms ? true:false,
        identifier: identifier_viewargs && identifier_viewargs.identifiers &&
            identifier_viewargs.identifiers.length > 0,
        unknown_outcomes : viewargs.unknown_outcomes == undefined,
		include_percentiles : viewargs.include_percentiles,
    };
    var case_str = get_default_case_str(agg_info, has);
	var check_options = [];
	if(allow.top_parties || has.top_parties) {
	    check_options.push(["Show Parties", has.top_parties, "max_parties", 3]);
    }
	if(allow.top_firms || has.top_firms) {
	    check_options.push(["Show Firms", has.top_firms, "max_firms", 3]);
    }
	if(allow.gender || has.gender) {
        // Show gender analytics option link.
        var gender_desc = filter_term && filter_term.startsWith("judge") ?
            "Show Attorney Gender" : "Show Law Firm Gender";
        check_options.push([gender_desc, has.gender, "gender", "true", law_firm_gender_tip()]);
    }
	if(has.identifier) {
		check_options.push(["Show Unknown Outcomes", has.unknown_outcomes,
			"unknown_outcomes", null, unknown_outcome_tip()]);
		check_options.push(["Show Percentiles", has.include_percentiles,
			"include_percentiles", "true", "Show 25th and 75th percentile."]);
	}

	var $check_options = get_checkbox_viewargs_row(check_options, obj_id);

	// Add the dropdown too.
	if(has.identifier) {
	    var $timing_dropdown = parser_stats_utils.stats_row_timing_type_dropdown(viewargs.stats_row_timing_type);
	    $check_options.append($timing_dropdown)
    }

	$obj.find(".graph_title").append("<div class='export'>Export</div>")
			.append($check_options).end()
		.append("<div class='" + table_class + "'><div class='table'></div></div>")
		.find("." + table_class + " .table");

	// Render two tables of top parties
	if(suggest_term) {
		$obj.find(".graph_title")
				.append(suggest_bar_html(suggest_title || "Search"));
		suggest_bar_setup($obj, suggest_term);
	} else {
		$obj.find(".graph_title").addClass("no_suggest");
	}

	// Top clients take a while to calculate and are not always available.
	if(has.top_parties) {
		// Implment the top clients as a mid column. Concat so we don't mutate.
		mid_columns = mid_columns.concat([{
			header : "Top Parties",
			get_row : function(b) {
				// Get the top clients.
				var parties = b.Parties && b.Parties.buckets ?
					b.Parties.buckets.slice(0, 10) : [];
				// Sort by the number of cases, not # of representations.
				sortByKey(parties, function (p) { return p.doc_count}, true);
				return {
					list : parties,
					'class':'list',
					powertip: top_entities_powertip("Clients", parties, case_str)
				};
			},
			get_key : function (b) {
				var party = b.Parties && b.Parties.buckets ?
					b.Parties.buckets[0] : null;
				return party ? party.key : '';
			}

		}]);
	}
	if(has.top_firms) {
		// Implment the top clients as a mid column. Concat so we don't mutate.
		mid_columns = mid_columns.concat([{
			header : "Top Firms",
			get_row : function(b) {
				// Get the top clients.
				var firms = b.Firms && b.Firms.buckets ?
					correct_edit_distance_subbuckets(
						b.Firms.buckets).slice(0, 10) : [];
				// Sort by the number of cases, not # of representations.
				sortByKey(firms, function (p) { return p.doc_count}, true);
				return {
					list : firms,
					'class':'list',
					powertip: top_entities_powertip("Firms", firms, case_str)
				};
			},
			get_key : function (b) {
				var party = b.Firms && b.Firms.buckets ?
					b.Firms.buckets[0] : null;
				return party ? party.key : '';
			}
		}]);
	}
	if(has.identifier && identifier_viewargs.identifier_list) {
        // Get all of the information on the active identifiers
	    var active_identifier_info = identifier_viewargs.identifier_list.filter(function f_id(info) {
            return identifier_viewargs.identifiers.indexOf(info.identifier) != -1;
        });
	    events = events.concat(_identifier_list_to_event_list(active_identifier_info, identifier_viewargs.types));
    }
	function bucket_to_url(b) {
		 var filter_val = val_to_query ? val_to_query(b.key) : b.key;
	    return "#" + get_filtered_view_url(filter_term,
			filter_val, profile_name, ["max_entities=20"]);
	}
	var options = default_bar_table_options($obj, case_str, agg.buckets,
		mid_columns, events, bucket_to_url);
	options.sort = function (name) {
		var sorter = get_sort_func(name, plural(2, case_str), mid_columns,
			events, false);
		if(!sorter.get_key) {
			show_error_usermsg("Cannot currently sort by: " + name)
		} else {
			sortByKey(agg.buckets, sorter.get_key, sorter.reverse);
		}
	};
	options.clicked = profile_name ? function (row, key, event) {
	    var new_hash = bucket_to_url(agg.buckets[row]);
		if(window.location.hash == new_hash) {
			show_error_usermsg("Already viewing " + agg.buckets[row].key);
		} else {
			open_url(new_hash, true);
		}
	} : null;
	setup_bar_table(options);
}

/**
 * Generate a list of top judges. Allowed agg_info options:
 * 	case_str	What to call the cases (e.g., case, proceeding, etc.)
 * 	events		A list of case event dictionaries in the table.
 *	mid_columns	Any additional columns to put into the table.
 */
function render_top_judges(obj_id, agg_info, agg_name, agg) {
	// Use our generic "top" list generator.
	render_top_terms(obj_id, agg_info, agg_name, agg,
		// Add Judge specific options.
		"judge_exact", "top_judges", "judges_full", "judge_profile",
		"judge", "Search for a Judge");
}

function render_top_case_types(obj_id, agg_info, agg_name, agg) {
	// Use our generic "top" list generator.
	render_top_terms(obj_id, agg_info, agg_name, agg,
        'fact',  // filter_term
        null,  // top_class: for custom css styling
        null, // table_class: for custom css styling
        "case_type_profile", // has_profile: If the user can click on it.
        null, // suggest_term
        null, // suggest_title
        function _(v) { // val_to_query
	        return 'type:"Case Type" value:("' + v + '")'
        }
    );
}
function render_top_classes(obj_id, agg_info, agg_name, agg) {
	// Use our generic "top" list generator.
	render_top_terms(obj_id, agg_info, agg_name, agg,
        'fact',  // filter_term
        null,  // top_class: for custom css styling
        null, // table_class: for custom css styling
        "classes_profile", // has_profile: If the user can click on it.
        null, // suggest_term
        null, // suggest_title
        function _(v) { // val_to_query
	        return 'type:"Class" value:("' + v + '")'
        }
    );
}

function render_top_roles(obj_id, agg_info, agg_name, agg) {
	// Use our generic "top" list generator.
	render_top_terms(obj_id, agg_info, agg_name, agg,
        'party.type',  // filter_term
        null,  // top_class: for custom css styling
        null, // table_class: for custom css styling
        null, // has_profile: If the user can click on it.
        null, // suggest_term
        null, // suggest_title
        function _(v) { // val_to_query
	        return 'party:(type:("' + v + '")'
        }
    );
}

function render_top_courts(obj_id, agg_info, agg_name, agg) {
	// Use our generic "top" list generator.
	render_top_terms(obj_id, agg_info, agg_name, agg, "court_exact",
		null, null, "court_profile");
}

function render_top_tags(obj_id, agg_info, agg_name, agg) {
	// Use our generic "top" list generator.
	render_top_terms(obj_id, agg_info, agg_name, agg, "tag_exact",
		null, null, "tags_profile");
}
function render_top_patents(obj_id, agg_info, agg_name, agg) {
    render_top_terms(obj_id, agg_info, agg_name, agg,
        'patent',  // filter_term
        null,  // top_class: for custom css styling
        null, // table_class: for custom css styling
        "patent_profile", // has_profile: If the user can click on it.
        "patent", // suggest_term
        null, // suggest_title
        null, // val_to_query
        {gender:false, top_parties:true, top_firms:true}
    );
}

/**
 * Generate a list of top parties. Allowed agg_info options:
 *	set_roles The roles of the parties that should be analyzed.
 * 	case_str	What to call the cases (e.g., case, proceeding, etc.)
 * 	events		A list of case event dictionaries in the table.
 *	mid_columns	Any additional columns to put into the table.
 */
function render_top_parties(obj_id, agg_info, agg_name, agg) {
	var events = agg_info.events || [];
	var mid_columns = agg_info.mid_columns || [];
	// What type of profile should we link to when the user clicks on a link.
	var profile_agg = agg_info.profile_agg || "party_profile";

	var $obj = $("#" + obj_id).addClass("top_parties");
	if(_render_no_cases(agg, $obj)) {
		return;
	}
	var buckets = agg.buckets;
    var viewargs = get_viewargs_obj();
    var identifier_viewargs = _get_viewargs_identifiers();
	// Figure out what features we will show:
	var has = {
	    // Column on list of top firms.
	    top_firms : (buckets || []).some(function (b) {
            return b.Law_Firms && b.Law_Firms.buckets && b.Law_Firms.buckets.length;
        }),
        // Gender analytics column
        gender : (buckets || []).some(function (b) {
            return b.male || b.female || b.unknown;
        }),
        // Party roles column
        proles : !viewargs.party_type_exact &&
            buckets.some(function (b) { return b.Party_Roles; }),
        // Top case types column
        casetype : buckets.some(function (b) { return b.Case_Type; }),
        // Identifier column
        identifier: identifier_viewargs && identifier_viewargs.identifiers &&
            identifier_viewargs.identifiers.length > 0,
        unknown_outcomes : viewargs.unknown_outcomes == undefined,
    };
	var case_str = get_default_case_str(agg_info, has);
    var set_roles = agg_info.set_roles;
	if(!set_roles || !set_roles.length) {
	    // Generate the roles from the buckets.
        var set_roles_dict = {};
        buckets.forEach(function (b) {
            (b.Party_Roles.buckets || []).forEach(function (r){
                set_roles_dict[r.key] = true;
            });
        });
        set_roles = [];
        for(var r_k in set_roles_dict) {
            set_roles.push(r_k);
        }
    }
	var check_options = [["Show Firms", has.top_firms, "max_firms", 3],
		["Show Law Firm Gender", has.gender, "gender", "true", law_firm_gender_tip()]];

	if(has.identifier) {
	    check_options.push(["Show Unknown Outcomes", has.unknown_outcomes,
            "unknown_outcomes", null, unknown_outcome_tip()]);
    }

	$obj.find(".graph_title")
			.append(get_checkbox_viewargs_row(check_options, obj_id))
			.append(suggest_bar_html("Search for a Party"))
			.append("<div class='export'>Export</div>").end()
		.append("<div class='parties_full'><div class='table'></div></div>")
		.find(".parties_full .table");
	suggest_bar_setup($obj, "party");

	// If we have Party Roles, then add it as a standard middle column.
    // If the exact party type is specified, then don't display it.
	mid_columns = (has.proles ? [{
		header : "Party Type",
		get_row : function (b) {
			return get_party_percental_column(b.Party_Roles, set_roles);
		},
		get_key : function (b) {
			return get_party_percental_column(b.Party_Roles, set_roles).perc;
		}
	}] : [])
	.concat(has.casetype ? [get_case_type_column()] : [])
	.concat(mid_columns);

	if(has.top_firms) {
		mid_columns = mid_columns.concat([{
			header : "Top Law Firms",
			get_row : function (b) {
				var law_firms = b.Law_Firms && b.Law_Firms.buckets ?
					b.Law_Firms.buckets.slice(0, 3) : [];
				return {
					list : law_firms, 'class':'list',
					powertip:top_entities_powertip("Law Firms", law_firms, case_str)
				};
			},
			get_key : function(b) {
				var law_firm = b.Law_Firms && b.Law_Firms.buckets ?
					b.Law_Firms.buckets[0] : null;
				return law_firm ? law_firm.key : '';
			}
		}]);
	}
	// Remove events which do not exist in the data itself.
	events = events.filter(function (e) {
		return buckets && buckets.some(function(b) { return b[e.key] });
	});

	if(has.identifier && identifier_viewargs.identifier_list) {
        // Get all of the information on the active identifiers
	    var active_identifier_info = identifier_viewargs.identifier_list.filter(function f_id(info) {
            return identifier_viewargs.identifiers.indexOf(info.identifier) != -1;
        });
	    events = events.concat(_identifier_list_to_event_list(active_identifier_info, identifier_viewargs.types));
    }
	function bucket_to_url(b) {
		return "#" + get_filtered_view_url("party_exact",
				b.key, profile_agg, ["party_exact-" + b.key, "max_entities-20"]);
	}
	var options = default_bar_table_options($obj, case_str, buckets,
		mid_columns, events, bucket_to_url);
	options.sort = function (name) {
		var sorter = get_sort_func(name, plural(2, case_str), mid_columns,
			events, false);
		if (name =='First Firm Ascending' || name == 'First Firm Descending') {
			sorter.get_key = function (o) {
				return o.Law_Firms && o.Law_Firms.buckets &&
					o.Law_Firms.buckets.length ? o.Law_Firms.buckets[0].key : "";
			};
			sorter.reverse = (name === 'First Firm Descending');
		}
		sortByKey(buckets, sorter.get_key, sorter.reverse);
	};
	options.clicked = function (row, key, event) {
		var hash_url = bucket_to_url(buckets[row]);
		if(window.location.hash == hash_url) {
			show_error_usermsg("Already viewing report for " + buckets[row].key);
		} else {
		    // Open in new tab
			open_url(hash_url, true);
		}
	};
	setup_bar_table(options);
}

/**
 * Generate a list of top law firms. Allowed agg_info options:
 *	set_roles The roles of the parties that should be analyzed.
 * 	case_str	What to call the cases (e.g., case, proceeding, etc.)
 * 	events		A list of case event dictionaries in the table.
 *	mid_columns	Any additional columns to put into the table.
 */
function render_top_firms(obj_id, agg_info, agg_name, agg) {
	var events = agg_info.events || [];
	var mid_columns = agg_info.mid_columns || [];
	// This function works for attorneys as well.
	var is_firm = agg_info.name.search(/Attorneys/) >= 0 ? false : true;
	var non_represent = obj_id.search("Nonrepresent") > -1;

	var $obj = $("#" + obj_id).addClass(is_firm ? "top_firms" : "top_attorneys")
		.addClass("top_entities");
	if(_render_no_cases(agg, $obj)) {
		return;
	}
	var tclass = (is_firm ? "firms_full" : "attorneys_full");
	var buckets = agg.buckets;
	// Figure out the party roles from the data if we weren't given one.
	var set_roles = agg_info.set_roles;
	if(!set_roles || !set_roles.length) {
	    // Generate the roles from the buckets.
        var set_roles_dict = {};
        buckets.forEach(function (b) {
            (b.Firm_Roles && b.Firm_Roles.buckets || []).forEach(function (r){
                set_roles_dict[r.key] = true;
            });
        });
        set_roles = [];
        for(var r_k in set_roles_dict) {
            set_roles.push(r_k);
        }
    }
	// Determine whether we're showing clients or firms.
    var viewargs = get_viewargs_obj();
	var identifier_viewargs = _get_viewargs_identifiers();
    var has = {
        top_clients: (buckets || []).some(function (b) {
            return b.Parties && b.Parties.buckets && b.Parties.buckets.length;
        }),
        top_firms: (buckets || []).some(function (b) {
            return b.Firms && b.Firms.buckets && b.Firms.buckets.length;
        }),
        gender: (buckets || []).some(function (b) {
            return b.male || b.female || b.unknown;
        }),
        // Figure out if we have the party roles
        // If the exact party type is specified, then don't display it.
        proles: !viewargs.party_type_exact &&
            buckets.some(function (b) {
                return b.Firm_Roles;
            }),
        histogram : (buckets || []).some(function (b) {
            return b.Cases && b.Cases.Date_Histogram &&
                b.Cases.Date_Histogram.buckets &&
                b.Cases.Date_Histogram.buckets.length;
        }),
        identifier: identifier_viewargs && identifier_viewargs.identifiers &&
            identifier_viewargs.identifiers.length > 0,
        unknown_outcomes : viewargs.unknown_outcomes == undefined,
    }
	var case_str = get_default_case_str(agg_info, has);

	// A top row of checkboxes.
	var check_options = [["Show Clients", has.top_clients, "max_clients", 3]];
	check_options.push(is_firm ?
			["Show Gender", has.gender, "gender", "true", law_firm_gender_tip()]:
			["Show Firms", has.top_firms, "max_firms", 3]);
	if(has.identifier) {
	    check_options.push(["Show Unknown Outcomes", has.unknown_outcomes,
            "unknown_outcomes", null, unknown_outcome_tip()]);
    }

	var explain_text = agg_info.explain ? wrap_html(agg_info.explain, "div", "explain") : null;

	// Render two tables of top parties
	var $table = $obj
		.find(".graph_title")
            .append(explain_text)
			.append(get_checkbox_viewargs_row(check_options, obj_id))
			.append(suggest_bar_html("Search for " +
				(is_firm ? "a Law Firm" : "an Attorney")))
			.append("<div class='export'>Export</div>")
		.end()
		.append("<div class='" +  tclass + "'><div class='table'></div></div>")
		.find("." + tclass + " .table");
	suggest_bar_setup($obj, is_firm ? "firm" : "attorney");

	// Handle clicking on top parties or top firms.
	var case_str_plural = plural(2, case_str);

	// Add the law firm role column.
	mid_columns = (has.proles ? [{
		header:"Party Type",
		range:[0, 100],
		get_row : function (b) {
			return get_party_percental_column(b.Firm_Roles, set_roles,
				"Representing parties in ", true);
		},
		get_key : function (b) {
			return get_party_percental_column(b.Firm_Roles, set_roles,
				"Representing parties in ", true).perc;
		}
	}] : []).concat(mid_columns);

	// Top clients take a while to calculate and are not always available.
	if(has.top_clients) {
		// Implment the top clients as a mid column. Concat so we don't mutate.
		mid_columns = mid_columns.concat([{
			header : "Top Clients",
			get_row : function(b) {
				// Get the top clients.
				var parties = b.Parties && b.Parties.buckets ?
					b.Parties.buckets.slice(0, 3) : [];
				// Sort by the number of cases, not # of representations.
				sortByKey(parties, function (p) { return p.doc_count}, true);
				return {
					list : parties,
					'class':'list',
					powertip: top_entities_powertip("Clients", parties, case_str)
				};
			},
			get_key : function (b) {
				var party = b.Parties && b.Parties.buckets ?
					b.Parties.buckets[0] : null;
				return party ? party.key : '';
			}

		}]);
	}
	if(has.top_firms) {
		// Implment the top clients as a mid column. Concat so we don't mutate.
		mid_columns = mid_columns.concat([{
			header : "Top Firms",
			get_row : function(b) {
				// Get the top clients.
				var firms = b.Firms && b.Firms.buckets ?
					correct_edit_distance_subbuckets(
						b.Firms.buckets).slice(0, 3) : [];
				// Sort by the number of cases, not # of representations.
				sortByKey(firms, function (p) { return p.doc_count}, true);
				return {
					list : firms,
					'class':'list',
					powertip: top_entities_powertip("Firms", firms, case_str)
				};
			},
			get_key : function (b) {
				var party = b.Firms && b.Firms.buckets ?
					b.Firms.buckets[0] : null;
				return party ? party.key : '';
			}
		}]);
	}
	if(has.histogram) {
		mid_columns = mid_columns.concat([{
			header : "Timeline",
			get_row : function(b) {
				// Get the top clients.
				var times = b.Cases.Date_Histogram.buckets;
				return {
					timeline : times,
					'class':'timeline',
					powertip: wrap_html("Timeline", "xval") +
						wrap_html(times.map(function (l, i) {
						if(!l.doc_count) {
							return "";
						}
						var year = (new Date(l.key)).getUTCFullYear();
						return "<li>" + year + ": " +
							plural_n(l.doc_count, "case") + "</li>";
						}).join(""), "ul", "yval")
				};
			},
			get_key : function (b) {
				var party = b.Firms && b.Firms.buckets ?
					b.Firms.buckets[0] : null;
				return party ? party.key : '';
			}
		}]);
	}
	// Remove events which do not exist in the data itself.
	events = events.filter(function (e) {
		return buckets && buckets.some(function(b) { return b.Cases[e.key] });
	});
	if(has.identifier && identifier_viewargs.identifier_list) {
        // Get all of the information on the active identifiers
	    var active_identifier_info = identifier_viewargs.identifier_list.filter(function f_id(info) {
            return identifier_viewargs.identifiers.indexOf(info.identifier) != -1;
        });
	    events = events.concat(_identifier_list_to_event_list(active_identifier_info, identifier_viewargs.types));
    }
	function bucket_to_url(b) {
		var k = is_firm ? "firm_exact" : "attorney_exact";
		var profile_name = is_firm ? "firm_profile" : "attorney_profile";
		return "#" + get_filtered_view_url(k,
				b.key, profile_name, [k + "-" + b.key, "max_entities-20"]);
	}

	var options = default_bar_table_options($obj, case_str, buckets,
		mid_columns, events, bucket_to_url);
	options.sort = function (name) {
		var sorter = get_sort_func(name, case_str_plural, mid_columns,
				events, true);
		if(name == 'Top Client Ascending' || name == 'Top Client Descending') {
				sorter.get_key = function (o) {
					return o.Parties && o.Parties.buckets &&
						o.Parties.buckets.length ? o.Parties.buckets[0].key : "";
				};
				sorter.reverse = name.endsWith('Descending');
		}
		sortByKey(buckets, sorter.get_key, sorter.reverse);
	};
	// This agg is sorted by number of representations, so sort to no. of cases.
	options.sort('No. ' + case_str_plural + ' Descending');

	options.clicked = function (row, key, event) {
		var hash_url = bucket_to_url(buckets[row]);
		if(window.location.hash == hash_url) {
			show_error_usermsg("Already viewing report for " + buckets[row].key);
		} else {
			open_url(hash_url, true);
		}
	};
	if (non_represent) {
	    options.clicked = null;
    }
	setup_bar_table(options);
}

var render_top_attorneys = render_top_firms;

/**
 * Render a party profile aggregation page. Agg_info options include.
 * party_roles:
 * filing_str:
 * party_events:
 *	name:	The event name.
 *  rate_name: A human readable explanation of the rate an event is granted.
 *		For a motion, it should be "Grant", which will turn into "Grant Rate".
 *  resulted_in: A longer narrative explaining the rate. For motions,
 *		it could be "the motion being granted."
 *	partial_granted_counts: If true, a partially granted event counts as a
 *		granted one.
 */
function render_party_profile(obj_id, agg_info, agg_name, agg) {
	var proles = agg_info.party_roles || ["Plaintiff", "Defendant"];
	var filing_str = agg_info.filing_str;
	var party_events = agg_info.party_events || [];

	var date_filed_id = obj_id + "_Date_Proceeding_Filed";
	var $obj = $("#" + obj_id)
		.addClass("party_profile").addClass("entity_profile")
		.append("<div class='info'></div><div class='date_filed'><div id='" +
			date_filed_id + "'></div></div>");

	if (_render_no_cases(agg.Date_Proceeding_Filed, $obj)) {
		return;
	}
	// Firm and attorney profiles needs to be unnested.
	var is_firm_profile = agg_name.startsWith("Firm_");
    var is_nested_profile = is_firm_profile && agg_name.startsWith("Attorney_");
    var has_gender = is_firm_profile && (agg.male || agg.female || agg.unknown_gender);

    var check_options = [];
    if(is_firm_profile) {
        check_options = [["Show Law Firm Gender", has_gender, "gender", "true", law_firm_gender_tip()]];
        $obj.find(".graph_title").addClass("no_suggest");
    }
    $obj.find(".graph_title").addClass("no_export").append(get_checkbox_viewargs_row(check_options, obj_id))

	// Get info on the party's role.
	var role_info = get_party_percental_column(agg.Party_Roles, proles,
		is_nested_profile ? "Representing parties in " : null, is_nested_profile);

	// Function to get their institution / FWD rates.
	function get_rate(b, type, partial_granted_counts) {
		if(!b[type] || !b[type].doc_count) {
			return {count:0, granted:0};
		}
		var granted = get_granted_total(b[type].buckets, partial_granted_counts);
		return {
			perc : granted / b[type].doc_count,
			count : b[type].doc_count,
			granted : granted
		}
	}
	function get_rate_html(b) {
		// The values may be stored in this sub-agg, which is unnested.
		var bcount = b.Cases ? b.Cases : b;
		var rates = party_events.map(function(pa) {
			return get_rate(bcount, pa.key || pa.name.replaceAll(" ", "_"),
				pa.partial_granted_counts);
		});
		var stats = party_events.map(function(pa, i) {
			if(rates[i].perc == null)
				return '';
			return "<div class='stat'><div class='rtype'>" +
                (pa.rate_name||'') + " Rate</div>" +
                widget_gauge(rates[i].perc) + "</div>";
		}).join("").strip();
		var narrative = party_events.map(function(pa, i) {
			var total = bcount[pa.key || pa.name.replaceAll(" ", "_")];
			total = (total || {}).doc_count;
			return total ? "Out of " + plural_n(total, pa.name) + " as " +
				b.key + ", " + plural_have(rates[i].granted) +
				" resulted in " + pa.resulted_in +  ". ":
				// Don't display any text if there is no data.
				"" /* "No " + plural(0, pa.name) + " as " + b.key + "." */ ;
		}).join(" ").strip();
		// If there's no narrative or stats, don't display anything.
		if(!narrative.length && !stats.length) {
			return "";
		}
		return "<div class='prof_sec'><div class='stitle'>" + b.key + "</div>" +
			stats + "<div class='narrative'>" + narrative + "</div></div>";
	}
	if(agg.Party_Roles) {
		var prof_sec = "";
		if(proles.length > 1) {
			prof_sec += "<div class='prof_sec'><div class='stitle'>" +
				"Party Preference</div><div class='perc_holder'>" +
					widget_percentage(role_info.text, role_info.perc) +
				"</div><div class='narrative role_narrative'></div></div>";
		}
		prof_sec += (agg.Party_Roles.buckets || []).map(get_rate_html).join("");
		$obj.find(".info").append(prof_sec)
			.find(".prof_sec .narrative.role_narrative")
				.html(role_info.powertip).end();
	}

	// The extra aggregations.
	for(const k in agg) {
		if(k == "doc_count" || k == "sum_other_doc_count" ||
			k == "doc_count_error_upper_bound" || k == "Party_Roles" ||
			k == "Date_Proceeding_Filed") {
			continue;
		}
		var kagg = agg[k] ? agg[k].Cases || agg[k] : null;
		if(!kagg || !kagg.doc_count || !kagg.buckets.length) {
			continue;
		}
		var sec_id = obj_id + "_" + k.replaceAll(' ', '_');
		var sec_tit = capitalize(k.replaceAll("_", " "));
		$obj.find(".info")
			.append("<div id='" + sec_id + "' class='extra_sec'>" +
				"<div class='stitle'>" + sec_tit + " Preference</div></div>");

		function quote(q) {
			return q.search(" ") >= 0 ? '"' + q + '"' : q;
		}
		if(kagg.doc_count > 0 && kagg.buckets.length == 1) {
			// Don't bother with a pie chart if there's only one choice.
			$obj.find(".info #" + sec_id).append("<div class='narrative'>Of " +
				 kagg.doc_count + " " + plural(2, case_str).toLowerCase() +
				 ", all have " +  sec_tit + " " + kagg.buckets[0].key +
				 ".</div>");
			continue;
		}
		setup_pie_chart(2, k, kagg, "#" + sec_id, null,
		function _onClick(d, i, el) {
			if (!d || !d.data || !d.data.k || d.data.k == "Other") {
				return null;
			}
			var cur = deparam_url();
			if(!cur.f) {
				cur.f = [];
			} else if (typeof cur.f == "string") {
				cur.f = [cur.f];
			}
			// A bit of a hack, but whatever.
			var q = (k == 'tech_center') ?
				k + ':' + quote(d.data.k):
				'fact_obj:(type:("Case Type") value:(' + quote(d.data.k) + '))';
			cur.f.push('q_' + k + '-' + q);
			cur['fname_' + 'q_' + k] = sec_tit + " - " + d.data.k;
			return DOCKET_SEARCH_URL(cur);
		});
		// Provide the most common.
		$obj.find(".info #" + sec_id).append("<div class='narrative'>Of " +
			 kagg.doc_count + " " + plural(2, case_str).toLowerCase() + ", " +
			 kagg.buckets[0].doc_count + " have " + sec_tit + " " +
			 kagg.buckets[0].key + ".</div>");
	}

	// Add the law firm gender last, it's a bit touchy to many firms.
    if(has_gender) {
	    var gagg = {buckets : []};
	    var total = 0;
	    for(var g in {male:1, female:1, unknown_gender:1}) {
	        var val = agg && agg[g] && agg[g].value ? agg[g].value : 0;
	        total += val;
	        gagg.buckets.push({
                key : capitalize(g.replaceAll("_", " ")),
                doc_count : val,
                short_name : capitalize(g.split("_")[0]),
            })
        }
	    gagg.doc_count = total;
	    if(total) {
            $obj.find(".info").append("<div id='chart_firm_gender' class='extra_sec'>" +
				"<div class='stitle'>Law Firm Gender<i class='fas fa-info'></i></div>" +
                "<div class='narrative'>Attorney gender of each notice of appearance.</div>" +
                "</div>")
                .find('.stitle, .narrative').data("powertip", law_firm_gender_tip(agg))
                    .powerTip({
                        smartPlacement : true,
                        popupClass : 'standard_tip'
                    });
            setup_pie_chart(2, "Law Firm Gender", gagg, "#chart_firm_gender", null);
        }
    }

	agg_info.filing_str = filing_str;
    // The render_new_filings function takes an optional total count and recent
    // aggregation as well as the date proceedings filed aggregation.
    var cumulative = agg.Count_Total && agg.Count_Recent ? {
	        total : agg.Count_Total.value,
	        totalbefore : agg.Count_Recent.value,
	        monthsbefore : get_months_prev(3, false)
    }: null;
	// Render large party profile graph showing the timeline of cases.
	render_new_filings(date_filed_id, agg_info, agg_name,
		agg.Date_Proceeding_Filed, null, null, cumulative);
}

/**
 * Returns a function that renders a filtered aggregation using the same
 * function that renders the non-filtered agg. Basically just swaps some args.
 */
function render_filtered_based_as_basic(render_basic) {
	return function (obj_id, agg_info, agg_name, agg,
			filtered_name, filtered_agg)  {
		return render_basic(obj_id, agg_info, agg_name, filtered_agg);
	}
}

// Helper functions that are used in the agg_info
function keyToClass(it) {
	return it.key.toString().replaceAll(" ", "_");
}
function sort_grant(a,b) {
	var order = {
		'granted' 	: 0,
		'granted and denied' : 1,
		'denied and granted' : 1,
		'denied'	: 2,
		// Other types of orders
		'affirmed' : 3,
		'reversed' : 4,
		'sustained' : 5,
		'dismissed' : 6,
	};
	return order[a.key] - order[b.key];
}

///////////////////////
// Layout and Display Data
// Static information that determines much of the layout and functionality of
// each rendered aggregation.

var agg_infos = {
	Date_Proceeding_Filed : {
		name : "How Busy is the Court",
		render : render_new_filings,
		render_filtered : render_new_filings,
		render_filtered_alone : false
	},
	Law_Firms_Representing_Top_Parties : {
		name 	: 'Top Players',
		render	: render_filtered_top_players,
		render_filtered_alone : true
	},
	Top_Judges : {
		name 	: 'Top Judges',
		render 	: render_top_judges,
		render_filtered_alone : true
	},
	Top_Courts : {
		name 	: 'Top Courts',
		render 	: render_top_courts,
		render_filtered_alone : true
	},
	Top_Case_Types : {
		name 	: 'Top Case Types',
		render 	: render_top_case_types,
		render_filtered_alone : true
	},
	Top_Tags : {
		name 	: 'Top Case Tags',
		render 	: render_top_tags,
		render_filtered_alone : true
	},
	Top_Classes : {
		name 	: 'Top Classes',
		render 	: render_top_classes,
		render_filtered_alone : true
	},
	Top_Patents : {
		name 	: 'Top Patents',
		render 	: render_top_patents,
		render_filtered_alone : true
	},
	Top_Parties : {
		name : 'Top Parties',
		render 	: render_top_parties,
		render_filtered_alone : true
	},
	Top_Law_Firms : {
		name : 'Top Law Firms',
		render 	: render_top_firms,
		render_filtered_alone : true
	},
    Top_Law_Firms_Nonrepresent : {
		name : 'Top Non-Representing Law Firms',
		render 	: render_top_firms,
		render_filtered_alone : true,
        explain : 'Law firms that did not represent the ' +
            'party. Generally, the opposing law firms.'
	},
	Top_Law_Firms_For_Entity : {
		name : 'Law Firms', // We need to use a different name.
		render 	: render_top_firms,
		render_filtered_alone : true
	},
	Top_Law_Firms_Histogram : {
		name : 'Law Firm Histogram',
		render 	: render_top_entity_histogram,
		render_filtered_alone : true
	},
    Top_Law_Firms_Histogram_Nonrepresent : {
		name : 'Non-Representing Law Firm Histogram',
		render 	: render_top_entity_histogram,
		render_filtered_alone : true
	},
	Case_Length_Histogram : {
		name 	: 'Case Length',
		render	: render_case_length,
		render_filtered : render_case_length,
		render_filtered_alone : false
	},
	Top_Attorneys : {
		name : 'Top Attorneys',
		render 	: render_top_attorneys,
		render_filtered_alone : true
	},
    Top_Roles : {
		name : 'Top Roles',
		render 	: render_top_roles,
		render_filtered_alone : true
	},
	Party_Profile : {
		name : 'Summary',
		render 	: render_party_profile,
		render_filtered_alone : true,
	},
	Firm_Profile : {
		name : 'Summary',
		render 	: render_party_profile,
		render_filtered_alone : true,
	},
	Attorney_Profile : {
		name : 'Summary',
		render 	: render_party_profile,
		render_filtered_alone : true,
	},
	// This one is old, will be removed.
    Event_Info : { // Deprecated
	    name : 'Event',
	    render : render_with_identifier_dict(render_event_success_viewargs),
        // For now, no comparisons.
        render_filtered_alone : true,
    },
	// These are the newer ones.
	Event_Info_Counts : {
		name : 'Event Counts',
		render : render_with_identifier_dict(render_event_counts_viewargs),
        // For now, no comparisons.
        render_filtered_alone : true,
	},
	Event_Histogram : {
		name : 'Event Histogram',
		render : render_with_identifier_dict(render_date_event_histogram),
        // For now, no comparisons.
        render_filtered_alone : true,
	},
	Event_Length_Histogram : {
		name : 'Event Histogram',
		render : render_with_identifier_dict(render_length_event_histogram),
        // For now, no comparisons.
        render_filtered_alone : true,
	}
};

function build_default_aggregations(opts) {
	var events = opts.events || [];
	var set_roles = opts.party_roles || stats_views_globals.party_roles || [];

	// Add the parser objects to the events array, but mark it as such.
	events = events.concat((opts.parser || []).map(function(p) {
        p.is_parser = true;
        return p;
    }));
    var viewargs = get_viewargs_obj();

	// Special options just for the top entity pages and rankings.
	function _entity_opts(requires_unnest) { return {
		events : events.map(function (e) { return {
		    // Full name of the event
			full: e.name,
            // Abreviated name of the event.
			abrev: e.abrev,
            // Show the rate that this event occurs or grants/losses (default true).
            show_rate : e.show_rate,
            show_count : e.show_count || false,
            // Show timing information about this event (default false).
            custom_columns : e.custom_columns || false,
            // Aggregation key. The fallback method seems to work.
			key: e.key || e.name.replace(/\s/ig, '_'),
			partial_counts: e.partial_granted_counts,
			resulted_in : e.resulted_in,
			powertip : e.powertip,
		}}),
		set_roles : set_roles,
		mid_columns : opts.get_mid_columns ?
			opts.get_mid_columns(requires_unnest) : []
	}; }

	var profile_options = {
		party_events : events.map(function (e) { return {
			name : e.name,
			key : e.key || e.name.replace(/\s/ig, '_'),
			rate_name : e.rate_name,
			resulted_in : e.resulted_in,
			partial_granted_counts : e.partial_granted_counts,
		}}),
	};

	var opts_no_unnest = _entity_opts(false);
	var opts_unnest = _entity_opts(true);
	update_dict(agg_infos, {
		// Customize the top lists by inserting our own options.
		Top_Judges : update_dict(agg_infos.Top_Judges, opts_no_unnest),
		Top_Courts : update_dict(agg_infos.Top_Courts, opts_no_unnest),
		Top_Case_Types : update_dict(agg_infos.Top_Case_Types, opts_no_unnest),
		Top_Tags : update_dict(agg_infos.Top_Tags, opts_no_unnest),
        Top_Patents : update_dict(agg_infos.Top_Patents, opts_no_unnest),
		Top_Parties : update_dict(agg_infos.Top_Parties, opts_no_unnest),
		Top_Law_Firms : update_dict(agg_infos.Top_Law_Firms, opts_unnest),
		Top_Law_Firms_For_Entity :
			update_dict(agg_infos.Top_Law_Firms_For_Entity, opts_unnest),
		Top_Law_Firms_Histogram :
            update_dict(agg_infos.Top_Law_Firms_Histogram, opts_unnest),
        Top_Attorneys : update_dict(agg_infos.Top_Attorneys, opts_unnest),

		// Customize the Party profile aggregation.
		Party_Profile : update_dict(agg_infos.Party_Profile, profile_options),
		Firm_Profile : update_dict(agg_infos.Firm_Profile, profile_options),
		Attorney_Profile : update_dict(agg_infos.Attorney_Profile, profile_options),
        // Event_Info : update_dict(agg_infos.Event_Info, profile_options),
	});
    function _get_event_agg_info(e) {
        var outcome_stat_regex = e.outcome_stat_regex || /./;
        return {
			name : e.name,
            is_parser : e.is_parser,
			map_name : e.map_outcome ? function (it) {
				return e.map_outcome[it.key] || it.key;
			} : function(it) {
			    return it.key;
            },
			map_short_name : e.map_outcome_short ?
                function _mapped_get_short_name(it) {
				    return e.map_outcome_short[it.key] || it.key;
			    }: function _default_get_short_name(it) {
			        return it.key;
                },
			sort_series 	: e.sort_series || sort_grant,
			render			: render_event_success,
			render_filtered	: render_filtered_event_success,
			click_searches_dockets : true,
			click_type		: e.query_type,
			// Specific to render_event_success
			days_from_name : e.days_from_name || case_str,
			days_to_name : e.days_to_name || e.name,
			// Specific to patent claim analysis (so far only PTAB uses it)
			claims_grant_name : e.claims_grant_name,
			// Special function specific to render_event_success
			get_stat : function (agg) {
				return {
					stat : (100*this.get_stat_filtered(agg).stat
						).toFixed(0).toString() + "%",
					p : e.percent_success
				}
			},
			// Generates a percentage statistic for filtered data.
			get_stat_filtered : function(agg) {
				var total = 0, total_stat = 0;
				for(var i in agg.buckets) {
					var k = agg.buckets[i].className;
					// Set the statistics that we are gathering.
					if(outcome_stat_regex.test(k))
						total_stat += agg.buckets[i].doc_count;
					// Set the total amount we're dividing it over.
					total += agg.buckets[i].doc_count;
				}
				return {
					stat 	: total ? total_stat / total : null,
					p 		: e.outcome_state_expl || "",
				};
			}
		}
    }
	// Now add "event success" aggregations for each event.
	events.forEach(function (e) {
		var key = e.key || e.name.replace(/\s/ig, '_');
		agg_infos[key] = _get_event_agg_info(e);
	});
}

/**
 * Build the default aggregations, add filters, and return a view builder for the given events.
 * @param agg_events
 * @returns {function(): *}
 */
function build_views_from_events(agg_events) {
    // Build the default aggreagtions
    build_default_aggregations({
        events : agg_events.map(function (ev) {
            return {
                name : ev.name,
                abrev : get_abbreviation(ev.name),
                // Events where we're only interested in the count, timing, not grant/deny.
                existence : ev.existence || false,
                map_outcome : {},
                map_outcome_short : {},
                query_type : ev.name,
                rate_name : '',
                resulted_in : ev.name,
                // abrev:'Opp.',
                // partial_granted_counts : true,

                days_from_name : ev.measure_from || (case_str + " Start"),
                days_to_name : ev.name,
                outcome_stat_regex : /granted|sustained|affirmed/,
            };
        })
    });
    // Add filters for the events.
    agg_events.forEach(function _save_event_filter_global(ev) {
		// Add a filter for the event into the global filter customizations.
        typical_analytics_filters[ev.key] = {
            title : ev.name,
            f : 'q_' + ev.key,
            choices : [
                {key:'All Cases', isdefault:true},
                {key:'With ' + ev.name, v:'event:(type:(' + ev.name + '))'},
                {key:'Without ' + ev.name, v:'not event:(type:(' + ev.name + '))'},
            ]
        };
    })
    // Return a function that builds the view infos.
    return function _build_view_infos() {
        return build_default_view_infos({
            events : agg_events.map(function (e) { return e.name; }),
            extra_filter_keys : agg_events.map(function (e) { return e.key; }),
        });
    }
}

/////
// Static data structure that defines filters used in the sidebar.

// This global variable stores all filters customizations for the analytics
// template. It also holds event based filters, which are also defined.
var typical_analytics_filters = {};
function add_party_type_filters(party_types, filter_dict) {
	if(!party_types || party_types.length <= 1) {
		if(filter_dict.party_type) {
			delete filter_dict.party_type;
		}
		if(filter_dict.party_type_for_party) {
			delete filter_dict.party_type_for_party;
		}
		if(filter_dict.representing_party_type) {
			delete filter_dict.representing_party_type;
		}
		return;
	}
	filter_dict.party_type = {
		title : 'Filter by Party Type',
		viewargs : 'party_type_exact',
		choices: [
			{key:'All Parties', isdefault:true}
		].concat(party_types.map(function (p) {
			return {key:'Only ' + plural(2, p), v: p};
		}))
	};

	filter_dict.party_type_for_party = {
		title : 'Filter Party by Type',
		viewargs: 'party_type_exact',
		choices: [
			{key:'As Any Party', isdefault:true},
		].concat(party_types.map(function (p) {
			return {key:'Only as ' + p, v: p};
		}))
	};

	filter_dict.representing_party_type = {
		title : 'Filter by Representation',
		viewargs:'party_type_exact',
		choices: [
			{key:'All Cases', isdefault:true},
		].concat(party_types.map(function(p) {
			return { key: 'Representing ' + plural(2, p), v: p };
		}))
	};
}
// Add the default party type filters. This can be overriden, and called again
// once we get the true Party types from the ajax call.
add_party_type_filters(["Plaintiff", "Defendant"], typical_analytics_filters);

/**
 * Add a filter that filters a top level aggregation based on its doc_count.
 * This is a "live" filter, meaning it just redraws what's on the screen.
 */
function add_total_cases_filter(agg_name, need_cases, case_str, filter_dict) {
	// Keep track of the aggregation we're filtering.
	var orig_agg = null, orig_buckets = null, min, max;
	var key = agg_name.replaceAll(' ', '_');
	var get_count = need_cases ?
		function _cases(b) { return b.Cases.doc_count; }:
		function _no_cases(b) { return b.doc_count; };

	function get_agg() {
		// For this agg to work, it needs to be rendered already.
		return get_last_render_by_agg_key(key);
	}

	function get_ranges() {
		var agg = get_agg();
		// If the agg doesn't exist, or it hasn't changed from last time, return.
		if(!agg || !agg.buckets || orig_agg === agg) {
			return;
		}
		// Save this agg, and get it's max and min values.
		orig_agg = agg;
		min = null;
		max = null;
		for (var i = 0; i < agg.buckets.length; i++) {
			var count = get_count(agg.buckets[i]);
			if(min === null || count < min) { min = count; }
			if(max === null || count > max) { max = count; }
		}
		// Create a shallow copy of all buckets, we'll be filtering it.
		orig_buckets = agg.buckets.slice();
	}

	// Create the new filter.
	filter_dict[key + '_total_cases'] = {
		title : 'Filter By Total ' + plural(2, case_str),
		unit : plural(2, case_str),
		range : true,
		get_val : function (perc) {
			get_ranges();
			return roundNumber((max - min) * perc / 100.0) + min;
		},
		filter : function (new_min, new_max) {
			var agg = get_agg();
			// Start with the original buckets and filter.
			agg.buckets = orig_buckets.filter(function (b) {
				var count = get_count(b);
				return new_min <= count && count <= new_max;
			});
			// Probably overkill
			clear_and_rerender_all();
		}
	};
}

/**
 * Add a filter that controls the time of an event.
 * @param agg_name
 * @param case_str
 * @param filter_dict
 */
function add_time_to_event_filter(agg_name, case_str, filter_dict) {
	// Keep track of the aggregation we're filtering.
	var orig_agg = null, min, max, ufmin, ufmax;
	var key = agg_name.replaceAll(' ', '_');
	var HISTOGRAM_INTERVAL_TIMING = 10; // Number of days in each bucket.

	function get_ranges() {
		// Get the main agg, For this agg to work, it needs to be rendered already.
		var agg = get_last_render_by_agg_key(key);

		// If the agg doesn't exist, or it hasn't changed from last time, return.
		if(!agg || !agg.Days_from_Filing || orig_agg === agg) {
			return;
		}
		var i, count;
		// Save this agg, and get it's max and min values.
		orig_agg = agg;
		min = null;
		max = null;
		for (i = 0; i < agg.Days_from_Filing.buckets.length; i++) {
			count = agg.Days_from_Filing.buckets[i].key;
			if(min === null || count < min) { min = count; }
			if(max === null || count > max) { max = count; }
		}

		// Get the unfiltered min, max if it exists.
		ufmin = min;
		ufmax = max;
		agg = get_last_render_by_agg_key(key, true);
		if(agg) {
			for (i = 0; i < agg.Days_from_Filing.buckets.length; i++) {
				count = agg.Days_from_Filing.buckets[i].key;
				if(count < ufmin) { ufmin = count; }
				if(count > ufmax) { ufmax = count; }
			}
		}
		ufmax += HISTOGRAM_INTERVAL_TIMING - 1;
		max += HISTOGRAM_INTERVAL_TIMING - 1;
	}

	// Create the new filter.
	filter_dict[key + '_total_time'] = {
		title : 'Time to ' + agg_name,
		unit : 'Days',
		range : true,
		get_val : function (perc) {
			get_ranges();
			return roundNumber((ufmax - ufmin) * perc / 100.0) + ufmin;
		},
		start_perc : function () {
			get_ranges();
			if(ufmax === undefined) {
				return [0, 100];
			}
			var total = ufmax - ufmin;
			return [100*(min-ufmin)/total, 100*(max-ufmin)/total];
		},
		filter : function (new_min, new_max) {
			var q = "event:(type:(" + agg_name + ") AND " +
				"days:[" + new_min + "," + new_max + "])";
			var qkey = "q_Days_to_" + agg_name;
			var fname = new_min + " to " + new_max + ' Days to ' + agg_name;

			var cur = deparam_url();
			cur.f = Array.isArray(cur.f) ? cur.f : (cur.f ? [cur.f]: []);
			cur.f = cur.f.filter(function (v, i) {
				return !v.startsWith(qkey);
			});
			cur['fname_' + qkey] = fname;
			cur.f.push(qkey + '-' + q);
			window.location.hash = "#" + param_query(cur);
		}
	};
}

/////
// The Views Info Structure
// Defines what aggregations we see in each view.

/**
 * Builds a default gbl_view_infos structure based on the given options:
 *  court_short: A short name for a court (e.g., SCOTUS)
 * 	case_str: What to call a "case"
 * 	party_roles: What parties to account for in the stats.
 *	events: A list of events that will be captured and displayed.
 *	extra_filter_keys: Keys to the typical_analytics_filters that should be
 *		applied to the list and profile views.
 **/
function build_default_view_infos(opts) {
	opts = opts || {};
	if(typeof case_str == "undefined") {
		case_str = "Case";
	}
	var court = " " + (opts.court_short || "court");
	var default_case_str = opts.case_str || case_str;
	var default_party_roles = opts.party_roles || stats_views_globals.party_roles;
	var events = opts.events || [];
	var extra_filter_keys = opts.extra_filter_keys || [];
	// Use the global filters that we will be displaying.
	var analytics_filters = typical_analytics_filters;

	// If events are specified, extract their key.
	var event_keys = events.map(function (e) { return e.replaceAll(" ", "_"); });
	// The extra filters are the
	var extra_filters = extra_filter_keys.map(function (k) {
		if(!analytics_filters[k]) {
			console.warn("No analytics filter: " + k);
		}
		return analytics_filters[k];
	}).filter(function (it) { return it; });
	// Add the template filters, and all the filters specified for the view.
	var all_filters = template_global_filters().concat(extra_filters);

	function del_by_val(ar, x) {
		var idx = ar.indexOf(x);
		if(idx != -1) ar.splice(idx, 1);
	}

	add_party_type_filters(default_party_roles, analytics_filters);
	add_total_cases_filter("Top Parties", false, default_case_str, analytics_filters);
	add_total_cases_filter("Top Law Firms", true, default_case_str, analytics_filters);
	add_total_cases_filter("Top Attorneys", true, default_case_str, analytics_filters);
	add_total_cases_filter("Top Judges", false, default_case_str, analytics_filters);

	for(var i=0; i < events.length; i++) {
		add_time_to_event_filter(events[i], default_case_str, analytics_filters);
	}
	function post_process(views) {
		// When there are identifiers, remove certain views.
		return views;
	}
	// Additional view options that can be added manually by subclasses:
	// 	title_facets: an array which signify which facets should be part of
	//				  the title of the view.
	var case_str_plural = plural(2, case_str.toLowerCase());
	var default_top_list_viewargs = ['max_entities-50'];
	return post_process({
		overview : {
			title : "What is happening at the " + court + "?",
			question : 1,
			selected_tab : "li.overview",
			// The views to display
			views : event_keys.length ?
				// If we have events, display them.
				['Date_Proceeding_Filed', 'Top_Case_Types'].concat(event_keys):
				// If not, settle for displaying general court info.
				['Date_Proceeding_Filed', 'Case_Length_Histogram',
					'Top_Courts', 'Top_Tags'],
			allow_identifier_views : 2,
			description : [
				'Get an overview of all activity and spot trends as they occur.'],
			other_filters : all_filters
		},
		chances : {
			title : "What are my chances of winning?",
			question : 2,
			views : event_keys.concat([
				// 'Law_Firms_Representing_Top_Parties',
				'Top_Judges'
			]),
			allow_identifier_views : true,
			selected_tab : "li.overview",
			description : ['Select your judge and we&rsquo;ll tell you outcomes ' +
				'based on historical trends.'],
			other_filters : all_filters
		},
		players : {
			title 	 : "Who are the major players?",
			question : 3,
			views : [
				'Law_Firms_Representing_Top_Parties',
				'Top_Attorneys',
				'Top_Judges'
			],
			selected_tab : "li.overview",
			description : ['View top ' +  court + ' judges, parties, and law firms.'],
			other_filters : all_filters
		},
		end : {
			title 	: "How do "+ court + " " + case_str_plural + " end?",
			question : 4,
			views : [
				'How_Proceedings_Terminate',
			],
			selected_tab : "li.overview",
			description : ['See how often ' + case_str_plural + ' settle'],
			extra : [
				"#party_judge_filters",
			],
			other_filters : all_filters
		},
		status : {
			title 	: "What is the status of " + court + " " +
				case_str_plural + "?",
			question : 5,
			views : [
				'How_Proceedings_Terminate',
			],
			selected_tab : "li.overview",
			description : ['See how often a party or law firm wins or settles.'],
			extra : [
				"#party_judge_filters",
			],
			other_filters : all_filters
		},

		///////////
		// Newer more generalized views.
		parties : {
			title : "Top Parties",
			views : [
				'Top_Parties',
			],
            default_viewargs : default_top_list_viewargs,
			selected_tab : "li:has([href='#v=parties&q='])",
			other_filters : [analytics_filters.party_type]
				.concat(all_filters)
				.concat([analytics_filters.Top_Parties_total_cases])
		},
		firms : {
			title : 'Top Law Firms',
			views : [
				'Top_Law_Firms',
			],
            default_viewargs : default_top_list_viewargs,
			selected_tab : "li:has([href='#v=firms&q='])",
			other_filters : [analytics_filters.representing_party_type]
				.concat(all_filters)
				.concat([analytics_filters.Top_Law_Firms_total_cases]),
		},
		attorneys : {
			title : 'Top Attorneys',
			views : [
				'Top_Attorneys',
			],
            default_viewargs : default_top_list_viewargs,
			selected_tab : "li:has([href='#v=attorneys&q='])",
			other_filters : [analytics_filters.representing_party_type]
				.concat(all_filters)
				.concat([analytics_filters.Top_Attorneys_total_cases])
		},
		judges : {
			title : "Top Judges",
			views : [
				'Top_Judges',
			],
            default_viewargs : default_top_list_viewargs,
			selected_tab : "li:has([href='#v=judges&q='])",
			other_filters : all_filters
				.concat([analytics_filters.Top_Judges_total_cases])
		},
        courts : {
			title : "Top Courts",
			views : [
				'Top_Courts',
			],
            default_viewargs : default_top_list_viewargs,
			selected_tab : "li:has([href='#v=courts&q='])",
			other_filters : all_filters
				.concat([analytics_filters.Top_Courts_total_cases])
		},
        case_types : {
			title : "Top Case Types",
			views : [
				'Top_Case_Types',
			],
            default_viewargs : default_top_list_viewargs,
			selected_tab : "li:has([href='#v=case_types&q='])",
			other_filters : all_filters
		},
		classes : {
			title : "Top Classes",
			views : [
				'Top_Classes',
			],
            default_viewargs : default_top_list_viewargs,
			selected_tab : "li:has([href='#v=class&q='])",
			other_filters : all_filters
		},
		tags : {
			title : "Top Case Tags",
			views : [
				'Top_Tags',
			],
            default_viewargs : default_top_list_viewargs,
			selected_tab : "li:has([href='#v=tags&q='])",
			other_filters : all_filters
		},
        patents : {
			title : "Top Patents",
			views : [
				'Top_Patents',
			],
            default_viewargs : default_top_list_viewargs,
			selected_tab : "li:has([href='#v=patents&q='])",
			other_filters : all_filters
		},
        event_profile : {
		  views : [
		      'Event_Info_Counts',
			  'Event_Histogram',
			  'Event_Length_Histogram',
		  	  // 'Event_Info', // Depreceated
              'Top_Courts',
              'Top_Judges',
              'Top_Case_Types',
              'Top_Parties',
              'Top_Law_Firms'
          ],
            // Reduce default, there are many reports in here.
            default_viewargs : ['max_entities-10'],
            other_filters : all_filters
        },
		// Profiles of Specific Entities.
		party_profile : {
			title : 'Party Profile',
			views : [
				'Party_Profile',
				'How_Proceedings_Terminate']
				.concat(event_keys)
				.concat([
				'Top_Law_Firms_Histogram',
				'Top_Law_Firms',
				'Top_Attorneys',
				'Top_Courts',
                'Top_Case_Types',
				'Top_Judges',
				'Top_Law_Firms_Histogram_Nonrepresent',
				'Top_Law_Firms_Nonrepresent',
			]),
			allow_identifier_views : 2,
			parent_view : 'parties',
			selected_tab : "li:has([href='#v=parties&q='])",
			other_filters : (analytics_filters.party_type_for_party ?
                [analytics_filters.party_type_for_party] : []
            ).concat(all_filters),
			title_facets : ['Party']
		},
		firm_profile : {
			title : 'Law Firm Profile',
			views : [
				'Firm_Profile',
				'Top_Parties',
				// 'Top_Roles', Not yet working perfectly.
				'Top_Attorneys',
				'How_Proceedings_Terminate'].concat(event_keys).concat([
				'Top_Courts',
                'Top_Judges',
                'Top_Case_Types'
			]),
			allow_identifier_views : 0,
			parent_view : 'firms',
			selected_tab : "li:has([href='#v=firms&q='])",
			other_filters : (
			    analytics_filters.representing_party_type ?
                    [analytics_filters.representing_party_type] : []
            ).concat(all_filters),
		},
		attorney_profile : {
			title : 'Attorney Profile',
			views : [
				'Attorney_Profile',
				'Top_Law_Firms_For_Entity',
				'Top_Parties',
				'How_Proceedings_Terminate',
                'Top_Case_Types',
            ].concat(event_keys).concat([
                'Top_Courts',
				'Top_Judges'
			]),
			allow_identifier_views : 0,
			parent_view : 'attorneys',
			selected_tab : "li:has([href='#v=attorneys&q='])",
			other_filters : (
			    analytics_filters.representing_party_type ?
                    [analytics_filters.representing_party_type] : []
            ).concat(all_filters),
		},
		judge_profile : {
			title : 'Judicial Profile',
			views : ['Date_Proceeding_Filed'].concat(event_keys).concat([
				'Top_Parties',
				'How_Proceedings_Terminate',
                'Top_Case_Types',
                'Top_Law_Firms',
				'Top_Courts',
				'Top_Judges'
			]),
			allow_identifier_views : 1,
			parent_view : 'judges',
			selected_tab : "li:has([href='#v=judges&q='])",
			other_filters : all_filters
				.concat(event_keys.map(function(k) {
					return analytics_filters[k + '_total_time'];
				}))
		},
        case_type_profile : {
			title : 'Case Type Summary',
			views : ['Date_Proceeding_Filed'].concat(event_keys).concat([
				'Top_Parties',
				'How_Proceedings_Terminate',
				'Top_Law_Firms',
				'Top_Judges'
			]),
			allow_identifier_views : 1,
			parent_view : 'case_types',
			selected_tab : "li:has([href='#v=case_type&q='])",
			other_filters : all_filters
				.concat(event_keys.map(function(k) {
					return analytics_filters[k + '_total_time'];
				}))
		},
		court_profile : {
			title : 'Court Profile',
			views : ['Date_Proceeding_Filed'].concat(event_keys).concat([
				'Top_Case_Types',
				'Top_Parties',
				'Top_Law_Firms',
				'Top_Judges'
			]),
			allow_identifier_views : 1,
			parent_view : 'judges',
			selected_tab : "li:has([href='#v=judges&q='])",
			other_filters : all_filters
				.concat(event_keys.map(function(k) {
					return analytics_filters[k + '_total_time'];
				}))
		},
		tags_profile : {
		    title : 'Tags Profile',
			views : ['Date_Proceeding_Filed'].concat(event_keys).concat([
				'Top_Parties',
				'How_Proceedings_Terminate',
				'Top_Law_Firms',
				'Top_Judges',
                'Top_Tags'
			]),
			allow_identifier_views : 1,
			parent_view : 'tags',
			selected_tab : "li:has([href='#v=tags&q='])",
			other_filters : all_filters
				.concat(event_keys.map(function(k) {
					return analytics_filters[k + '_total_time'];
				}))
        },
        patent_profile : {
		    title : 'Patent Profile',
			views : ['Date_Proceeding_Filed'].concat(event_keys).concat([
				'Top_Parties',
				'How_Proceedings_Terminate',
				'Top_Law_Firms',
				'Top_Judges',
                'Top_Tags'
			]),
			allow_identifier_views : 1,
			parent_view : 'patents',
			selected_tab : "li:has([href='#v=patents&q='])",
			other_filters : all_filters
				.concat(event_keys.map(function(k) {
					return analytics_filters[k + '_total_time'];
				}))
        }
	});
}

/**
 * Returns the global filters for the current template. Relies on a global variable.
 * @returns {*[]}
 */
function template_global_filters() {
	// Determine which filters we are using.
	var allowed_filters = stats_views_globals.template_filters;
	if (!allowed_filters) {
		console.warn("No global filters defined.");
		return [];
	}
	// Get the library of filters.
	const all_filters = get_filter_library_dict();
	// Filter the list of filters.
	var filters = [];
	for (const [key, filter_func] of Object.entries(all_filters)) {
		if(allowed_filters[key]) {
			filters.push(filter_func);
		}
	}
	return filters;
}

/**
 * Return a dictionary of filter objects.
 * @returns {{}}
 */
function get_filter_library_dict() {
	const filters_dict = {};
	filters_dict.judge = {
		title : 'Judge',
		f : 'q_judge',
		text : 'Judge name / query',
		entity : 'judge',
		get_query : function _get_judge_query(v) {
			return "judge:(" + v + ")";
		},
		get_value : function _get_judge_value(filter){
			var match = /^judge:\((.*)\)$/.exec(filter)
			return match && match.length > 1 ? match[1] : "";
		}
	};
	filters_dict.party = {
		title : 'Party',
		f : 'q_party',
		text : 'Party name ...',
		entity : 'party',
		get_query : function _get_party_query(v) {
			return "party:(" + v + ")";
		},
		get_value : function _get_judge_value(filter){
			var match = /^party:\((.*)\)$/.exec(filter)
			return match && match.length > 1 ? match[1] : "";
		}
	};
	filters_dict.firm = {
		title : 'Firm',
		f : 'q_firm',
		text : 'Firm name ...',
		entity : 'firm',
		get_query : function _get_firm_query(v) {
			return "firm:(" + v + ")";
		},
		get_value : function _get_firm_value(filter) {
			var match = /^firm:\((.*)\)$/.exec(filter)
			return match && match.length > 1 ? match[1] : "";
		},
		tip :
			wrap_html("Law Firm", "h4") +
			wrap_html("Filter motions by law firm involved in the case.", "p")
	};
	// State filter still relies on the global to exist to be loaded.
	if(stats_views_globals.template_filters.states) {
		if(!stats_views_globals.state_names) {
			console.warn("No state names defined.");
		}
		filters_dict.states = {
			title : 'State',
			f : 'q_state',
			multiple : true,
			choices: [
				{key:'All States', isdefault:true}
			].concat((stats_views_globals.state_names || []).map(function _transform_state(s) {
				var s2 = s.replaceAll('"', "");
				return { key : s2, fname : s2, v : 'court:(' +  s + ')' };
			}))
		}
	}
    filters_dict.case_type = {
		title : 'Case Type',
		f : 'q_case_type',
		// Placeholder text.
		text: "Filter by case type",
		// Convert a value into a query.
		get_query : function (v) {
			return 'fact_obj:(type_exact:"Case Type" value:(' + v + '))';
		},
		// Convert query into the val
		get_value : function (query) {
			return (query || '')
				.replace('fact_obj:(type_exact:"Case Type" value:(', '')
				.slice(0, -2);
		}
	};
	filters_dict.case_tag = {
		title: 'Case Tag',
		f: 'q_case_tag',
		// Placeholder text.
		text: "Filter by case tag",
		// Convert a value into a query.
		get_query: function (v) {
			return 'fact_obj:(type_exact:Tag value:(' + v + '))';
		},
		// Convert query into the val
		get_value: function (query) {
			return (query || '')
				.replace('fact_obj:(type_exact:Tag value:(', '')
				.slice(0, -2);
		}
	};
    filters_dict.case_status = {
		title: 'Case Status',
		f: 'q_case_status',
		// Placeholder text.
		text: "Filter by case status",
		// Convert a value into a query.
		get_query: function (v) {
			return 'status:(' + v + ')';
		},
		// Convert query into the val
		get_value: function (query) {
			return (query || '').replace('status:(', '').slice(0, -2);
		}
	};
    filters_dict.case_patent = {
		title: 'Patent',
		f: 'q_patent',
		// Placeholder text.
		text: "Filter by patent no.",
		// Convert a value into a query.
		get_query: function (v) {
			return 'patent:(' + v + ')';
		},
		// Convert query into the val
		get_value: function (query) {
			return (query || '').replace('patent:(', '').slice(0, -2);
		}
	};
	filters_dict.free_form = {
		title: 'Docket Query',
		f: 'q_query_filter',
		// Placeholder text.
		text: "Filter by keyword or query on docket",
		// Convert a value into a query.
		get_query: function (v) {
			return v;
		},
		// Convert query into the val
		get_value: function (query) {
			return query;
		}
	};
	filters_dict.free_form_document = {
		title: 'Document Query',
		f: 'q_document_filter',
		// Placeholder text.
		text: "Query dockets by document text",
		// Convert a value into a query.
		get_query: function (v) {
			return 'documenttext:(' + v + ')';
		},
		// Convert query into the val
		get_value: function (query) {
			return (query || '').replace('documenttext:(', '').slice(0, -2);
		}
	}
    return filters_dict	;
}

function template_link_filter(params) {
    var link_filter = stats_views_globals.template_filters &&
		stats_views_globals.template_filters.link;
    if (link_filter) {
        params.f.push("q_analytics_court-" + link_filter.filter);
        // Add a pretty-printed name for it.
        params.fname_q_analytics_court = link_filter.description;
        return "/search/dockets/?" + param_query(params);
    }
    // Use our current URL to get the search url.
    var search_url = location.pathname.replace(
        // Hardcode these special values. We can do better than this.
        /\/(stats|analytics)\/(Profile\/)?/,
        // Replace with generic search path
        "/search/");
    if(location.pathname.search("/workbench/") != -1) {
        return search_url + "/?" + param_query(params);
    }
    // We need to add the dockets so we don't search documents.
    return search_url + "dockets/?" + param_query(params);
}

function view_info_subtitle(view) {
    if(typeof view.subtitle != "undefined") {
        return view.subtitle || "";
    }
    return "Question #" + view.question;
}

function render_toptabs(){
    var cache_key = window.location.pathname + "?toptabs";
    function set_toptabs_enable(data) {
        var has_entity = {};
        var $toptabs = $(".toptabs");
        for(var k in data.aggs) {
            if(!k.startsWith("Has_")) {
                continue;
            }
            // Get the class name from the aggregation type, this has to be
            // matched manually.
            var e_k = k.slice(4).toLowerCase();
            var disable_entity = (data.aggs[k].doc_count || 0) <= 1;
            $toptabs.find("." + e_k)
                .toggleClass("disabled", disable_entity)
                .data("powertip", disable_entity ? "The " + capitalize(e_k) +
                    " tab is not available for these analytics.": "")
                .powerTip({
                    smartPlacement : true,
                    popupClass : 'standard_tip'
                });

        }
    }

    // Get the data from the cache.
    var toptabs_data = sessionGet(cache_key);
    // If we can get it from the cache, then just process it now.
    if(toptabs_data) {
        set_toptabs_enable(toptabs_data);
        return;
    }
    var query = get_query_str();
    // We need to make a call to get it.
    get_json_results({
		requests : [{ views: ["Has_Entities"] , q:query}],
		on_success : function (resp) {
		    // There is only one response.
            sessionSet(cache_key, resp[0], 60*5, true);
            set_toptabs_enable(resp[0]);
        }
    });
}

var _last_render = null;
/**
 * Set a global cache of the last_render
 * @param aggs
 * @param filtered_aggs
 * @param view
 */
function set_last_render(aggs, filtered_aggs, view) {
	_last_render = {
		aggs : aggs,
		filtered_aggs : filtered_aggs,
		view : view
	};
}
/**
 * Return the last aggregation by key.
 * @param key The aggregation key
 * @param unfiltered If False, return the current filtered aggregation.
 * 	If True, return the unfiltered aggregation (for overall date aggs).
 * @returns {null|*}
 */
function get_last_render_by_agg_key(key, unfiltered) {
	return !_last_render ? null:
		unfiltered ?
			// Use the unfiltered aggregation, but require a filtered.
			_last_render.filtered_aggs && _last_render.filtered_aggs[key] &&
			_last_render.aggs && _last_render.aggs[key]:
			// Use the last filtered agg, fallback on the unfiltered.
			(_last_render.filtered_aggs && _last_render.filtered_aggs[key]) ||
			(_last_render.aggs && _last_render.aggs[key]);
}

function clear_and_rerender_all() {
	// Clear the previous renders
	$("#charts").empty();
	// Start fresh
	if(_last_render) {
		render_allaggs(_last_render.aggs, _last_render.filtered_aggs, _last_render.view);
	}
}

/**
 * Render the title name of an aggregation.
 * @param view The view info dictionary.
 * @returns {string} HTML String.
 * @private
 */
function _render_agg_title_html(view) {
	var title_html = '';

	// If the view has a "question"
	if(view && view.question) {
		var url = window.location.pathname;
		var urls_params = url_params_to_object();
		if(urls_params.code) {
			url += "?code=" + encodeURIComponent(urls_params.code);
		}
		title_html += "<div class='question'><a href='" + url +
			"'>All Questions</a> &#8594; " + "<h2>" + view_info_subtitle(view) +
			"</h2></div>";
	}
	var q_list = query_to_list();
	var title_extra = q_list.title ? " for " + wrap_html(q_list.title.name, "span",
		"title_extra" + (q_list.title.is_entity ? " title_entity" : "")) : "";
	if(view && view.title &&
		// Don't show the view title if there's one agg and it has the same title.
		!(view.views && view.views.length == 1 && agg_infos[view.views[0]] &&
		agg_infos[view.views[0]].name == view.title)) {
		// Check if there's punctuation at the end.
		if(".?;:".indexOf(view.title[view.title.length - 1]) != -1) {
			// Move punctuation to the end.
			title_html += "<h1>" + view.title.slice(0, -1) + title_extra +
				view.title[view.title.length - 1] + "</h1>";
		} else {
			title_html += "<h1>" + view.title + title_extra + "</h1>";
		}
	}

	// Show parent breadcrumbs.
	if(view && view.parent_view && gbl_view_infos[view.parent_view]) {
		var parent_title = gbl_view_infos[view.parent_view].title || "&larr;";
		title_html += "<h3 class='parent'><a href='#v=" + view.parent_view + "'>" +
			parent_title + "</a></h3>";
	}
	return {
		html : title_html,
		extra : title_extra
	};
}

// Build a default gbl_view_infos structure.
var gbl_view_infos = null;
function get_view_infos() {
	if(gbl_view_infos === null) {
		gbl_view_infos = build_view_infos();
	}
	return gbl_view_infos;
}

/**
 * Return a list of visible views based on the current hash parameters.
 * In particular, the "v" parameter, which specifies a collection of views.
 * @param view
 * @param frag_obj
 * @returns {view: [view object], views: [sub views to be displayed]}
 */
function view_info_get_views(view, frag_obj) {
	if(!view && frag_obj) {
		view = frag_obj.v ? (get_view_infos()[frag_obj.v] || []) : {};
	}
	// Default to the views in the view info object.
	var views = view.views ||
		// Manually specified views
		(frag_obj && frag_obj.views) ||
		// Display all aggregations.
		Object.keys(agg_infos);
	if(typeof views === "string") {
		views = [views];
	}

	if(views.length && view.views && view.views.length) {
		var identifier_info = _get_viewargs_identifiers();
		if(identifier_info && identifier_info.identifiers) {
			function del_by_val(ar, x) {
				var idx = ar.indexOf(x);
				if(idx != -1) ar.splice(idx, 1);
			}
			// Create a copy.
			views = views.map(function(x) { return x; });
			// The date proceeding filed view can be confusing because it shows proceedings instead of motions.
			del_by_val(views, 'Date_Proceeding_Filed');
			// Firm profiles can be confusing because they aren't necessarily the filer.
			del_by_val(views, 'Firm_Profile');

			if (view.allow_identifier_views !== undefined) {
				var position = typeof view.allow_identifier_views === "number"?
					view.allow_identifier_views: 0;
				function add_if_unique(x) {
					if(views.indexOf(x) == -1) {
						// Insert into position.
						views.splice(position, 0, x);
					}
				}
				add_if_unique('Event_Info_Counts');
				add_if_unique('Event_Histogram');
				add_if_unique('Event_Length_Histogram');
				// add_if_unique('Event_Info');
			}
		}
	}

	return {view : view, views:views};
}

/**
 * Render all of the aggregation data that we have.
 * @param aggs The incoming aggregation data.
 * @param filtered_aggs
 * @param view The view info object, specifies which aggregations to run.
 */
function render_allaggs(aggs, filtered_aggs, view) {
	if(!aggs && !filtered_aggs) {
		return;
	}
	if(!gbl_view_infos) {
		gbl_view_infos = build_view_infos();
	}
	if(!aggs) { aggs = {}; }

	////////
	// Handle the view title.
	var Title = _render_agg_title_html(view);
	var print_pdf = "<a href='#' class='print_pdf'><i class='far fa-file-pdf'></i></a>";
	var embed_code = "<span class='embed_code'><i class='fad fa-code'></i></span>";

	var $charts = $("#charts");

	var embed_tip_html = wrap_html("Embedded Link", "h4") +
	wrap_html("Generate a link to this page, sharable with users without an account.", "p") +
	wrap_html("You can also track page views in your user history.", "p");

	$charts
        .append("<div class='view_title'>" + Title.html + embed_code + print_pdf + "</div>")
        // Allow for special css styling when there's no view title.
        .find(".view_title").toggleClass("no_title", Title.html.length==0).end()
        .find(".embed_code").click(function () {
            show_embed_page_popup($charts);
        }).data('powertip', embed_tip_html).powerTip({
            popupClass : 'small_powertip',
            placement: 'sw',
        }).end()
	    .find(".print_pdf").click(function () {
            window.print();
            return false;
        }).data('powertip', 'Print this report to PDF').powerTip({
            popupClass : 'small_powertip',
            placement: 'nw',
        });

	// Change the title of the page itself.
	if(view && view.title) {
	    var page_title = view.title + Title.extra;
	    if(analytics_title.length) {
	        page_title += " | " + analytics_title;
        }
		$("title").text($(wrap_html(page_title)).text());
	}

	////////
	// Render the aggregations
	var views_to_render = view_info_get_views(view).views;

	var num_rendered = 0;
	views_to_render.forEach(function(view_name, index) {
		// Make sure there's a definition for the view.
		if(!aggs[view_name] && (!filtered_aggs || !filtered_aggs[view_name])) {
			return;
		}
		// Find the aggregation info specific to this agg
		var info = agg_infos[view_name];
		if(!info) {
			console.log("Unknown analytics view: " + view_name);
			return;
		}
		// If filtered, submit an empty dictionary, otherwise null.
		var fagg = filtered_aggs ? filtered_aggs[view_name] || {} : null;
		// Render the aggregation.
		render_agg("#charts", 0, null, view_name, aggs[view_name], aggs[view_name] && aggs[view_name].doc_count,
			info, fagg);
		num_rendered += 1;
	});

	///////
	// Add a class to allow for CSS styling based on the number of aggregations.
    $charts
        .removeClass("no_views_rendered")
        .removeClass("one_view_rendered")
        .removeClass("multiple_views_rendered")
    .addClass(
        num_rendered == 0 ? "no_views_rendered":
        num_rendered == 1 ? "one_view_rendered":
        "multiple_views_rendered");

	////////
	// Show any other items by selector.
	for(var i in (view && view.extra || [])) {
		$(view.extra[i]).show();
	}

	////////
	// Analytics Tabs
	$(".toptabs")
		.find(".selected").removeClass("selected").end()
		.find((view && view.selected_tab) || "").addClass("selected").end();

	////////
	// Save the last render so we can redo it if necessary
	set_last_render(aggs, filtered_aggs, view);
}

/**
 * A list of filters, generated from the query_to_list().filters function.
 * @param filters
 * @returns {string}
 */
function render_filter_list(filters) {
	// Improve the agg title by adding the filters.
	var filter_ar = filters.map(function (f) {
		return f.remove_link ?
			wrap_html(f.name, "a", "filter remove_link", {}, {href:"#"+f.remove_link}):
			wrap_html(f.name, "span", "filter");
	});
	return wrap_html(filter_ar.join(" "), "div", "filter_list");
}

/**
 * The main function that renders an individual agg.
 * There is a default rendering that is not very intelligent, but a
 * custom rendering function can be specified in agg_info.
 *
 * $appendto:	Append the current rending on to another DOM block.
 * cur_depth:	This function is recursive for default renderings. One
 *				can therefore specify which level to render this in. It is
 *				generally used to properly size various charts.
 * parent_agg_name Used to give unique IDs when there are subaggs rendered.
 * agg_name		This agg's name.
 * agg			The actual data.
 * avg_doc_count eh... see below.
 * agg_info		Used to pass all of the aggregations options.
 * filtered_agg A filtered version of this aggregation.
 */
function render_agg($appendto, cur_depth, parent_agg_name, agg_name, agg,
						avg_doc_count, agg_info, filtered_agg) {

	var new_id = ((parent_agg_name ? (parent_agg_name + "_") : "") + agg_name)
			.replace(/[^\w\s\d]/g, "")
			.replace(/\s+/g, "_");

	// Convert the name to something human readable
	var agg_name_title = agg_name;
	if(parent_agg_name) {
		agg_name_title += " for " + wrap_html(parent_agg_name, "span", "parent_agg_name");
	}
	agg_name_title = agg_name_title.replaceAll("_", " ");

	if(agg_info && agg_info.name) {
		// Allow the aggregation to specify the name by string or function.
		agg_name_title = typeof agg_info.name == 'function' ?
			agg_info.name() : agg_info.name;
		// Wrap the name in a tag in case the analytics want to change it later.
        agg_name_title = wrap_html(agg_name_title, "span", "name");
	}

	var filter_name = null;
	// An html list of filters applied to these analytics.
	var filter_list_html = '';
    var q_list = query_to_list();
    var has_remove_link = q_list.filters.filter(function (f) { return f.remove_link; }).length > 0;
	if(filtered_agg || (agg_info.render_filtered_alone && (q_list.title || has_remove_link))) {
		// Add the filter title to the agg title.
        if(q_list.title) {
			var f_cls = "filtered_title" + (q_list.title.is_entity ? " filter_entity": "");
			// Replace ending punctuation.
			agg_name_title = agg_name_title.replace(/([\?!\.])?\s*$/,
                ' for ' + wrap_html(q_list.title.name,"span", f_cls) + "$1");
        }
		// Improve the agg title by adding the filters.
        filter_list_html = render_filter_list(q_list.filters);

		// Create a detailed explanation of the filter. Treat title like a filter.
		if(q_list.title) {
			q_list.filters.unshift(q_list.title.name);
		}
		filter_name = human_list(q_list.filters.map(function (f) {
		    return escape_html(typeof f == "string" ? f : f.name);
        }), "and");
	}

	// Link to A Single View
    // Append icon and text to the ".graph_title"
    if(agg_name && agg_name.length) {
        agg_name_title += render_link_to_view(agg_name);
    }

    // Filter list goes after the link to single view on a new line.
	agg_name_title += filter_list_html;

	// Create the new object
	$("<div id='" + new_id + "' class='" +
		(cur_depth == 0 ? 'chart':'parent_chart') + " " +
		"depth_" + cur_depth + "'></div>").appendTo($appendto);

	// Add the title
	var htag = "h" + (cur_depth+2);
	htag = "<" + htag + " class='graph_title'>" + agg_name_title + "</" + htag + ">";
	// Only add it if there are multiple sub-aggs or we are the leaf agg
	if(cur_depth == 0 || (agg.buckets && agg.buckets.length))
		$("#" + new_id).append(htag);

	// Transform the aggregation according to the agg_info object.
	if(agg_info) {
		// Set some defaults.
		if(!agg_info.map_className) {
			agg_info.map_className = keyToClass;
		}
		if(!agg_info.filing_str) {
			agg_info.filing_str = typeof(filing_str) !== "undefined" &&
				filing_str ? filing_str : "filing";
		}
		if(!agg_info.case_str) {
			agg_info.case_str = typeof(case_str) !== "undefined" &&
				case_str ? case_str : "case";
		}
		if(!agg_info.party_roles) {
			agg_info.party_roles = typeof(party_roles) !== "undefined" &&
				party_roles ? party_roles : ['Plaintiff', 'Defendant'];
		}
		// Transform the aggregation.
		transform_agg(agg, agg_info.filter, agg_info.map, agg_info.map_name,
			agg_info.map_className, agg_info.sort_series);

		if(filtered_agg) {
			transform_agg(filtered_agg, agg_info.filter, agg_info.map,
				agg_info.map_name, agg_info.map_className, agg_info.sort_series);
		}
	}

	// If there's no filter func, but we're supposed to render alone, then do so.
	if(filtered_agg && agg_info.render_filtered_alone &&
		!agg_info.render_filtered && agg_info.render) {
		agg_info.render_filtered = render_filtered_based_as_basic(agg_info.render);
	}

	// If we have a custom renderer for the filtered data, then use it.
	if(filtered_agg && agg_info.render_filtered) {
		agg_info.render_filtered(new_id, agg_info, agg_name, agg,
			filter_name, filtered_agg);
		return;
	}

	// The default is to show the filtered information rather than cumulative.
	if(filtered_agg) {
		agg = filtered_agg;
		if(!agg.buckets || !agg.buckets.length)
			return;
	}

	// Check if there is a custom function for rendering.
	if(agg_info && agg_info.render) {
		agg_info.render(new_id, agg_info, agg_name, agg);
		return;
	}

	////////////////////
	// This is the default renderer
	if(agg_name.startsWith("Date") && agg.depth == 1 &&
			agg.buckets.length > 1 && agg.buckets.length < 4) {
		var do_stacked = false;
		var subaggs = agg.buckets.map(_get_sub_agg_from_bucket)
		for(var i in subaggs) {
			if(!subaggs[i]) {
				do_stacked = false;
				break;
			} else if(subaggs[i].buckets.length > 1) {
				do_stacked = true;
			}
		}
		// Display stacked bar chart.
		console.log("  Prining stacked bar");
		if(do_stacked) {
			var xAxis = render_stacked_date_histogram(
							cur_depth, agg_name, agg, new_id);
			// Don't render the subaggs when doing a stacked chart.
			return;
		}
	}

	if (agg.depth > 0) {
		// We make a recursive call to build this out.
		var this_avg_doc_count = agg.doc_count / agg.buckets.length;
		for(var i in agg.buckets) {
			var bucket = agg.buckets[i];
			var subaggs = [];
			var key = null;
			var doc_count = null;
			for(var k in agg.buckets[i]) {
				if(k == 'key') {
					key = agg.buckets[i][k];
				} else if (k == 'doc_count') {
					doc_count = bucket[k];
				} else if (k == 'name' || k == 'className') {
					;
				} else {
					subaggs.push(k);
				}
			}

			for(k in subaggs) {
				var full_sub_name = key;
				if(parent_agg_name)
					full_sub_name += " for " + wrap_html(parent_agg_name, "span", "parent_agg_name");
				full_sub_name = full_sub_name.toString().replaceAll("_", " ");

				render_agg("#" + new_id, cur_depth+1, full_sub_name,
							subaggs[k], bucket[subaggs[k]], this_avg_doc_count);
			}
		}
		return;
	}

	console.log("Rendering " + agg_name_title);
	// Render the chart
	if(agg_name.startsWith("Date")) {
		// Date Histogram
		render_date_histogram(cur_depth, agg_name, agg, new_id);
	} else if(are_agg_keys_nums(agg)) {
		render_histogram(cur_depth, agg_name, [agg], new_id);
	} else {
		setup_pie_chart(cur_depth, agg_name, agg, "#" + new_id, avg_doc_count);
	}
}

/**
 * General function to change aggregation data.
 * @param agg The aggregation you want to change.
 * @param filter Filter out buckets.
 * @param map Map buckets.
 * @param map_name Set the bucket's "name"
 * @param map_className Set the bucket's className
 * @param sort
 */
function transform_agg(agg, filter, map, map_name, map_className, sort) {
	if(!agg || !agg.buckets || !agg.buckets.length)
		return;

	// Filter out all buckets that are not supposed to be here
	if(filter) {
		agg.buckets = agg.buckets.filter(filter);

		// Check out if we have anything left to render
		if(!agg.buckets || !agg.buckets.length)
			return;
	}

	// Map the buckets, if requested.
	if(map) {
		agg.buckets = agg.buckets.map(map);
		// The depth of the buckets may have changed.
		// TODO: Recursively fix all of the sub agg's depths.
		var depths = agg.buckets.map(function(it) {
			var subagg = _get_sub_agg_from_bucket(it);
			return subagg ? subagg.depth : 0;
		});
		agg.depth = Math.max.apply(null, depths) + 1;
	}

	// Add a name to the aggregation if one is defined.
	if(map_name) {
		for(var a in agg.buckets) {
			agg.buckets[a].name = map_name(agg.buckets[a]);
		}
	}
	// Add a class name to the aggregation
	if(map_className) {
		for(var a in agg.buckets) {
			agg.buckets[a].className = map_className(agg.buckets[a]);
		}
	}
	// Sort the series if requested
	if(sort) {
		agg.buckets.sort(sort);
	}
}

////////////////////////////
// The Sidebar
function setup_sidebar() {
	var $sidebar = $(".sidebar");
	if(!$sidebar.length){
		return;
	}
	// Initial setup of sidebar, should not be called more than once.
	setup_common_sidebar($sidebar[0], $("#footer")[0]);

	// Toggling the sidebar's visibility.
	$(".sidebartoggle a").click(function () {
		$(".sidebar").toggleClass("visible");
		return false;
	});
}

function render_sidebar_date_histogram(agg) {
	if(!agg) {
		$("#sidebar_date_histogram").empty();
		return;
	}
	function get_hash(val_min, val_max) {
		var frag_obj = url_params_to_object(get_url_hash());
		if(!val_min && !val_max) {
			delete frag_obj.date_filed_start;
			delete frag_obj.date_filed_end;
		} else {
			frag_obj.date_filed_start = (val_min / 1000).toFixed(0);
			frag_obj.date_filed_end = (val_max / 1000).toFixed(0);
		}
		return "#" + param_query(frag_obj);
	}
	function onClick(d) {
		return get_hash(new Date(d.x), new Date(d.x + 31*24*3600*1000));
	}
	function on_slider_changed(val_min, val_max) {
		var new_hash = get_hash(val_min, val_max);
		if(window.location.hash != new_hash) {
			window.location.hash = new_hash;
		}
		return false;
	}
	$("#sidebar_date_histogram")
		.html("<div id='sidebar_date_graph' class='datehistogram graph'></div>");
	var obj_id = 'sidebar_date_graph';

	// Use the standard date histogram
	var xAxis = render_date_histogram(0, "Date Histogram", agg, obj_id, onClick,
		"month");

	// Add the slider underneath the graph.
	var frag_obj = url_params_to_object(get_url_hash());
	add_jqueryui_slider_to_graph(obj_id, xAxis,
		frag_obj.date_filed_start ? frag_obj.date_filed_start * 1000 : null,
		frag_obj.date_filed_end ? frag_obj.date_filed_end * 1000 : null,
		on_slider_changed);

	// Round the start and end times to nearest 100 secs to match current time.
	var r_start = frag_obj.date_filed_start ?
		roundNumber(frag_obj.date_filed_start / 100)*100 : null;
	var r_end = frag_obj.date_filed_end ?
		roundNumber(frag_obj.date_filed_end / 100)*100 : null;

	var total_time = agg.buckets && agg.buckets.length ?
		agg.buckets[agg.buckets.length - 1].key - agg.buckets[0].key : 0;

	// Insert some more date options after.
	$("#sidebar_date_histogram .datehistogram .clear_date")
		// The clear date filter is only shown if there a custom date is selected.
		.text("Custom Date Filter").addClass("selected").addClass("clearable")
		.after("<a class='ytd' href='#'>Year-To-Date</a>" +
				"<a class='lastyear' href='#'>Last Year</a>" +
				"<a class='trail12' href='#'>Trailing 12 Mos.</a>" +
				(total_time > 5*365*24*3600*1000 ?
					"<a class='trail5years' href='#'>Trailing 5 Years</a>" : "") +
				"" // "<a class='trail6' href='#'>Trailing 6 Mos.</a>"
				)
		.parent().find("> a").each(function () {
			var $this = $(this);
			if($this.hasClass('clear_date')) {
				// Clearing the date filters.
				$this.click(function () {
					on_slider_changed();
					return false;
				});
				return;
			}
			// Start off with max_val to now, and min_val to one year ago.
			var max_val = new Date();
			var min_val = new Date();
			min_val.setUTCFullYear(min_val.getUTCFullYear() - 1);
			if($this.hasClass('ytd')) {
				// max_val is now, min_val is Jan 1
				min_val.setUTCFullYear(max_val.getUTCFullYear());
				min_val.setUTCMonth(0);
				min_val.setUTCDate(1);
			} else if($this.hasClass('lastyear')) {
				// max_val is Jan 1, min_val is Jan 1 of the previous year.
				max_val.setUTCMonth(0);
				max_val.setUTCDate(1);
				max_val.setUTCHours(0);
				max_val.setUTCMinutes(0);
				max_val.setUTCSeconds(0);
				max_val.setUTCMilliseconds(0);
				min_val.setUTCMonth(0);
				min_val.setUTCDate(1);
			} else if($this.hasClass('trail12')) {
				; // Defaults will do.
			} else if($this.hasClass('trail5years')) {
				// Subtract 4 more years.
				min_val.setUTCFullYear(min_val.getUTCFullYear() - 4);
			} else if($this.hasClass('trail6')) {
				min_val.setUTCMonth(min_val.getUTCMonth() + 6)
			} else {
				console.log("unknown link");
			}
			if(min_val) {
				min_val.setUTCHours(0);
				min_val.setUTCMinutes(0);
				min_val.setUTCSeconds(0);
				min_val.setUTCMilliseconds(0);
			}
			if((min_val && roundNumber(min_val.getTime()/100000)*100) == r_start &&
				(max_val && roundNumber(max_val.getTime()/100000)*100) == r_end) {
				$this.addClass("selected").addClass("clearable");
				// Because this one is clearable, we can remove the clear date link.
				$this.parent().find(".clear_date").hide();
			}
			$this.click(function () {
				$this.hasClass("clearable") ?
					on_slider_changed():
					on_slider_changed(min_val, max_val);
				return false;
			});
	});
}

/**
 * Sub-analytics can customize the filters they display on the side-bar by
 * inserting structures into the "typical_analytics_filters" structure.
 *
 * Each filter is in the form: {
 *	title: 	  The title of the filter.
 *	f:		  The filter name used by the server. For generic query filters,
 * 			  use q_<name>.
 *	choices:[ A list of "choices" to choose from in the filter.
 *	{
 *		v: 		The filter value
 *		fname:	The filter value to be displayed in search results. This may
 *				be omitted if using a standard filter (i.e., not a q_ filter).
 *		key:	The value displayed in the side-bar. If not specified, then
 *				fname will be used.
 *  }, ...]
 * }
 **/
function render_sidebar_other_filters(other_filters, $content_div) {
	if(!other_filters || !other_filters.length) {
		$(".other_filters").hide();
		return;
	}
	var url_hash = get_url_hash();
	var $content = $content_div || $(".other_filters").show().empty();
	var num_other_filters = other_filters.length;
	other_filters.forEach(function (of) {
		if(!of || typeof of != "object") {
			console.warn("Bad other filter: " + of);
			return;
		}
		if(of.title) {
			$content.append('<h4>' + of.title + '</h4>');
		}

		// Go through the "choices" specified in this view
		var choice_info = (of.choices || []).map(function (choice) {
			// Each choice can viewargs, which narrow the specific view.
			var cur_args_obj, choice_obj;
			if(of.viewargs) {
				cur_args_obj = get_viewargs_obj();
				choice_obj = viewarg_to_obj(of.viewargs + "-" + (choice.v||''));
			} else if(of.f) {
				cur_args_obj = get_filter_obj(url_hash);
				choice_obj = viewarg_to_obj(of.f + "-" + (choice.v||''));
			} else {
				console.log("Did not specify a choice");
				return;
			}
			var selected = cur_args_obj[choice_obj.k] == choice_obj.v;

			// Now setup the new hash
			var cur = deparam_url(url_hash);
			if(!selected) {
				if(choice_obj.v && choice_obj.v.length) {
					cur_args_obj[choice_obj.k] = choice_obj.v;
				} else if (cur_args_obj[choice_obj.k]) {
					delete cur_args_obj[choice_obj.k];
				}
				if(of.viewargs) {
					cur.viewargs = args_obj_to_args_ar(cur_args_obj);
				} else if(of.f) {
					cur.f = args_obj_to_args_ar(cur_args_obj);
				}
				// The choice can provide a name for the filter
				if(choice.fname && (of.viewargs || of.f)) {
					cur['fname_' + (of.viewargs || of.f)] = choice.fname;
				}
			}
			return {
				choice : choice,
				selected : selected,
				link : '#' + param_query(cur),
				// If a key is not specified, fall back on the fname
				key : choice.key || choice.fname
			}
		});

		// Remove the empties.
		choice_info = choice_info.filter(function (f) { return f; });

        var MAX_CHOICES = 7;
		var MAX_CHOICES_FEW_FILTERS = 12;

		// We have a few ways of rendering.
		if(of.range) {
            // Range Sliders
            var start_perc = of.start_perc ? of.start_perc() : [0, 100];
            // A continuous range, not a set of discrete choices, use a slider.
            var $slide = $("<div class='slide_filter'><div class='slider'></div>" +
                "<div class='text'><span class='min'>" +
                (of.get_val(start_perc[0]) || '-') +
                "</span> to <span class='max'>" + (of.get_val(start_perc[1]) || '-') +
                "</span> " + (of.unit || "") + " </div>");
            $content.append($slide);

            function on_slide($slider) {
                // Set the text under the slider
                var vals = $slider.slider("values").map(of.get_val);
                $slider.parent()
                    .find(".min").text(vals[0]).end()
                    .find(".max").text(vals[1]);
            }

            // The slider goes from 0% to 100%, of.get_val converts percent to value.
            $slide.find(".slider").slider({
                range: true,
                min: 0,
                max: 100,
                values: [start_perc[0], start_perc[1]],
                slide: function () {
                    on_slide($(this));
                },
                change: function () {
                    on_slide($(this));
                    // Get the slider's values and issue the callback.
                    var vals = $(this).slider("values").map(of.get_val);
                    // Do the filtering.
                    of.filter(vals[0], vals[1]);
                }
            });
        } else if (of.text && (!of.get_query || ! of.get_value)) {
            console.error("Must set get_query and get_value");
		} else if(of.text) {
			var placeholder = of.text !== true ?
				' placeholder="' + of.text + '"':'';
			var cur_args_obj = get_filter_obj(url_hash);
			var $input = $("<input type='text' " + placeholder + ">").change(function () {
				var val = $(this).val();
				var cur = deparam_url(url_hash);
				if(val) {
					cur_args_obj[of.f] = of.get_query(val);
					// Give this filter a proper title.
					cur['fname_' + of.f] = of.title + ": " + val;
				} else {
					if(cur_args_obj[of.f]) {
						delete cur_args_obj[of.f];
					}
					if(cur['fname_' + of.f]) {
						delete cur['fname_' + of.f];
					}
				}
				cur.f = args_obj_to_args_ar(cur_args_obj);
				document.location.hash = '#' + param_query(cur);
			}).val(of.get_value(cur_args_obj[of.f] || ''));
			$content.append($input);
		} else if(choice_info.length <= MAX_CHOICES ||
				(num_other_filters <= 4 && choice_info.length <= MAX_CHOICES_FEW_FILTERS)) {
			// Short List
			// Not too many choices, just show them.
			$content.append("<ul class='choices'>" + choice_info.map(function (ci) {
				return "<li><a class='" + (ci.selected ? "selected": "") +
					"' href='" + ci.link + "'>" + ci.key + "</a></li>";
			}).join(" ") + "</ul>");
		} else {
			// Long List
			var default_value = null;
			var choice_options = choice_info.map(function (ci) {
				if(ci.choice.isdefault) {
					// Don't show the default choice.
					default_value = ci.link;
					return "";
				}
				return "<option value='" + ci.link + "' " +
					(ci.selected ? "selected='selected'": "") + ">" + ci.key +
						"</option>";
			}).join(" ");
			$content
				.append("<select multiple='multiple' class='choices tokens'" +
					(default_value ? "data-default='" + default_value + "'": '') + ">" +
					choice_options+ "</select>")
				.find('select.tokens').tokenize({
					displayDropdownOnFocus: true,
					maxElements: 1,
					newElements: false,
					nbDropdownElements: 50,
					onAddToken : function (value, text, e) {
						document.location.hash = value;
					},
					onRemoveToken : function (value, e) {
						// Go to the default page.
						document.location.hash = e.select.data("default");
					}
			});
		}
	});
}

var sidebar_generation = 0;
function render_sidebar_jump_to() {
	var $jump_to = $(".sidebar .jump_to").hide();
	var $charts = $("#charts > .chart");
	var $offsets = $charts.find("> .graph_title, .section");
	if(!$jump_to.length || $offsets.length < 2) {
		// Don't display if there's no jump to or only one section.
		return;
	}

	// We will be inserting a number of list items.
	var $ul = $jump_to.show().filter(".content").find("ul");
	if(!$ul.length) {
		$ul = $jump_to.show().filter(".content").append("<ul></ul>").find("ul");
	}
	// Start fresh
	$ul.empty();

	// If the sidebar gets redrawn, we start a new generation.
	sidebar_generation += 1;
	var this_sidebar_generation = sidebar_generation;

	// Go through each of the graph titles.
	var offsets = $offsets.map(function () {
		var $title = $(this);
		var offset;
		// If the section isn't visible, but its parent is, then use the parent.
		if($title.is(":visible")) {
		 offset = $(this).offset().top;
		} else if(!$title.is(":visible") && $title.parent().is(":visible")) {
			offset = $title.parent().offset().top;
			if(!offset) {
				return null;
			}
		} else {
			console.log("Offset section hidden");
			offset = 0;
		}
		// Get the text of the title, but removing any list items within it.
		var title_text = $title.clone()
			// Remove everything matching this list:
			.find(".filter_list, .export, .options, .explain, .link-view, " +
				".suggest_search, .identifier_tip, .filtered_title, " +
				".view_all_stats, .motion_chooser_btn")
			.remove().end().text();
		// Remove any trailing and "for" text.
		title_text = title_text.replace(/\s+for\s+$/ig, "");

		// Create the list item, and give it a click handler.
		var $li = $("<li><a href=''>" + title_text + "</a></li>")
			.toggleClass("subsection", $title.hasClass("section"))
			.click(function _on_scroll_click() {
				// Scroll to the correct offset, taking into account the menu.
				$('html,body').animate({
					scrollTop: offset - $("#search_login_menu").height()
				},'slow');
		 		return false;
			});
		// Add the item to the list.
		$ul.append($li);
		// Return the current location of this item.
		return { offset : offset, text : title_text, $li: $li};
	}).filter(function (x) { return x != null; });

	// Make sure the offsets are sorted by offset
	sortByKey(offsets, function (o) { return o.offset; });

	// The function that changes the side-bar jump section.
	function set_selection() {
		if (this_sidebar_generation != sidebar_generation) {
			// This should be un-bound, but for now just ignore.
			return;
		}
		// We switch offsets when the section passes the jump-to selector.
		var selector_offset = $jump_to.find("ul").offset().top;
		// Find the first offset that's above the selector.
		for(var i=0; i < offsets.length; i++) {
			if(offsets[i].offset > selector_offset) {
				// i is the first one below it, so we need to back up one.
				var item = offsets[i ? i - 1 : 0];
				$jump_to.find("li.selected").removeClass("selected");
				item.$li.addClass("selected");
				return;
			}
		}
	}
	// Select the first item.
	$($ul.find("li")[0]).addClass("selected");
	$(window).scroll(debouncer(set_selection, 50));
	set_selection();
}

////////////////////////////
// Ajax data loading
function bind_window_events() {
	// Bind the window size change handler to re-rendering.
	$(window).bind('resize', debouncer(function () {
		if(!_last_render) {
			return;
		}
		// Save the scroll height so we can set it after recreating charts.
		var scrollX = window.scrollX;
		var scrollY = window.scrollY;
		clear_and_rerender_all();
		window.scrollTo(scrollX, scrollY);
	}, 300));

	add_print_listener(function () {
	    console.log("Printing " + isMediaPrint().toString());
	    clear_and_rerender_all();
    });

	// Build the global views_infos variable
	gbl_view_infos = build_view_infos();
	window.addEventListener('hashchange', function( event ) {
		handle_hashchange(url_to_fragment(event.newURL));
	});
}

$(document).ready(function _stats_views_loader() {
	bind_window_events();
	setup_sidebar();
});


/**
 * If there is an error retrieving results for whatever reason, show an error message.
 * @param message
 * @param error_type
 */
function handle_error(message, error_type) {
    if(stats_views_globals.user_logged_in && error_type !== 'billing') {
        $(".message.error").show()
            .find("h1").hide().end()
            .find("p.main").text(message);
    } else {
        // If the user isn't logged in, present them with the login pane.
        var $loginPane = $("#LoginOverlay .createlogin").clone()
            .find(".close_overlay").hide().end();
        setup_signup_dialogs($(".message.error").show()
            .find("h1").text(message).end()
            .find("p.main").empty().append($loginPane).end());
    }
}

var hash_change_generation = 0;
function handle_hashchange(fragment, numtries) {
	if(CURRENTLY_UPGRADING) {
		$("body").find(".message").hide().end()
			.find(".message.newversion").show();
		return;
	}

	var urls_params = url_params_to_object();
	if(urls_params.q !== undefined) {
		// Do not use the hash string mechanism when we have a query.
		return;
	}
	// Clear the chart area
	$("#charts").empty();
	// Scroll to the top
	window.scrollTo(0, 0);
	// Setup the filtering
	$(".getstats").click(function () {
		// This is a more customized query.
		// First get the values to submit.
		var values = {};
		// A human readable explanation of the key (optional)
		var key_qname = {};
		$(this).parent().find("input[type=text], select").each(function (i, el) {
			var $sel = $(el);
			var v = $sel.val();
			if(!v || !v.length)
				return;
			var n = $sel.attr('name');
			if(!values[n]) {
				values[n] = [];
			}
			values[n].push(v);
			key_qname[n] = $sel.data('qname');
		});

		var query = []; // Build the Query
		var qname = []; // Build the Query in English
		for(var k in values) {
			// Put quotes around each value if necessary
			var paren = values[k].map(function(v) {
				return v.search(" ") == -1 ? v : "\"" + v + "\"";
			});
			// Build the Query
			query.push(k + ":(" + paren.join(" OR ") + ")");
			// Build the English translation of the query
			var human_key = key_qname[k] || capitalize(k.replaceAll("_", " "));
			qname.push(human_key + " " + human_list(values[k], "or"));
		}
		if(!query.length) {
			show_error_usermsg("Please select an option.");
			return false;
		}
		query = query.join(" AND ");
		qname = human_list(qname, "and");
		// Now construct the parameter list.
		var params = {
			'q' 	: query,
			'qname' : qname,
		};
		var $parent = get_parent_with_class($(this), "query");
		// Check if there is a custom view specified.
		if($parent.attr("data-view"))
			params['v'] = $parent.attr("data-view");

		// Now go
		jQuery.bbq.pushState(params);

		return false;
	});
	var $body = $("body");
	if(!fragment || !fragment.length) {
		// No hash, show a static starter page.
		$body.addClass("nosidebar");
        $(".toptabs")
				.find(".selected").removeClass("selected").end()
				.find("li.overview").addClass("selected").end();
		// Show the start message
		var $queries = $(".message.start").show()
		.find(".queries")
			.find(".query").each(function (i) {
				// If the question has a front and back, append to the front.
				var appendTo = $(this).find(".front").length ?
								$(this).find(".front") : this;
				var found_k = null;
				for(var k in gbl_view_infos) {
                    if (gbl_view_infos[k].question == (i + 1)) {
                        found_k = k;
                        break
                    }
                }
                if(!found_k) {
				    $(this).remove();
				    return;
                }
                // Add the query title
                var view = gbl_view_infos[found_k];
                if(view.title && !$(this).find("h2").length) {
                    $("<h2>" + view.title + "</h2>").prependTo(appendTo);
                }
                // Add the query description.
                if(view.description && !$(appendTo).find("p").length) {
                    $(view.description.map(function (d) {
                        return "<p>" + d + "</p>";
                    }).join("")).appendTo(appendTo);
                }
                // Set the links.
                if(this.tagName == "A" && !$(this).attr('href')) {
                    $(this).attr('href', "#q=&v=" + k)
                }
				// Add the question label
				if(!$(this).find("h3").length) {
					$("<h3>" + view_info_subtitle(view) + "</h3>")
                        .prependTo(this);
				}
			})
			.filter("div").click(function () {
				var $obj = $(this);
				$obj
					.find(".front").hide().end()
					.find(".back").show(100);
				update_label_widths($obj);
			}).end().end();
		// If there are queries and we have masonry, use it to organize the questions nicely.
		if($queries.length) {
			masonry_load(function _loaded(Masonry) {
				// Use masonry to allow queries to shift as blocks.
				new Masonry($queries[0], {
					itemSelector: '.query',
					gutter: 20,
					position: 'relative',
					columnWidth: $queries.find(".query:not(.big):not(.medium)")[0]
					//isFitWidth: true
				});
			});
		}
		return;
	}
	// Parse the parameters.
	var frag_obj = $.deparam(fragment);
	$body.removeClass("nosidebar")
		.find(".message.start").hide().end()
		.find(".message.loading")
			.removeClass("gettingfiltered")
			.show().end();
	// When we embed, hide the sidebar.
	if(frag_obj.embed !== undefined) {
		$body
            // Remove the sidebar
            .addClass("nosidebar")
			// Remove the top tabs and the footer when embedding.
			.addClass("embed")
			// Remove any minimum height requirements on the body.
			.find("#bd").css("min-height", "auto");
		// Turn off our salesforce chat when in embedded mode.
		enable_support_chat = false;
	}

	if(!numtries) {
		// Start cycling through the help after a few seconds.
		setTimeout(function () { cycle_help(); }, 7000);
		start_progress_bar(".message.loading .progressbar",
				50, "statsbar");
	}

	var vinfo = view_info_get_views(null, frag_obj);
	// Determine if any of the filtered aggs need an unfiltered one.
	var filter_needs_unfilter = vinfo.views.some(function (v) {
		return agg_infos[v] && !agg_infos[v].render_filtered_alone;
	});
	// When analytics are "filtered" (i.e., a date filter or a "&f=..." filter,
    // we display analytics on both the original, and the filtered value.
	var has_filter = (frag_obj.f && frag_obj.f.length) ||
		frag_obj.date_filed_start || frag_obj.date_filed_end;
    // The analytics query. This gets applied regardless of other filters.
	var query = frag_obj.q || "";
	var viewargs_no_filter = [];
	if(!has_filter) {
        if(Array.isArray(frag_obj.viewargs)) {
            viewargs_no_filter = frag_obj.viewargs;
        } else if(frag_obj.viewargs) {
            viewargs_no_filter = [frag_obj.viewargs];
        }
        // Add any view specified default viewargs.
	    if(vinfo.view && vinfo.view.default_viewargs){
	        var frag_viewargs_obj = _hash_to_obj(viewargs_no_filter);
	        // Add defaults, but do not overwrite existing.
	        vinfo.view.default_viewargs.forEach(function (varg) {
	           var varg_obj = viewarg_to_obj(varg);
	           if(!frag_viewargs_obj[varg_obj.k]) {
	               viewargs_no_filter.push(varg);
               }
            });
        }

    }
	var has_unfiltered = !has_filter || !vinfo.view || filter_needs_unfilter;

	// The requests
	var requests = []; // What we send to the server
	var request_info = []; // Used to keep track of what we sent.

	// Get unfiltered results
	if(has_unfiltered) {
		// We will send each view request separately.
		vinfo.views.forEach(function (v, i) {
			// Filtered views may not need to request the unfiltered version.
			if (has_filter) {
				// Get filtered results.
				requests.push({views : [v], filter: frag_obj});
				request_info.push({filtered:true, viewi : i});

				// Find the agg info structure for this view.
				var a = agg_infos[v];
				if(a && a.render_filtered_alone) {
					// No need to get the unfiltered view here.
					return;
				}
			}
			// We still add the query, even when unfiltered.
			requests.push({ views : [v], viewargs:viewargs_no_filter, q : query });
			request_info.push({filtered:false, viewi : i});
		});
	} else if (has_filter) {
		vinfo.views.forEach(function (v, i) {
			// Get filtered results.
			requests.push({views : [v], filter: frag_obj});
			request_info.push({filtered:true, viewi : i});
		});
	}

    var render_analytics = stats_views_globals.render_analytics;

    // Treat the date histogram differently.
	var has_date_hist = render_analytics && vinfo.view && !vinfo.view.omit_date_histogram;
	if(has_date_hist) {
		// Remove the date filters for the histogram.
        if (has_filter) {
            var frag_obj_wo_date = $.deparam(fragment);
            delete frag_obj_wo_date.date_filed_start;
            delete frag_obj_wo_date.date_filed_end;
            requests.push({views: ['Date_Proceeding_Filed'],
                filter: frag_obj_wo_date });
        } else {
            requests.push({views: ['Date_Proceeding_Filed'], q : query});
        }
		request_info.push({filtered:false, date_hist:true});
	}

	// We can generated the list of party types/roles.
	var gen_proles = render_analytics && (!stats_views_globals.party_roles || !stats_views_globals.party_roles.length);
	// No reason to get the top party roles when in embedded mode.
	if(gen_proles && frag_obj.embed !== undefined) {
	    gen_proles = false;
    }
	if(gen_proles) {
	    var de_frag = $.deparam(fragment);
	    if(de_frag.views) {
	        delete de_frag.views;
        }
	    if(de_frag.q) {
	        delete de_frag.q;
        }
		requests.push({views : ['Top_Roles'], filter: de_frag, q : query});
		request_info.push({roles:true});
    }

	function merge_aggs(orig, newresp) {
		if(!orig || !orig.aggs) {
			return newresp;
		}
		for(var a in newresp.aggs) {
			if(orig.aggs[a]) {
				console.log("Overwriting agg " + a);
			}
			orig.aggs[a] = newresp.aggs[a];
		}
		return orig;
	}

	var need_parser_info = false;
	var viewargs = get_viewargs_obj();
	var identifier_info = _get_viewargs_identifiers();
	function do_partial_render(i, request_info, requests) {
		if(requests.length <= 1){
			// No point partial rendering only 1 view. Wait for full render.
			return;
		}
		var info = request_info[i];
		if(info.viewi !== 0 || !vinfo.views.length) {
			// Only render when the first view is completed.
			return;
		}
		// Only display it when this view is entirely done.
		if(!request_info.some(function(r) { return !r.done && r.viewi == 0;}) ) {
			var view_copy = $.extend({}, vinfo.view);
			// Only render the first view.
			view_copy.views = [vinfo.views[0]];
			render_allaggs(result ? result.aggs : null,
				filtered_result ? filtered_result.aggs : null, view_copy);
		}
	}

	// Use this global to make sure the responses we receive are still current.
	hash_change_generation++;
	var cur_hash_change_generation = hash_change_generation;

	var result = null, filtered_result = null;
	$(".message.error").hide();
	get_json_results({
		requests : requests,
		on_finished_request : function (i, resp, num_finished) {
		    // Called when each AJAX call completes.
			if(cur_hash_change_generation != hash_change_generation) {
				// This request is stale, ignore it.
				return;
			}
			if(resp.error) {
			    handle_error(resp.error, resp.error_type);
				return
            }
			if(request_info[i].date_hist) {
				// Render the date histogram immediately.
				render_sidebar_date_histogram(resp.aggs &&
					resp.aggs.Date_Proceeding_Filed);
				// Render the other_filters with the histogram complete.
				render_sidebar_other_filters(vinfo.view.other_filters);
			} else if(request_info[i].roles) {
			    // Set the global variable for party roles.
                stats_views_globals.party_roles = resp.aggs && resp.aggs.Top_Roles.buckets ?
                    resp.aggs.Top_Roles.buckets.map(function (b) {
                        return b.key;
                    }) : [];
				// Just got party role information. Update the global party type info.
			    add_party_type_filters(stats_views_globals.party_roles, typical_analytics_filters);
			    // This will cause us to rebuild the filters.
			    gbl_view_infos = null;
			} else if(request_info[i].filtered) {
				filtered_result = merge_aggs(filtered_result, resp);
			} else {
				result = merge_aggs(result, resp);
			}
			// Display the first view when once we get it to reduce apparent latency.
			request_info[i].done = true;
			// Render the partial results.
			do_partial_render(i, request_info, requests);
			// We need to get the filtered results. Restart the progress bar
			// so the user knows they're getting results pretty soon.
			start_progress_bar(".message.loading .progressbar",
				50, "statsbar");
			set_progress_bar_text("Generating " + (num_finished+1) +
				" of " + requests.length + " Reports");
			$(".message.loading").addClass("gettingfiltered")
		},

		on_success : function on_render(results) {
		    // Called when ALL Ajax calls complete.
			if(cur_hash_change_generation != hash_change_generation) {
				// This request is stale, ignore it.
				return;
			}
			if(identifier_info.identifiers &&
                identifier_info.identifiers.length &&
                !identifier_info.identifier_list) {
                console.warn("Identifier list not yet setup.")
            }

			$("#charts").empty();
			stop_progress_bar("statsbar");
			$(".message.loading")
				.hide()
				.removeClass("gettingfiltered");
			render_allaggs(result ? result.aggs : null,
				filtered_result ? filtered_result.aggs : null,
				vinfo.view);
			if(gbl_view_infos == null) {
                console.log("view infos not defined (2), using all defaults.");
                gbl_view_infos = build_view_infos();
            }
			// Rendering all aggs can update the gbl_view_infos. Pull it again.
            var cur_view = frag_obj.v ? (gbl_view_infos[frag_obj.v] || []) : {};
			// Render the jump to field after loading everything.
			render_sidebar_jump_to();
			// Update all of the other filters that we've completed.
			render_sidebar_other_filters(cur_view.other_filters);
		},

		on_fail :  function () {
			if(cur_hash_change_generation != hash_change_generation) {
				// This request is stale, ignore it.
				return;
			}
			// We often fail the first time due to timeouts, try again.
			numtries = numtries || 0;
			if(numtries < 7){
				handle_hashchange(fragment, numtries+1);
			} else {
				// This is a real error.
				stop_progress_bar("statsbar");
				$(".message.loading").hide();
				$(".message.error").show();
			}
		}
	});
}

/////////
// Ajax loading of analytics suggestions
/**
 * For the best styling, put the suggest search bar within the title.
 */
function suggest_bar_html(placeholder) {
	return "<div class='suggest_search'><input placeholder='" + placeholder +
			"' type='text' ><div class='dropdown'>" +
			"<div class='suggestions'></div></div></div>";
}
function suggest_bar_setup($obj, entity) {
	function get_suggest_div($input) {
		return get_parent_with_class($input, "suggest_search").find(".dropdown");
	}
	var $input = $obj.find(".suggest_search input[type=text]")
		.keydown(debouncer(get_suggest_handler(
			entity, null, get_suggest_div, true), 200));

	// Make the input a bit nicer by expanding when in focus.
	var $parent = $input.parent().parent();
	$input.focus(function () {
		// Calculate how much room we have to expand.
		var new_width = $parent.find(".filter_list").length ?
			$parent.outerWidth() - $parent.find(".filter_list > div").width()
				- 30 : $parent.outerWidth() - 300;
		if(new_width > 600) {
			new_width = 600;
		}
		// Do the expansion if it'll grow.
		if ($input.width() < new_width) {
			$input.animate({ width : new_width });
		}
	})
	// Undo the expansion.
	.focusout(function () {
		var $this = $(this);
		// Delay shrinking just in case the user clicked on the dropdown.
		setTimeout(function() {
			$this.width("auto");
		}, 250);
	});
}

function cycle_help() {
	var $didknow = $(".didknow");
	// Don't cycle through the help if we're not loading.
	if(!$(".message.loading").is(":visible")) {
		$didknow.hide();
		return;
	}
	var cur_active = null;
	$didknow.each(function (d, el) {
	// Go through all of them to determine which index is the visible one.
		if($(el).is(":visible")) {
			cur_active = d;
			return false;
		}
	});
	// Hide all of them
	$didknow.hide();
	// Get the index of the one that we want to show.
	cur_active = cur_active==null ? 0 : (cur_active + 1) % $didknow.length;
	// activate the new one.
	$($didknow[cur_active]).fadeIn(1000);
	// Setup the next cycle in a few seconds.
	setTimeout(function () { cycle_help(); }, 25000);
}

export {
	build_default_aggregations,
	build_default_view_infos,
	build_views_from_events,

	// Global
	typical_analytics_filters,
	get_filter_library_dict,

	// These functions are exported, but may be overriden.
	render_toptabs,
	handle_error,

	suggest_bar_setup,
	suggest_bar_html
}